var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.ts
import { FontAwesomeIcon as FontAwesomeIcon7 } from "@fortawesome/react-fontawesome";

// src/fontawesome.js
import fontawesome from "@fortawesome/fontawesome";
import faBars from "@fortawesome/fontawesome-free-solid/faBars";
import faDownload from "@fortawesome/fontawesome-free-solid/faDownload";
import faPlus from "@fortawesome/fontawesome-free-solid/faPlus";
import faMinus from "@fortawesome/fontawesome-free-solid/faMinus";
import faTimes from "@fortawesome/fontawesome-free-solid/faTimes";
import faChevronUp from "@fortawesome/fontawesome-free-solid/faChevronUp";
import faChevronDown from "@fortawesome/fontawesome-free-solid/faChevronDown";
import faChevronLeft from "@fortawesome/fontawesome-free-solid/faChevronLeft";
import faChevronRight from "@fortawesome/fontawesome-free-solid/faChevronRight";
import faTrashAlt from "@fortawesome/fontawesome-free-solid/faTrashAlt";
import faExclamationTriangle from "@fortawesome/fontawesome-free-solid/faExclamationTriangle";
import faAngleDown from "@fortawesome/fontawesome-free-solid/faAngleDown";
import faAngleLeft from "@fortawesome/fontawesome-free-solid/faAngleLeft";
import faAngleRight from "@fortawesome/fontawesome-free-solid/faAngleRight";
import faFile from "@fortawesome/fontawesome-free-solid/faFile";
import faTag from "@fortawesome/fontawesome-free-solid/faTag";
import faInfoCircle from "@fortawesome/fontawesome-free-solid/faInfoCircle";
import faArrowLeft from "@fortawesome/fontawesome-free-solid/faArrowLeft";
import faArrowRight from "@fortawesome/fontawesome-free-solid/faArrowRight";
import faHistory from "@fortawesome/fontawesome-free-solid/faHistory";
import faUndoAlt from "@fortawesome/fontawesome-free-solid/faUndoAlt";
import faRedoAlt from "@fortawesome/fontawesome-free-solid/faRedoAlt";
import faEdit from "@fortawesome/fontawesome-free-solid/faEdit";
import faFilePdf from "@fortawesome/fontawesome-free-solid/faFilePdf";
import faExclamationCircle from "@fortawesome/fontawesome-free-solid/faExclamationCircle";
import faTimesCircle from "@fortawesome/fontawesome-free-solid/faTimesCircle";
import faCheckCircle from "@fortawesome/fontawesome-free-solid/faCheckCircle";
import faCircle from "@fortawesome/fontawesome-free-solid/faCircle";
import faCheck from "@fortawesome/fontawesome-free-solid/faCheck";
import faQuestion from "@fortawesome/fontawesome-free-solid/faQuestion";
import faQuestionCircle from "@fortawesome/fontawesome-free-solid/faQuestionCircle";
fontawesome.library.add({
  faBars,
  faDownload,
  faFile,
  faFilePdf,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faTrashAlt,
  faExclamationTriangle,
  faExclamationCircle,
  faCircle,
  faCheck,
  faTimesCircle,
  faCheckCircle,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faTag,
  faTimes,
  faPlus,
  faMinus,
  faInfoCircle,
  faArrowLeft,
  faArrowRight,
  faHistory,
  faUndoAlt,
  faRedoAlt,
  faEdit,
  faQuestion,
  faQuestionCircle
});

// src/components/test.component.tsx
import { Box } from "@leagueplatform/genesis-commons";
import React from "react";
var TestComponent = ({
  content
}) => {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      backgroundColor: "primary.background.default",
      color: "primary.text.default",
      borderRadius: "pill",
      display: "inline-block",
      paddingLeft: "half",
      paddingRight: "half",
      paddingTop: "quarter",
      paddingBottom: "quarter"
    },
    content
  );
};

// src/breakpoints.js
import { css } from "styled-components";
var px = (value, offset) => `${value + offset}px`;
var min = (value, offset = 0) => `(min-width: ${px(value, offset)})`;
var max = (value, offset = 0) => `(max-width: ${px(value, offset)})`;
var units = {
  phone: 480,
  tablet: 768,
  lap: 1024,
  desktop: 1280
};
var breakpoints = {
  phone: max(units.phone),
  belowTablet: max(units.tablet, -1),
  tabletAndBelow: max(units.tablet),
  tablet: `${min(units.tablet)} and ${max(units.lap, -1)}`,
  tabletAndAbove: min(units.tablet),
  belowLap: max(units.lap, -1),
  lap: `${min(units.lap)} and ${max(units.desktop, -1)}`,
  lapAndAbove: min(units.lap),
  belowDesktop: max(units.desktop, -1),
  desktop: min(units.desktop)
};
var reduceBreakpoints = (accumulate, key) => __spreadProps(__spreadValues({}, accumulate), {
  [key]: (...args) => css`
    @media ${breakpoints[key]} {
      ${css(...args)}
    }
  `
});
var media = Object.keys(breakpoints).reduce(reduceBreakpoints, {});

// src/theme.js
import get from "lodash/get";

// src/vars.js
var genesisColors = {
  "neutral.gray": "#767676",
  "neutral.grayLight": "#D6D6D6",
  "neutral.grayLighter": "#F0F0F0",
  "neutral.grayDark": "#66686b",
  "functional.blueLight": "#E0E7FA",
  "functional.green": "#00A876",
  neutral: {
    gray: "#767676",
    grayLight: "#D6D6D6",
    grayLighter: "#F0F0F0",
    grayDark: "#66686b"
  },
  functional: {
    blueLight: "#EAEEFB",
    green: "#00A876"
  }
};
var vars = {
  colour: __spreadValues({
    // League Design Language -- Primary
    purpleLightest: "#EDE8FA",
    purpleLighter: "#D7CAFA",
    purpleLight: "#9677E4",
    purple: "#501cd2",
    purpleDark: "#3F16A5",
    purpleDarkest: "#250D53",
    mintLightest: "#E5F8F7",
    mintLighter: "#99E5E1",
    mintLight: "#66D9D1",
    mint: "#00bfb3",
    mintDark: "#05A99F",
    // League Design Language -- Neutrals
    greyLightest: "#F6F7F9",
    greyLighter: "#DDE0E6",
    greyLight: "#98A1B4",
    grey: "#536382",
    greyDark: "#414F68",
    navyLightest: "#EAE9EF",
    navyLighter: "#AEA9BF",
    navyLight: "#857DA0",
    navy: "#43327B",
    navyDark: "#342760",
    creme: "#F9F7F6",
    // League Design Language -- Secondary
    redLightest: "#fbf2f3",
    red: "#D92045",
    blue: "#2E5CDF",
    blueLightest: "#EAEEFB",
    // Non-Standard Colours
    lightenedPurple: "rgba(237, 232, 250, 0.4)",
    purpleGrey: "#424f6f",
    backdrop: "hsla(223, 25%, 35%, 0.9)",
    purpleText: "#271A4D",
    sea: "#8cffd7",
    ocean: "#1BB0AC",
    oceanDarkened: "#008c80",
    lightGreen: "#D9FFF2",
    green: "#548203",
    moneyGreen: "#15d90b",
    opal: "#00BFB3",
    darkGreen: "#00856C",
    yellow: "#F7CC0C",
    lightYellow: "#FFFAE6",
    darkYellow: "#FFD51A",
    white: "#FFFFFF",
    offWhite: "#F8F8F8",
    paleGrey: "#f2f2f5",
    lightMediumGrey: "#e2e5e8",
    infoGrey: "#BFC5CE",
    mediumGrey: "#afb5ba",
    darkGrey: "#727272",
    offBlack: "#4A4A4A",
    darkBlack: "#0a0b0c",
    black: "#000000",
    lightRose: "#FBE4E8",
    darkRose: "#F1A1B1",
    lightOrange: "#FFF3E6",
    orange: "#FFB466",
    flushOrange: "#ff8200",
    flushOrangeLight: "#ffedd9",
    orangeRed: "#D94647",
    darkRed: "#C71337",
    feta: "#DEFADC",
    brightGreen: "#15D90B",
    remy: "#FDE5F1",
    brilliantRose: "#F04E98",
    tenne: "#A44701",
    bone: "#E5D4C2"
  }, genesisColors),
  button: {
    borderRadius: "0.3rem",
    height: "4.5rem"
  },
  card: {
    bottomShadow: "0 5px 10px #e2e5e8",
    fullShadow: "0 0 14px 7px rgba(0, 0, 0, 0.05)"
  },
  fixedWidth: 1e3,
  smallFixedWidth: 835,
  text: {
    bottomShadow: "1px 1px 2px #000",
    fontFamily: `'MarkOffcPro', 'Helvetica Neue', Arial, Helvetica, sans-serif`
  },
  fontWeight: {
    regular: 300,
    medium: 700,
    bold: 800
  }
};

// src/theme.js
var spacingValues = [0, 4, 8, 12, 16, 24, 32, 40];
var genesisSpace = {
  none: spacingValues[0],
  quarter: spacingValues[1],
  half: spacingValues[2],
  threeQuarters: spacingValues[3],
  one: spacingValues[4],
  oneAndHalf: spacingValues[5],
  two: spacingValues[6],
  twoAndHalf: spacingValues[7]
};
var theme = __spreadProps(__spreadValues({}, vars), {
  breakpoints: [
    `${units.phone}px`,
    `${units.tablet}px`,
    `${units.lap}px`,
    `${units.desktop}px`
  ],
  colors: vars.colour,
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
  radii: [0, 2, 3, 5],
  space: __spreadProps(__spreadValues({}, [0, 8, 16, 32, 64]), { genesis: genesisSpace })
});
var getThemeValue = (path) => ({ theme: themeProp }) => get(themeProp, path);
var colour = (colourName) => getThemeValue(["colors", colourName]);
var spaceInPx = (level) => ({ theme: themeProp }) => `${get(get(themeProp, "space"), level)}px`;
var fontSizeInPx = (level) => ({ theme: themeProp }) => `${get(themeProp, ["fontSizes", level])}px`;
var radiusInPx = (level) => ({ theme: themeProp }) => `${get(themeProp, ["radii", level])}px`;

// src/utils/background.js
function bgImageContain() {
  return `
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
  `;
}
function bgImageCover() {
  return `
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  `;
}

// src/utils/components.js
import styled from "styled-components";
var Code = styled.code`
  font-size: ${getThemeValue("fontSizes.2")}px;
  background-color: ${colour("purpleLightest")};
  color: ${colour("purple")};
  padding-left: 0.5ch;
  padding-right: 0.5ch;
  font-family: monospace;
`;

// src/utils/flexible.js
function flexBox() {
  return `
    display: flex;
  `;
}
function verticalBox() {
  return `
    ${flexBox()}
    flex-direction: column;
  `;
}
function horizontalBox() {
  return `
    ${flexBox()}
    flex-direction: row;
  `;
}
function flexShrink(value) {
  return `
    flex-shrink: ${value};
  `;
}
function flexGrow(value) {
  return `
    flex-grow: ${value};
  `;
}
function flex(value) {
  return `
    flex: ${value};
  `;
}
function flexAlign(align) {
  return `
    align-items: ${align === "start" || align === "end" ? `flex-${align}` : align};
  `;
}
function flexPack(pack) {
  return `
    justify-content: ${pack === "start" || pack === "end" ? `flex-${pack}` : pack};
  `;
}
function flexWrap() {
  return `
    flex-wrap: wrap;
  `;
}
function flexOrder(value) {
  return `
    order: ${value};
  `;
}

// src/utils/font.js
function leagueFont(options = { medium: false, bold: false, italic: false }) {
  let fontWeight2;
  if (options.medium) {
    fontWeight2 = 500;
  } else if (options.bold) {
    fontWeight2 = 700;
  } else {
    fontWeight2 = 300;
  }
  return `
      font-family: ${vars.text.fontFamily};
      font-weight: ${fontWeight2};
      font-style: ${options.italic ? "italic" : "normal"};
  `;
}
var fontSizeLineHeight = (fontSize2 = 14, lineHeight2 = 20, unit = "px") => `
  font-size: ${fontSize2 + unit};
  line-height: ${lineHeight2 + unit};
`;

// src/utils/genesis-focus.js
var genesisFocus = Object.freeze({
  outline: 0,
  boxShadow: "focusRing"
});

// src/utils/helpers.js
import { get as get2 } from "lodash";
import { keyframes, css as css2 } from "styled-components";
var getColourObject = (theme2) => {
  return (theme2 == null ? void 0 : theme2.colour) || vars.colour;
};
function hex2Rgba(hex, alpha) {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
var slideUp = keyframes`
  0% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(0%);
  }
`;
var slideDown = keyframes`
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(30px);
  }
`;
var fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
var fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
var pulseKeyframes = keyframes`
  0% {
    background-color: ${hex2Rgba(vars.colour.lightMediumGrey, 0.45)};
  }

  100% {
    background-color: ${hex2Rgba(vars.colour.lightMediumGrey, 0.9)};
  }
`;
var pulse = css2`
  ${pulseKeyframes} .8s linear infinite alternate;
`;
var shakeKeyframes = keyframes`
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
`;
var shake = css2`
  ${shakeKeyframes} 0.82s cubic-bezier(.36,.07,.19,.97) both;
`;
var { darkBlack, flushOrange, brilliantRose, mint, moneyGreen, purple } = vars.colour;
var colorMap = {
  submitted: {
    inner: purple,
    outer: purple
  },
  more_information_needed: {
    inner: flushOrange,
    outer: flushOrange
  },
  approved: {
    inner: mint,
    outer: mint
  },
  paid: {
    inner: moneyGreen,
    outer: moneyGreen
  },
  rejected: {
    inner: brilliantRose,
    outer: brilliantRose
  },
  cancelled: {
    inner: darkBlack,
    outer: darkBlack
  },
  // should never really get to this point, but default
  default: {
    inner: purple,
    outer: purple
  }
};
var getStatusColor = (status) => get2(colorMap, status, colorMap.default);
var sumField = (array = [], field) => array.reduce((acc, curr) => acc + get2(curr, field), 0);

// src/utils/layout.js
import { css as css3 } from "styled-components";
function fullScreen() {
  return css3`
    position: relative;
    width: 100%;
    min-height: 100vh;
    top: 0;
    left: 0;
    @media print {
      position: relative;
      width: 100%;
      height: auto;
    }
  `;
}
function scrollable(options = { vertical: false, horizontal: false, hideScrollBar: false }) {
  return css3`
    -webkit-overflow-scrolling: touch;
    ${options.vertical ? "overflow-y: auto;" : "overflow-y: hidden;"}
    ${options.horizontal ? "overflow-x: auto;" : "overflow-x: hidden;"}
    ${options.hideScrollBar ? `
      &::-webkit-scrollbar {
        -webkit-appearance: none;
        display: none;
      }

      &::-webkit-scrollbar:vertical, &::-webkit-scrollbar:horizontal {
          width: 0px;
          height: 0px;
        }
      }
    ` : ""}
  `;
}
function textEllipsis() {
  return css3`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `;
}
function multilineEllipsis(numberOfLines) {
  return css3`
    /* This css is old. I don't want to try to update it, but it doesn't pass linter cause it's using outdated flex-box props */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${numberOfLines};
    overflow: hidden;
    text-overflow: ellipsis;
  `;
}
function fixedWidthCentered(width2) {
  return css3`
    ${verticalBox()};
    ${flexAlign("center")};
    ${flexPack("start")};

    > * {
      width: 100%;
      max-width: ${width2 || vars.fixedWidth}px;
    }
  `;
}
function smallFixedWidthCentered() {
  return fixedWidthCentered(vars.smallFixedWidth);
}

// src/utils/visually-hidden.js
import { genesisStyled, Box as Box2, css as css4 } from "@leagueplatform/genesis-commons";
var visuallyHidden = Object.freeze({
  ":not(:focus):not(:active)": {
    position: "absolute",
    height: 1,
    width: 1,
    overflow: "hidden",
    clip: "rect(1px, 1px, 1px, 1px)",
    whiteSpace: "nowrap"
  }
});
var VisuallyHidden = genesisStyled(Box2)(visuallyHidden);

// src/components/icon/icon.view.js
import React2 from "react";
import PropTypes from "prop-types";
var Icon = (props) => {
  let size;
  const {
    "aria-hidden": ariaHidden,
    className,
    colour: colour2,
    fill,
    icon,
    id,
    role,
    size: svgSize,
    stroke,
    strokeWidth,
    title,
    viewBox
  } = props;
  const svgProps = icon[0].props;
  const colourProp = icon[1] || "fill";
  const applyColour = (itemProps) => {
    return __spreadProps(__spreadValues({}, itemProps), {
      fill: colourProp === "fill" ? colour2 || fill || itemProps.fill : fill || itemProps.fill,
      stroke: colourProp === "stroke" ? colour2 || stroke || itemProps.stroke : stroke || itemProps.stroke
    });
  };
  const renderNodes = (nodes) => {
    const items = Array.isArray(nodes) ? nodes : [nodes];
    return items.map((item, idx) => {
      const { children } = item.props;
      const itemProps = applyColour(item.props);
      switch (item.type) {
        case "g":
          return /* @__PURE__ */ React2.createElement(
            "g",
            __spreadValues({
              key: idx
            }, itemProps),
            children && renderNodes(children)
          );
        case "circle":
          return /* @__PURE__ */ React2.createElement(
            "circle",
            __spreadValues({
              key: idx
            }, itemProps)
          );
        default:
          return /* @__PURE__ */ React2.createElement(
            "path",
            __spreadValues({
              key: idx
            }, itemProps)
          );
      }
    });
  };
  const paths = renderNodes(svgProps.children);
  switch (svgSize) {
    case "small":
      size = "2rem";
      break;
    case "medium":
      size = "3rem";
      break;
    case "large":
      size = "6rem";
      break;
    default:
      if (typeof svgSize === "string") {
        size = svgSize;
      } else {
        size = `${svgSize}px`;
      }
  }
  const styles = {
    svg: {
      display: "inline-block",
      verticalAlign: "middle",
      width: size,
      height: size,
      strokeWidth
    }
  };
  const hasTitle = !!title;
  return /* @__PURE__ */ React2.createElement(
    "svg",
    __spreadValues({
      "aria-hidden": hasTitle ? false : ariaHidden,
      "aria-label": title,
      className,
      id,
      role: hasTitle ? "img" : role,
      style: styles.svg,
      viewBox: svgProps.viewBox
    }, viewBox && { viewBox }),
    paths
  );
};
Icon.defaultProps = {
  size: "small",
  fill: null,
  stroke: null,
  title: void 0,
  colour: null,
  strokeWidth: "initial",
  viewBox: void 0,
  className: void 0,
  "aria-hidden": true,
  id: void 0,
  role: void 0
};
Icon.propTypes = {
  /** One of small, medium, large or unit in pixels */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** The name of the icon */
  icon: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element,
    PropTypes.object
  ]).isRequired,
  /** Fill colour */
  fill: PropTypes.string,
  /** Stroke colour */
  stroke: PropTypes.string,
  /** Stroke width */
  strokeWidth: PropTypes.string,
  /** Icon colour, if used fill and stroke will be ignored */
  colour: PropTypes.string,
  /** The title of the svg for accessibility */
  title: PropTypes.string,
  // For scaling of icons
  viewBox: PropTypes.string,
  className: PropTypes.string,
  "aria-hidden": PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string,
  role: PropTypes.string
};
var icon_view_default = Icon;

// src/components/icon/icon.constants.js
import React3 from "react";
var icons = {
  CLOCK: [
    /* @__PURE__ */ React3.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement(
      "g",
      {
        strokeWidth: "1.5",
        stroke: "inherit",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      },
      /* @__PURE__ */ React3.createElement("circle", { cx: "10", cy: "10", r: "9" }),
      /* @__PURE__ */ React3.createElement("path", { d: "M10 10V6.528M10 10l4.34 4.34" })
    )),
    "fill"
  ],
  RIGHT_CHEVRON: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M6 14L12 8L6 2",
          stroke: "currentcolor",
          fill: "none",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ),
    "stroke"
  ],
  LEFT_CHEVRON: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M10 2L4 8L10 14",
          stroke: "currentcolor",
          fill: "none",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ),
    "stroke"
  ],
  STAR_FILLED: [
    /* @__PURE__ */ React3.createElement("svg", { viewBox: "0 0 11 11", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M5.5 9.12L2.1 11l.65-3.98L0 4.202l3.8-.58L5.5 0l1.7 3.62 3.8.582L8.25 7.02 8.9 11",
        fill: "#64CCC9",
        fillRule: "evenodd"
      }
    )),
    "fill"
  ],
  INFORMATION: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" }, /* @__PURE__ */ React3.createElement(
      "path",
      {
        fill: "#FFF",
        d: "M56.67 76.56H43.33v-33h13.34v33zM50 38.05a7.31 7.31 0 1 1 7.31-7.31A7.31 7.31 0 0 1 50 38.05z"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        fill: "#FFF",
        d: "M85.36 14.64a50 50 0 1 0 0 70.71 49.84 49.84 0 0 0 0-70.71zm-5.53 65.19a42.19 42.19 0 0 1-59.66-59.66 42.19 42.19 0 0 1 59.67 0 42.19 42.19 0 0 1-.01 59.66z"
      }
    ), /* @__PURE__ */ React3.createElement("circle", { fill: "#FFF", cx: "50", cy: "30.74", r: "7.31" }), /* @__PURE__ */ React3.createElement("path", { fill: "#FFF", d: "M43.33 43.57h13.35v32.99H43.33z" })),
    "fill"
  ],
  SEARCH: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" })),
    "fill"
  ],
  WARNING: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" })),
    "fill"
  ],
  X: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M323.1 441l53.9-53.9c9.4-9.4 9.4-24.5 0-33.9L279.8 256l97.2-97.2c9.4-9.4 9.4-24.5 0-33.9L323.1 71c-9.4-9.4-24.5-9.4-33.9 0L192 168.2 94.8 71c-9.4-9.4-24.5-9.4-33.9 0L7 124.9c-9.4 9.4-9.4 24.5 0 33.9l97.2 97.2L7 353.2c-9.4 9.4-9.4 24.5 0 33.9L60.9 441c9.4 9.4 24.5 9.4 33.9 0l97.2-97.2 97.2 97.2c9.3 9.3 24.5 9.3 33.9 0z" })),
    "fill"
  ],
  CHECK: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" })),
    "fill"
  ],
  CHEVRON_RIGHT: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" })),
    "fill"
  ],
  CHEVRON_DOWN: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" })),
    "fill"
  ],
  ASTERISK: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z" })),
    "fill"
  ],
  LIGHT_BULB: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M272 428v28c0 10.449-6.68 19.334-16 22.629V488c0 13.255-10.745 24-24 24h-80c-13.255 0-24-10.745-24-24v-9.371c-9.32-3.295-16-12.18-16-22.629v-28c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12zm-143.107-44c-9.907 0-18.826-6.078-22.376-15.327C67.697 267.541 16 277.731 16 176 16 78.803 94.805 0 192 0s176 78.803 176 176c0 101.731-51.697 91.541-90.516 192.673-3.55 9.249-12.47 15.327-22.376 15.327H128.893zM112 176c0-44.112 35.888-80 80-80 8.837 0 16-7.164 16-16s-7.163-16-16-16c-61.757 0-112 50.243-112 112 0 8.836 7.164 16 16 16s16-7.164 16-16z" })),
    "fill"
  ],
  DOCUMENT_PIN: [
    /* @__PURE__ */ React3.createElement("svg", { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement("path", { d: "M4.06207394,14.1516394 C2.85323954,15.57965 1.64503617,17.0078709 0.435570752,18.4356711 C0.115851198,18.8128139 0.107647867,19.2469594 0.418322723,19.5530068 C0.726894162,19.8569507 1.14379163,19.8521128 1.5184104,19.5391242 C2.55455417,18.6756711 3.58985657,17.8120076 4.62578999,16.9483441 C5.09779702,16.5541636 5.5710661,16.1604037 6.06242457,15.7508682 C5.45642981,15.1398252 4.86242453,14.5399304 4.25685045,13.9295184 C4.18196877,14.0151276 4.12096964,14.0824369 4.06207394,14.1516394 Z M12.5628279,19.748204 C13.4288052,18.7770558 13.3886299,17.1010523 12.6120479,15.2315343 C12.6280339,15.2025071 12.6461233,15.1730592 12.6690505,15.1425597 C14.4258254,12.7892555 16.1720831,10.42901 17.9214959,8.07044726 L18.1619166,8.31128863 C18.5529421,8.70210372 19.1864916,8.70189338 19.576886,8.31107829 L19.7068772,8.18150773 C20.0972716,7.79090299 20.0976923,7.15756379 19.7070876,6.76653836 L13.2331873,0.292848409 C12.8421619,-0.097756336 12.209033,-0.0975459942 11.8180076,0.293058751 L11.688437,0.422418966 C11.2978323,0.813023711 11.2978323,1.44699393 11.688437,1.83759868 L12.0211978,2.17099045 C9.63024239,3.91956194 7.24012838,5.66897479 4.84433514,7.41081533 C4.84202138,7.41291875 4.83844556,7.4141808 4.83550078,7.4156532 C2.91865585,6.60352346 1.16251206,6.52317289 0.219970395,7.46550421 C0.111013336,7.57446126 -0.18914443,7.91942184 0.174746905,8.28352351 L11.6979024,19.8064687 C12.101338,20.2099043 12.433047,19.8777745 12.5628279,19.748204 Z M8.10820904,9.4399828 C7.61895398,9.04012301 7.12296799,8.68191091 6.62845439,8.3674499 C8.75038259,6.63486439 10.8714694,4.9018582 13.0081216,3.15707287 L14.1260883,4.2750396 C12.1072276,6.00783545 10.1068769,7.72443498 8.10820904,9.4399828 Z" }))
  ],
  CARET: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        className: "caret-icon",
        x: "0px",
        y: "0px",
        width: "12px",
        height: "6px",
        viewBox: "351.584 2118.292 12 6"
      },
      /* @__PURE__ */ React3.createElement("g", null, /* @__PURE__ */ React3.createElement("path", { d: "M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z" }))
    )
  ],
  CLOSE: [
    /* @__PURE__ */ React3.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, /* @__PURE__ */ React3.createElement("g", null, /* @__PURE__ */ React3.createElement(
      "path",
      {
        stroke: "currentcolor",
        fill: "currentcolor",
        d: "M19.5,20.25c-0.2,0-0.389-0.078-0.53-0.22L12,13.061l-6.97,6.97c-0.142,0.142-0.33,0.22-0.53,0.22s-0.389-0.078-0.53-0.22\n          c-0.292-0.292-0.292-0.768,0-1.061l6.97-6.97L3.97,5.03C3.828,4.889,3.75,4.7,3.75,4.5s0.078-0.389,0.22-0.53\n          C4.111,3.828,4.3,3.75,4.5,3.75s0.389,0.078,0.53,0.22l6.97,6.97l6.97-6.97c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22\n          c0.142,0.141,0.22,0.33,0.22,0.53s-0.078,0.389-0.22,0.53L13.061,12l6.97,6.97c0.292,0.292,0.292,0.768,0,1.061\n          C19.889,20.172,19.7,20.25,19.5,20.25z"
      }
    )))
  ],
  EDIT: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, /* @__PURE__ */ React3.createElement(
      "g",
      {
        fill: "none",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "currentcolor"
      },
      /* @__PURE__ */ React3.createElement("path", { d: "M18.151 1.848a2.911 2.911 0 0 0-4.135.028l-11.6 11.6L1 19l5.524-1.417 11.6-11.6a2.91 2.91 0 0 0 .027-4.135zM13 3l4 4M3 13l4 4" })
    ))
  ],
  CANCEL: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, /* @__PURE__ */ React3.createElement(
      "g",
      {
        fill: "none",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "currentcolor"
      },
      /* @__PURE__ */ React3.createElement("path", { d: "M13.652 8.348l-5.304 5.303M8.348 8.348l5.304 5.303M20.375 11c0 2.589-.915 4.799-2.746 6.63-1.83 1.83-4.04 2.745-6.629 2.745-2.589 0-4.799-.915-6.63-2.746C2.54 15.8 1.626 13.59 1.626 11c0-2.589.915-4.799 2.746-6.63C6.2 2.54 8.41 1.626 11 1.626c2.589 0 4.799.915 6.63 2.746C19.46 6.2 20.374 8.41 20.374 11z" })
    ))
  ],
  CHAT: [
    /* @__PURE__ */ React3.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, /* @__PURE__ */ React3.createElement(
      "g",
      {
        fill: "none",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "currentcolor"
      },
      /* @__PURE__ */ React3.createElement("path", { d: "M3.977 6.114c-1.668 2.998-1.595 5.953.217 8.865l-2.569 5.396 5.395-2.57c3.511 2.184 7.535 1.347 10.102-.61 2.567-1.955 3.863-5.697 2.77-9.733-1.092-4.036-4.214-5.837-8.267-5.837-3.43-.005-5.98 1.491-7.648 4.489z" }),
      /* @__PURE__ */ React3.createElement("path", { d: "M11.625 13.5c-.208 0-.313.104-.313.312 0 .209.105.313.313.313.208 0 .312-.104.312-.313 0-.208-.104-.312-.312-.312M9.125 9.125c0-1.114.77-1.92 1.543-2.31.774-.39 1.937-.245 2.725.542.787.788.787 2.087.542 2.725-.246.637-.732 1.543-2.31 1.543" })
    ))
  ],
  CARET_DOWN: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 8" }, /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M6.387 7.76A.87.87 0 0 0 7 8a.87.87 0 0 0 .613-.24l6.221-6.694a.578.578 0 0 0 .087-.695c-.13-.227-.402-.37-.7-.371H.78C.48 0 .209.144.078.371a.578.578 0 0 0 .088.695l6.22 6.694z",
        fillRule: "nonzero",
        fill: "#000"
      }
    ))
  ],
  FILE_DOWNLOAD: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fill: "none",
          d: "M15.375 20.375C18.1364 20.375 20.375 18.1364 20.375 15.375C20.375 12.6136 18.1364 10.375 15.375 10.375C12.6136 10.375 10.375 12.6136 10.375 15.375C10.375 18.1364 12.6136 20.375 15.375 20.375Z",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#501CD2"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fill: "none",
          d: "M15.375 12.875V17.875",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#501CD2"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fill: "none",
          d: "M15.375 17.875L17.25 16",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#501CD2"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fill: "none",
          d: "M15.375 17.875L13.5 16",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#501CD2"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fill: "none",
          d: "M7.875 17.875H2.875C2.18464 17.875 1.625 17.3154 1.625 16.625V2.875C1.625 2.18464 2.18464 1.625 2.875 1.625H11.7325C12.0638 1.62507 12.3815 1.75665 12.6158 1.99083L15.0092 4.38417C15.2433 4.6185 15.3749 4.93621 15.375 5.2675V7.875",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#501CD2"
        }
      )
    )
  ],
  WHAT: [
    /* @__PURE__ */ React3.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement(
      "g",
      {
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "#501CD2"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M12.5 21.5H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h11.129a1.5 1.5 0 0 1 1.06.439l2.872 2.872a1.5 1.5 0 0 1 .439 1.06V20.5a1 1 0 0 1-1 1h-7z",
          strokeWidth: "1.5",
          fill: "#E5DDF9"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M7.183 14.317h9.867M7.183 18h6.934M10 7a2 2 0 1 1 2 2",
          strokeWidth: "1.5"
        }
      ),
      /* @__PURE__ */ React3.createElement("path", { d: "M11.984 10.843a.513.513 0 1 1 0 1.025.513.513 0 0 1 0-1.025" })
    ))
  ],
  DEPENDENTS: [
    /* @__PURE__ */ React3.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React3.createElement("ellipse", { fill: "#E5DDF9", cx: "12", cy: "15.5", rx: "8", ry: "5.5" }), /* @__PURE__ */ React3.createElement("circle", { fill: "#E5DDF9", cx: "11.97", cy: "5.5", r: "4.5" }), /* @__PURE__ */ React3.createElement(
      "circle",
      {
        stroke: "#501CD2",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        cx: "11.97",
        cy: "5.5",
        r: "4.5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M20.776 15.528c-1.663-3.075-4.935-5-8.5-5-1.3 0-4.806.472-6.802 2.472M10.9 22.069c-.977-1.23-2.902-2-5-2-2.097 0-4.022.77-5 2",
        stroke: "#501CD2",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M17 23a6 6 0 1 0 0-12 6 6 0 0 0 0 12z",
        stroke: "#501CD2",
        strokeWidth: "1.5",
        fill: "#FFF",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ), /* @__PURE__ */ React3.createElement(
      "g",
      {
        stroke: "#501CD2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ React3.createElement("path", { d: "M18.972 17.234H15M16.986 15v4.469" })
    ), /* @__PURE__ */ React3.createElement(
      "circle",
      {
        stroke: "#501CD2",
        strokeWidth: "1.5",
        fill: "#E5DDF9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        cx: "5.901",
        cy: "15.5",
        r: "3.5"
      }
    )))
  ],
  COVERAGE: [
    /* @__PURE__ */ React3.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement(
      "g",
      {
        stroke: "#501CD2",
        strokeWidth: "1.5",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M22.313 13.375C22.313 7.68 17.694 3.062 12 3.062S1.687 7.68 1.687 13.376l.744-.62a4.315 4.315 0 0 1 6.131.62 4.858 4.858 0 0 1 6.876 0 4.315 4.315 0 0 1 6.131-.62l.744.62z",
          fill: "#E5DDF9"
        }
      ),
      /* @__PURE__ */ React3.createElement("path", { d: "M12 11.951v8.984a1.375 1.375 0 0 1-2.75 0M12 3.063V1.687" }),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M21.527 16.488a1.589 1.589 0 0 0-2.293 0l-.983 1.005-.983-1.005a1.589 1.589 0 0 0-2.293 0 1.698 1.698 0 0 0 0 2.356l2.927 3.007a.484.484 0 0 0 .698 0l2.927-3.01c.63-.66.63-1.694 0-2.353z",
          fill: "#E5DDF9"
        }
      )
    ))
  ],
  FAMILY: [
    /* @__PURE__ */ React3.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React3.createElement("circle", { fill: "#E5DDF9", cx: "13.875", cy: "6.96", r: "5.5" }), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M22.588 20.768c-1.224-3.068-5.772-6.765-9.818-4.917C8.724 17.7 1.07 17.596.885 21.467c-.185 3.87 23.585.365 21.703-.7z",
        fill: "#E5DDF9"
      }
    ), /* @__PURE__ */ React3.createElement(
      "circle",
      {
        stroke: "#501CD2",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        cx: "13.875",
        cy: "6.96",
        r: "5.5"
      }
    ), /* @__PURE__ */ React3.createElement(
      "circle",
      {
        stroke: "#501CD2",
        strokeWidth: "1.5",
        fill: "#E5DDF9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        cx: "7.387",
        cy: "11",
        r: "4"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M22.375 20.46c-1.662-3.076-4.936-5-8.5-5-2.31 0-4.291.54-6.877 2.5",
        stroke: "#501CD2",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ), /* @__PURE__ */ React3.createElement(
      "path",
      {
        d: "M12.387 21c-1.076-1.845-3.193-3-5.5-3s-4.424 1.155-5.5 3",
        stroke: "#501CD2",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )))
  ],
  TWO_PEOPLE: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          fill: "none",
          clipRule: "evenodd",
          d: "M12.5817 10.5434C14.9575 10.5434 16.8836 8.63087 16.8836 6.27168C16.8836 3.9125 14.9575 2 12.5817 2C10.2058 2 8.27979 3.9125 8.27979 6.27168C8.27979 8.63087 10.2058 10.5434 12.5817 10.5434Z",
          stroke: "#66686B",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M21 15.7914C19.4109 12.8722 16.2827 11.045 12.8742 11.045C11.9094 11.045 9.67502 11.3146 7.83093 12.3227",
          stroke: "#66686B",
          fill: "none",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M12.5597 22C11.625 20.8324 9.78485 20.1015 7.77987 20.1015C5.77489 20.1015 3.93477 20.8324 3 22",
          stroke: "#66686B",
          strokeWidth: "1.5",
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.77987 19.0867C9.62776 19.0867 11.1258 17.5992 11.1258 15.7643C11.1258 13.9294 9.62776 12.4419 7.77987 12.4419C5.93197 12.4419 4.43396 13.9294 4.43396 15.7643C4.43396 17.5992 5.93197 19.0867 7.77987 19.0867Z",
          stroke: "#66686B",
          strokeWidth: "1.5",
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    )
  ],
  PURPLE_ADD: [
    /* @__PURE__ */ React3.createElement("svg", { width: "20", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.833 10.833V9.167A.84.84 0 0 0 15 8.333h-3.333V5a.84.84 0 0 0-.834-.833H9.167A.84.84 0 0 0 8.333 5v3.333H5a.84.84 0 0 0-.833.834v1.666a.84.84 0 0 0 .833.834h3.333V15a.84.84 0 0 0 .834.833h1.666a.84.84 0 0 0 .834-.833v-3.333H15a.84.84 0 0 0 .833-.834zM20 10c0 5.52-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0s10 4.48 10 10z",
        fill: "#501CD2"
      }
    ))
  ],
  UMBRELLA_HEART: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.25 13.5C23.25 7.2868 18.2132 2.25 12 2.25C5.7868 2.25 0.75 7.2868 0.75 13.5L1.561 12.824C2.53262 12.0144 3.78918 11.6298 5.04749 11.757C6.30581 11.8842 7.46001 12.5123 8.25 13.5C9.24413 12.5046 10.5932 11.9453 12 11.9453C13.4068 11.9453 14.7559 12.5046 15.75 13.5C16.54 12.5123 17.6942 11.8842 18.9525 11.757C20.2108 11.6298 21.4674 12.0144 22.439 12.824L23.25 13.5Z",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M12 11.947V21.747C12 22.5754 11.3284 23.247 10.5 23.247C9.67157 23.247 9 22.5754 9 21.747",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M12 2.25V0.75",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.68 16.6C22.3214 16.2237 21.8243 16.0107 21.3045 16.0107C20.7847 16.0107 20.2876 16.2237 19.929 16.6L18.75 17.814L17.571 16.6C17.2124 16.2237 16.7153 16.0107 16.1955 16.0107C15.6757 16.0107 15.1786 16.2237 14.82 16.6C14.06 17.3961 14.06 18.649 14.82 19.445L18.331 23.076C18.4403 23.1906 18.5917 23.2554 18.75 23.2554C18.9083 23.2554 19.0597 23.1906 19.169 23.076L22.68 19.44C23.4368 18.6446 23.4368 17.3954 22.68 16.6Z",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    )
  ],
  CIGARETTE: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.75 22.75H3.75V16.75H21.75C22.5784 16.75 23.25 17.4216 23.25 18.25V21.25C23.25 22.0784 22.5784 22.75 21.75 22.75Z",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M15.75 16.75V22.75",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M0.75 16.75V22.75",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M8.25 3.25C8.25 5.73528 6.23528 7.75 3.75 7.75C2.09315 7.75 0.75 9.09315 0.75 10.75",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M12.75 3.25C12.75 8.22056 8.72056 12.25 3.75 12.25",
          stroke: "#767676",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    )
  ],
  QUESTION_CIRCLE: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fill: "none",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z",
          stroke: "#767676"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M7.236 10.306V8.41H7.65C7.99 8.41 8.292 8.376 8.556 8.308C8.82 8.24 9.044 8.142 9.228 8.014C9.412 7.882 9.552 7.724 9.648 7.54C9.744 7.352 9.792 7.138 9.792 6.898C9.792 6.678 9.744 6.48 9.648 6.304C9.552 6.128 9.412 5.978 9.228 5.854C9.048 5.73 8.828 5.636 8.568 5.572C8.308 5.508 8.016 5.476 7.692 5.476C7.536 5.476 7.382 5.482 7.23 5.494C7.082 5.502 6.95 5.512 6.834 5.524L6.75 4.516C6.886 4.496 7.046 4.48 7.23 4.468C7.414 4.452 7.584 4.444 7.74 4.444C8.228 4.444 8.666 4.502 9.054 4.618C9.442 4.73 9.772 4.892 10.044 5.104C10.316 5.312 10.524 5.566 10.668 5.866C10.816 6.162 10.89 6.492 10.89 6.856C10.89 7.204 10.83 7.52 10.71 7.804C10.59 8.088 10.414 8.334 10.182 8.542C9.95 8.75 9.666 8.92 9.33 9.052C8.994 9.184 8.608 9.274 8.172 9.322L8.124 10.306H7.236ZM7.68 11.476C7.788 11.476 7.892 11.498 7.992 11.542C8.092 11.586 8.178 11.646 8.25 11.722C8.326 11.794 8.386 11.88 8.43 11.98C8.474 12.08 8.496 12.184 8.496 12.292C8.496 12.404 8.474 12.51 8.43 12.61C8.386 12.71 8.326 12.798 8.25 12.874C8.178 12.95 8.092 13.01 7.992 13.054C7.892 13.098 7.788 13.12 7.68 13.12C7.572 13.12 7.468 13.098 7.368 13.054C7.268 13.01 7.18 12.95 7.104 12.874C7.028 12.798 6.968 12.71 6.924 12.61C6.88 12.51 6.858 12.404 6.858 12.292C6.858 12.184 6.88 12.08 6.924 11.98C6.968 11.88 7.028 11.794 7.104 11.722C7.18 11.646 7.268 11.586 7.368 11.542C7.468 11.498 7.572 11.476 7.68 11.476Z",
          fill: "#767676"
        }
      )
    )
  ],
  CADUCEUS: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0331 6.118C13.5155 6.118 14.7171 4.91633 14.7171 3.434C14.7171 1.95167 13.5155 0.75 12.0331 0.75C10.5508 0.75 9.34912 1.95167 9.34912 3.434C9.34912 4.91633 10.5508 6.118 12.0331 6.118Z",
          stroke: "#66686B",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M15.23 12.625C15.8492 12.615 16.434 12.9095 16.7946 13.413C17.1552 13.9165 17.2458 14.5649 17.037 15.148",
          stroke: "#66686B",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M12.033 6.11792V23.2499",
          stroke: "#66686B",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M14.4941 4.5H22.3831C25.0601 4.5 21.1831 10.953 15.6111 8.8",
          stroke: "#66686B",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M9.56905 4.5H1.68205C-0.993946 4.5 2.88205 10.953 8.45405 8.8",
          stroke: "#66686B",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M8.83502 12.6251C7.78797 12.6145 6.92974 13.4531 6.91602 14.5001C6.92152 15.5651 7.77044 16.4339 8.83502 16.4641H13.951C15.0108 16.4641 15.87 17.3233 15.87 18.3831C15.87 19.4429 15.0108 20.3021 13.951 20.3021H10.434C9.52967 20.3228 8.81334 21.0727 8.83402 21.9771C8.83146 22.4482 9.02361 22.8995 9.36502 23.2241",
          stroke: "#66686B",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    )
  ],
  PENCIL: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.6123 1.75402C14.1754 1.26683 13.5829 0.995385 12.9664 1.00006C12.35 1.00473 11.7608 1.28514 11.3298 1.7789L2.12378 12.0899L1 17L5.38399 15.7406L14.5901 5.42969C15.031 4.94728 15.2815 4.28743 15.2857 3.59704C15.2898 2.90666 15.0474 2.24307 14.6123 1.75402Z",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M10.5234 2.77783L13.698 6.33339",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M2.58691 11.6667L5.76152 15.2223",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      )
    )
  ],
  CLAIMS: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.17143 15H3C2.44771 15 2 14.5523 2 14V2C2 1.44772 2.44772 1 3 1H11.0034C11.276 1.00006 11.5375 1.11234 11.7303 1.31218L13.6983 3.35449C13.891 3.55445 13.9999 3.82557 14 4.10827V14C14 14.5523 13.5523 15 13 15H8.17143Z",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M6.19173 9.96202C6.60452 10.505 7.25652 10.812 7.938 10.7844C9.00851 10.7844 9.87601 10.1331 9.87601 9.33043C9.87601 8.52779 9.00851 7.8774 7.938 7.8774C6.8675 7.8774 6 7.22607 6 6.42249C6 5.6189 6.8675 4.96851 7.938 4.96851C8.61949 4.94089 9.27149 5.24794 9.68427 5.7909",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M7.938 10.7852V11.7542",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M7.938 4V4.969",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      )
    )
  ],
  EMPLOYER: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.53936 6.26953C1.53936 5.4411 2.21093 4.76953 3.03936 4.76953H12.9606C13.7891 4.76953 14.4606 5.4411 14.4606 6.26953V12.499C14.4606 13.3274 13.7891 13.999 12.9606 13.999H3.03936C2.21093 13.999 1.53936 13.3274 1.53936 12.499V6.26953Z",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.0563 2.63068C9.93056 2.25397 9.57791 1.99995 9.18076 2H6.81924C6.42209 1.99995 6.06944 2.25397 5.94367 2.63068L5.23116 4.76884H10.7688L10.0563 2.63068Z",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      )
    )
  ],
  FINANCE: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M5.30169 11.3563C5.94929 12.2081 6.97218 12.6898 8.04133 12.6465C9.72079 12.6465 11.0818 11.6246 11.0818 10.3654C11.0818 9.10618 9.72079 8.08582 8.04133 8.08582C6.36186 8.08582 5.00089 7.06399 5.00089 5.80329C5.00089 4.54258 6.36186 3.52222 8.04133 3.52222C9.11047 3.47889 10.1334 3.96061 10.781 4.81242",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M8.04133 12.6445V14.1647",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M8.04054 2V3.52022",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      )
    )
  ],
  TOOLKIT: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.07542 6.26953C1.07542 5.4411 1.747 4.76953 2.57542 4.76953H13.4246C14.253 4.76953 14.9246 5.4411 14.9246 6.26953V12.5023C14.9246 13.3307 14.253 14.0023 13.4246 14.0023H2.57542C1.747 14.0023 1.07542 13.3307 1.07542 12.5023V9.38592V6.26953Z",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M10.7698 4.76983C10.7698 3.2401 9.52974 2 8 2C6.47027 2 5.23017 3.2401 5.23017 4.76983",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M1.07542 8.46289H6",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M10 8.46289H14.9246",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 10C6.89543 10 6 9.05228 6 8.5C6 7.94772 6.89543 7 8 7C9.10457 7 10 7.94772 10 8.5C10 9.05228 9.10457 10 8 10Z",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      )
    )
  ],
  SIGN_OUT: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M15.5 8.00195H5",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M7.5 10.502L5 8.00195L7.5 5.50195",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          fill: "none",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M11.5 11V14C11.5238 14.5268 11.1173 14.9737 10.5907 15H2.40867C1.88226 14.9734 1.47622 14.5265 1.5 14V2C1.47585 1.47332 1.88209 1.02625 2.40867 1H10.5907C11.1173 1.02625 11.5238 1.47321 11.5 2V5",
          stroke: "inherit",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }
      )
    )
  ],
  OFFLINE: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement("path", { d: "M9.75666 5.69832C9.65437 5.67264 9.55207 5.69832 9.46256 5.76253C9.13009 6.04503 8.74647 6.27616 8.32449 6.43025C7.92809 6.58434 7.49332 6.66139 7.03298 6.66139C5.99722 6.66139 5.05096 6.23764 4.37324 5.55708C3.69551 4.87651 3.27353 3.92629 3.27353 2.88619C3.27353 2.4496 3.35026 2.02585 3.47813 1.64063C3.61879 1.22972 3.82338 0.857335 4.09192 0.536315C4.207 0.395066 4.18143 0.189613 4.04077 0.0740454C3.95126 0.0098413 3.84896 -0.0158403 3.74666 0.00984129C2.65975 0.30518 1.71349 0.960062 1.03577 1.83324C0.383617 2.69357 0 3.75936 0 4.91503C0 6.31468 0.562639 7.58593 1.48332 8.51046C2.404 9.435 3.65715 10 5.06375 10C6.24017 10 7.32709 9.58909 8.19662 8.90853C9.07894 8.21513 9.7183 7.22638 9.98683 6.09639C10.038 5.91662 9.93569 5.73685 9.75666 5.69832Z" })
    )
  ],
  FILE_ARROW_UP: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fill: "none",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.6667 21.0002C18.6122 21.0002 21 18.6123 21 15.6668C21 12.7213 18.6122 10.3335 15.6667 10.3335C12.7212 10.3335 10.3334 12.7213 10.3334 15.6668C10.3334 18.6123 12.7212 21.0002 15.6667 21.0002Z",
          stroke: "#501CD2",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M15.6666 18.3335L15.6666 13.0002",
          stroke: "#501CD2",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M15.6667 13L17.6667 15",
          stroke: "#501CD2",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M15.6666 13L13.6666 15",
          stroke: "#501CD2",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M3.66663 6.3335H13",
          stroke: "#501CD2",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M3.66663 10.3335H8.99996",
          stroke: "#501CD2",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          d: "M3.66663 14.3335H6.99996",
          stroke: "#501CD2",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ React3.createElement(
        "path",
        {
          fill: "none",
          d: "M7 18.3333H2.33333C1.59695 18.3333 1 17.7364 1 17V2.33333C1 1.59695 1.59695 1 2.33333 1H11.7813C12.1347 1.00008 12.4736 1.14043 12.7236 1.39022L15.2764 3.94311C15.5262 4.19307 15.6666 4.53196 15.6667 4.88533V7",
          stroke: "#501CD2",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    )
  ],
  PROFILE: [
    /* @__PURE__ */ React3.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, /* @__PURE__ */ React3.createElement("path", { d: "M437.02 330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521 243.251 404 198.548 404 148 404 66.393 337.607 0 256 0S108 66.393 108 148c0 50.548 25.479 95.251 64.262 121.962-36.21 12.495-69.398 33.136-97.281 61.018C26.629 379.333 0 443.62 0 512h40c0-119.103 96.897-216 216-216s216 96.897 216 216h40c0-68.38-26.629-132.667-74.98-181.02zM256 256c-59.551 0-108-48.448-108-108S196.449 40 256 40s108 48.448 108 108-48.449 108-108 108z" }))
  ],
  NEW_TAB: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 283.922 283.922",
        "aria-hidden": "true",
        key: "newTab"
      },
      /* @__PURE__ */ React3.createElement("path", { d: "M266.422 0h-97.625c-9.65 0-17.5 7.851-17.5 17.5 0 9.649 7.85 17.5 17.5 17.5h55.377l-92.375 92.374a17.378 17.378 0 00-5.127 12.375c0 4.676 1.819 9.069 5.125 12.371a17.374 17.374 0 0012.375 5.13c4.674 0 9.069-1.82 12.376-5.127l92.374-92.375v55.377c0 9.649 7.851 17.5 17.5 17.5 9.649 0 17.5-7.851 17.5-17.5V17.5c0-9.649-7.851-17.5-17.5-17.5z" }),
      /* @__PURE__ */ React3.createElement("path", { d: "M201.137 253.922H30V82.785h128.711l30-30H15c-8.284 0-15 6.716-15 15v201.137c0 8.284 6.716 15 15 15h201.137c8.284 0 15-6.716 15-15V95.211l-30 30v128.711z" })
    )
  ],
  DOT_MENU: [
    /* @__PURE__ */ React3.createElement(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React3.createElement("circle", { cx: "12", cy: "4", r: "2", fill: "currentcolor" }),
      /* @__PURE__ */ React3.createElement("circle", { cx: "12", cy: "12", r: "2", fill: "currentcolor" }),
      /* @__PURE__ */ React3.createElement("circle", { cx: "12", cy: "20", r: "2", fill: "currentcolor" })
    )
  ]
};
var icon_constants_default = icons;

// src/components/heading.view.js
import React4 from "react";
import PropTypes2 from "prop-types";
import styled2 from "styled-components";
var HeadingBase = (props) => {
  const Tag = `h${props.level}`;
  return /* @__PURE__ */ React4.createElement(Tag, __spreadValues({}, props));
};
var getFontSize = ({ level }) => {
  switch (level) {
    case 1:
      return fontSizeInPx(5);
    case 2:
      return fontSizeInPx(4);
    case 3:
      return fontSizeInPx(3);
    default:
      return fontSizeInPx(2);
  }
};
var Heading = styled2(HeadingBase)`
  margin-bottom: ${spaceInPx(2)};
  font-size: ${getFontSize};
  ${leagueFont({ medium: true })};
  line-height: 1.5;
`;
Heading.defaultProps = {
  level: 1,
  children: ""
};
Heading.propTypes = {
  /** [1-4] - the level of emphasis */
  level: PropTypes2.number,
  /** The content of header */
  children: PropTypes2.node
};
HeadingBase.propTypes = Heading.PropTypes;
Heading.displayName = "Heading";
var heading_view_default = Heading;

// src/components/subtitle.view.js
import React5 from "react";
import PropTypes3 from "prop-types";
import styled3 from "styled-components";
var Subtitle = (props) => {
  const StyledSubtitle = styled3.div`
    text-transform: ${props.textTransform};
    font-size: 1.2rem;
    margin: 1.6rem 0;
  `;
  return /* @__PURE__ */ React5.createElement(StyledSubtitle, __spreadValues({}, props), props.children);
};
Subtitle.defaultProps = {
  textTransform: "none",
  children: ""
};
Subtitle.propTypes = {
  /** [1-3] - the level of emphasis */
  textTransform: PropTypes3.string,
  /** The content of header */
  children: PropTypes3.node
};
var subtitle_view_default = Subtitle;

// src/components/image/image.view.js
import React6 from "react";
import styled4 from "styled-components";
import PropTypes4 from "prop-types";
var Image = (_a) => {
  var _b = _a, {
    backgroundPosition,
    backgroundSize,
    className,
    cover,
    fit,
    height,
    url,
    width: width2
  } = _b, rest = __objRest(_b, [
    "backgroundPosition",
    "backgroundSize",
    "className",
    "cover",
    "fit",
    "height",
    "url",
    "width"
  ]);
  const imageWidth = typeof width2 === "number" ? `${width2}px` : width2 || null;
  const imageHeight = typeof height === "number" ? `${height}px` : height || null;
  const StyledImage = styled4.div`
    background-repeat: no-repeat;
    background-size: ${cover ? "cover" : backgroundSize};
    background-image: ${url ? `url(${url})` : "none"};
    background-position: ${backgroundPosition};
    ${fit ? "width: 100%; height: 100%;" : ""} ${imageWidth !== null ? `width: ${imageWidth};` : ""} ${imageHeight !== null ? `height: ${imageHeight};` : ""};
  `;
  return /* @__PURE__ */ React6.createElement(StyledImage, __spreadValues({ className: `image ${className}` }, rest));
};
Image.defaultProps = {
  url: null,
  fit: false,
  width: null,
  height: null,
  cover: false,
  className: "",
  backgroundSize: "contain",
  backgroundPosition: "center",
  children: null
};
Image.propTypes = {
  /** The url for the image */
  url: PropTypes4.string,
  fit: PropTypes4.bool,
  width: PropTypes4.oneOfType([PropTypes4.number, PropTypes4.string]),
  height: PropTypes4.oneOfType([PropTypes4.number, PropTypes4.string]),
  cover: PropTypes4.bool,
  className: PropTypes4.string,
  /** The background-position property for the image */
  backgroundPosition: PropTypes4.string,
  /** The background-size property for the image */
  backgroundSize: PropTypes4.string,
  /** Inner content of the image */
  children: PropTypes4.node
};

// src/components/link.view.js
import React7 from "react";
import styled5, { css as css5 } from "styled-components";
var getColor = ({ disabled, theme: theme2 }) => disabled ? getColourObject(theme2).darkGrey : getColourObject(theme2).purple;
var getCursor = (props) => props.disabled ? "initial" : "pointer";
var StyledLink = styled5.a`
  color: ${getColor};
  font-size: 1.6rem;
  font-weight: 500;
  text-decoration: none;
  cursor: ${getCursor};
  &:hover {
    ${({ disabled, theme: theme2 }) => disabled ? css5`
            color: ${getColourObject(theme2).darkGrey};
          ` : css5`
            text-decoration: underline;
            color: ${getColourObject(theme2).purple};
          `};
  }
`;
var Link = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React7.createElement(StyledLink, __spreadValues({}, props));
};
var link_view_default = Link;

// src/components/scroll-loader/scroll-loader.view.js
import React8, { Component } from "react";
import styled6 from "styled-components";
import PropTypes5 from "prop-types";
var ScrollDiv = styled6.div`
  overflow-x: auto;
  height: ${(props) => props.height};
`;
var ScrollLoader = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastScrollY: 0
    };
    this.onScroll = this.onScroll.bind(this);
  }
  onScroll(evt) {
    const { isLoading, isEndOfList, load, bufferHeight } = this.props;
    const { scrollTop, scrollHeight, offsetHeight } = evt.currentTarget;
    if (!isLoading && !isEndOfList) {
      if (scrollTop > this.state.lastScrollY && scrollHeight - offsetHeight - scrollTop <= bufferHeight) {
        load();
        this.setState({
          lastScrollY: scrollTop
        });
      }
    }
  }
  render() {
    const { height } = this.props;
    return /* @__PURE__ */ React8.createElement(ScrollDiv, { onScroll: (evt) => this.onScroll(evt), height }, this.props.children);
  }
};
ScrollLoader.propTypes = {
  /** The load function to call on scroll */
  load: PropTypes5.func.isRequired,
  /** Flag to indicate all items have been loaded  */
  isEndOfList: PropTypes5.bool.isRequired,
  /** Flag to indicate loading status */
  isLoading: PropTypes5.bool.isRequired,
  /** Buffer height controls how much scrolling must take place to trigger loading */
  bufferHeight: PropTypes5.number,
  /** A height is required to enable scrolling of interior content, can override the default of 100% */
  height: PropTypes5.string,
  children: PropTypes5.node.isRequired
};
ScrollLoader.defaultProps = {
  bufferHeight: 300,
  height: "100%"
};
var scroll_loader_view_default = ScrollLoader;

// src/components/spinner.view.js
import React9 from "react";
import { Image as Image2, genesisStyled as genesisStyled2 } from "@leagueplatform/genesis-commons";
import { useIntl } from "react-intl";
import Loading from "./assets/loading.png";
var SpinnerImage = genesisStyled2(Image2)`
  animation: rotate 1s ease-in-out infinite;
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
var Spinner = (props) => {
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ React9.createElement(
    SpinnerImage,
    __spreadValues({
      src: Loading,
      size: "two",
      alt: formatMessage({ id: "LOADING" }),
      "aria-live": "polite"
    }, props)
  );
};

// src/components/animated-league-logo.view.js
import React10 from "react";
import PropTypes6 from "prop-types";
import styled7, { keyframes as keyframes2 } from "styled-components";
var ANIMATION_DELAY_INCREMENT = 0.3;
function gridTemplatesForSquare(squareSize) {
  const pxValue = `${squareSize}px`;
  return `${pxValue} ${pxValue} ${pxValue}`;
}
var foldTheCube = keyframes2`
  0%, 10% {
    transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  }
  25%, 75% {
    transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  }
  90%, 100% {
    transform: perspective(140px) rotateX(0deg);
    opacity: 0;
  }
`;
var fadeIn2 = keyframes2`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
var Indicator = styled7.div`
  font-size: 10px;
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  transform: translateX(-50%);
  position: absolute;
  top: 0;
  left: 50%;
  display: grid;
  grid-template-columns: ${(props) => gridTemplatesForSquare(props.squareSize)};
  grid-template-rows: ${(props) => gridTemplatesForSquare(props.squareSize)};
  .square {
    position: relative;
    width: ${(props) => `${props.squareSize}px`};
    height: ${(props) => `${props.squareSize}px`};
  }
  .square:not(:first-child):not(:last-child) {
    grid-row: 2;
  }
  .square:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 102%; /* Fix misalignment issues caused by CSS transforms on Safari and Firefox */
    height: 102%; /* Fix misalignment issues caused by CSS transforms on Safari and Firefox */
    background-color: #501cd2;
    animation: ${foldTheCube} 2.4s infinite linear both;
    transform-origin: 50% 100%;
  }
  .square--accent:before {
    background: #98f9c7;
  }
  .s1 {
    grid-column: 2;
  }
  .s2 {
    left: ${(props) => `-${props.accentSquareMargin}px`};
    transform: rotateZ(-90deg) translateX(-0.5px);
  }
  .s4 {
    transform: rotateZ(90deg);
  }
  .s5 {
    grid-column: 2;
    grid-row: 3;
    top: ${(props) => `${props.accentSquareMargin}px`};
    transform: rotateZ(-180deg);
  }
  .s1:before {
    animation-delay: ${`${ANIMATION_DELAY_INCREMENT}s`};
  }
  .s2:before {
    animation-delay: ${`${ANIMATION_DELAY_INCREMENT * 4}s`};
  }
  .s3:before {
    animation: ${fadeIn2} ${`${ANIMATION_DELAY_INCREMENT}s`} linear 0s 1
      alternate;
  }
  .s4:before {
    animation-delay: ${`${ANIMATION_DELAY_INCREMENT * 2}s`};
  }
  .s5:before {
    animation-delay: ${`${ANIMATION_DELAY_INCREMENT * 3}s`};
  }
`;
var AnimatedLeagueLogo = (props) => {
  const { size } = props;
  const squareDimension = Math.round(size / 3);
  const accentSquareMargin = Math.round(squareDimension / 6);
  const adjustedIndicatorSize = squareDimension * 3;
  return /* @__PURE__ */ React10.createElement(
    Indicator,
    {
      size: adjustedIndicatorSize,
      squareSize: squareDimension,
      accentSquareMargin
    },
    /* @__PURE__ */ React10.createElement("div", { className: "square s1" }),
    /* @__PURE__ */ React10.createElement("div", { className: "square square--accent s2" }),
    /* @__PURE__ */ React10.createElement("div", { className: "square s3" }),
    /* @__PURE__ */ React10.createElement("div", { className: "square s4" }),
    /* @__PURE__ */ React10.createElement("div", { className: "square square--accent s5" })
  );
};
AnimatedLeagueLogo.propTypes = {
  /** Pixel value used for width and height */
  size: PropTypes6.number.isRequired
};
var animated_league_logo_view_default = AnimatedLeagueLogo;

// src/components/state-message/state-message.view.js
import React11 from "react";
import PropTypes7 from "prop-types";
import {
  HeadingOne,
  Image as Image3,
  Box as Box3,
  genesisStyled as genesisStyled3,
  HeadingFour
} from "@leagueplatform/genesis-commons";
var MessageContent = genesisStyled3(HeadingFour)`
  white-space: pre-wrap;
  max-width: 600px;
`;
var StateMessage = ({ icon, iconSize, title, message, children }) => {
  return /* @__PURE__ */ React11.createElement(Box3, { padding: "three", textAlign: "center" }, /* @__PURE__ */ React11.createElement(Image3, { src: icon, size: iconSize, role: "presentation" }), /* @__PURE__ */ React11.createElement(
    HeadingOne,
    {
      fontWeight: "medium",
      marginTop: "half",
      marginBottom: "one",
      color: "onSurface.text.subdued"
    },
    title
  ), /* @__PURE__ */ React11.createElement(
    MessageContent,
    {
      fontWeight: "normal",
      color: "onSurface.text.subdued",
      as: "h2"
    },
    message
  ), children && /* @__PURE__ */ React11.createElement(Box3, { marginTop: "two" }, children));
};
StateMessage.propTypes = {
  title: PropTypes7.oneOfType([PropTypes7.string, PropTypes7.node]).isRequired,
  message: PropTypes7.oneOfType([PropTypes7.string, PropTypes7.node]).isRequired,
  icon: PropTypes7.string.isRequired,
  iconSize: PropTypes7.string,
  children: PropTypes7.node
};
StateMessage.defaultProps = {
  iconSize: "100px",
  children: null
};
var state_message_view_default = StateMessage;

// src/components/backdrop.view.js
import React12, { PureComponent } from "react";
import PropTypes8 from "prop-types";
import { noop } from "lodash";
import { Flex, genesisStyled as genesisStyled4, css as css6 } from "@leagueplatform/genesis-commons";
var BackdropWrapper = genesisStyled4("div")(
  (props) => css6({
    transition: "0.3s opacity",
    opacity: props.isVisible ? 1 : 0,
    position: "relative",
    zIndex: props.zIndex
  })
);
var BackdropContainer = genesisStyled4(Flex)`
  ${fullScreen()};
  position: fixed;
  height: 100vh;
  background-color: ${hex2Rgba(vars.colour.black, 0.7)};
`;
var Backdrop = class extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
    this.onClick = this.onClick.bind(this);
  }
  componentDidMount() {
    this.setVisibile(true);
  }
  onClick(e) {
    const { onClose, closeOnChildrenClick } = this.props;
    if (!closeOnChildrenClick && e.target !== e.currentTarget) {
      return;
    }
    onClose(e);
  }
  setVisibile(isVisible) {
    this.setState({
      isVisible
    });
  }
  render() {
    const { children, className, zIndex } = this.props;
    const { isVisible } = this.state;
    return /* @__PURE__ */ React12.createElement(BackdropWrapper, { isVisible, zIndex }, /* @__PURE__ */ React12.createElement(
      BackdropContainer,
      {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        onClick: this.onClick,
        className
      },
      children
    ));
  }
};
Backdrop.defaultProps = {
  onClose: noop,
  className: null,
  closeOnChildrenClick: true,
  zIndex: 100
};
Backdrop.propTypes = {
  onClose: PropTypes8.func,
  children: PropTypes8.node.isRequired,
  className: PropTypes8.string,
  closeOnChildrenClick: PropTypes8.bool,
  zIndex: PropTypes8.number
};

// src/components/check-box/check-box.view.js
import React13 from "react";
import styled8, { css as css7 } from "styled-components";
import PropTypes9 from "prop-types";
import CheckedAsset from "./assets/checked.png";
var checkboxHeight = "20px";
var borderWidth = "2px";
var Container = styled8.div`
  label {
    ${horizontalBox()};
    ${flexAlign("center")};
  }

  input {
    display: none;
  }

  .icon {
    width: ${checkboxHeight};
    height: ${checkboxHeight};
    margin-right: ${spaceInPx(1)};
    background-color: ${colour("white")};
    border: ${borderWidth} solid ${colour("darkGrey")};
    border-radius: ${radiusInPx(2)};
  }

  &[data-align='right'] {
    .icon {
      order: 2;
      margin-right: 0;
      margin-left: ${spaceInPx(1)};
    }

    span {
      order: 1;
    }
  }

  input:checked + label {
    .icon {
      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-image: url(${CheckedAsset});
        ${bgImageContain()};
      }
    }
  }

  ${({ disabled }) => disabled && css7`
      pointer-events: none;
      label {
        pointer-events: none;
        color: ${colour("greyLight")};
      }
      .icon {
        opacity: 0.5;
        background-color: transparent;
      }
    `};
  ${({ error }) => error ? css7`
          .icon {
            border-color: ${colour("red")};
            background-color: ${colour("redLightest")};
          }
        ` : css7`
    &:hover .icon {
    border-color: ${colour("purpleLight")};
  `};
`;
var CheckBox = (props) => {
  const {
    inputClassName,
    children,
    boxAlign,
    checked,
    onChange,
    name,
    className,
    disabled,
    error
  } = props;
  const id = name || Date.now();
  return /* @__PURE__ */ React13.createElement(
    Container,
    {
      disabled,
      error,
      className: `${className} checkbox`,
      "data-align": boxAlign
    },
    /* @__PURE__ */ React13.createElement(
      "input",
      {
        onChange,
        id,
        type: "checkbox",
        checked,
        className: inputClassName,
        disabled
      }
    ),
    /* @__PURE__ */ React13.createElement("label", { htmlFor: id }, /* @__PURE__ */ React13.createElement("div", { className: "icon" }), /* @__PURE__ */ React13.createElement("span", null, children))
  );
};
CheckBox.propTypes = {
  inputClassName: PropTypes9.string,
  children: PropTypes9.node,
  boxAlign: PropTypes9.string,
  checked: PropTypes9.bool,
  onChange: PropTypes9.func,
  name: PropTypes9.string,
  className: PropTypes9.string,
  disabled: PropTypes9.bool,
  error: PropTypes9.bool
};
CheckBox.defaultProps = {
  inputClassName: "",
  children: null,
  name: void 0,
  boxAlign: "left",
  checked: false,
  onChange: () => {
  },
  className: "",
  disabled: false,
  error: false
};
var check_box_view_default = CheckBox;

// src/components/divider.view.js
import styled10, { css as css9 } from "styled-components";

// src/components/primitives.view.js
import styled9, { css as css8 } from "styled-components";

// src/utils/isProduction.ts
function isProduction() {
  return true;
}

// src/components/primitives.view.js
import {
  compose,
  space,
  width,
  color,
  fontSize,
  fontFamily,
  textAlign,
  lineHeight,
  fontWeight,
  letterSpacing,
  borders,
  boxShadow,
  alignSelf,
  flex as flex2,
  order,
  flexDirection,
  alignItems,
  justifyContent,
  flexWrap as flexWrap2
} from "styled-system-old";
var baseSystems = compose(
  space,
  width,
  color,
  fontSize,
  fontFamily,
  textAlign,
  lineHeight,
  fontWeight,
  letterSpacing,
  borders,
  boxShadow,
  alignSelf,
  flex2,
  order,
  flexDirection,
  alignItems,
  justifyContent,
  flexWrap2
);
var Box4 = styled9.div`
  box-sizing: border-box;
  ${baseSystems}
`;
Box4.displayName = "Box";
Box4.propTypes = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, space.propTypes), width.propTypes), color.propTypes), fontSize.propTypes), fontFamily.propTypes), textAlign.propTypes), lineHeight.propTypes), fontWeight.propTypes), letterSpacing.propTypes), borders.propTypes), boxShadow.propTypes), alignSelf.propTypes), flex2.propTypes), order.propTypes);
var Flex2 = styled9.div`
  display: flex;
  box-sizing: border-box;
  ${baseSystems}
`;
Flex2.displayName = "Flex";
Flex2.propTypes = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, Box4.propTypes), alignSelf.propTypes), order.propTypes), flexDirection.propTypes), alignItems.propTypes), justifyContent.propTypes), flexWrap2.propTypes);
var Fill = styled9(Box4)`
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
`;
Fill.displayName = "Fill";
var Fit = styled9(Box4)`
  flex: none;
`;
Fit.displayName = "Fit";
var InlineFlex = styled9(Flex2)`
  display: inline-flex;
`;
InlineFlex.displayName = "InlineFlex";
var Text = styled9.p`
  box-sizing: border-box;
  ${baseSystems}

  ${({ weight }) => {
  if (!weight)
    return null;
  if (!isProduction()) {
    console.warn(
      `Text component "weight" prop is deprecated, use styled system "fontWeight" instead! Got weight ${weight}.`
    );
  }
  return css8`
      font-weight: ${weight};
    `;
}};
  ${({ size }) => {
  if (!size)
    return null;
  if (!isProduction()) {
    console.warn(
      `Text component "size" prop is deprecated, use styled system "fontSize" instead! Got size ${size}.`
    );
  }
  return css8`
      font-size: ${size};
    `;
}};

  &:last-of-type {
    margin-bottom: 0;
  }
`;
Text.displayName = "Text";
Text.propTypes = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, space.propTypes), width.propTypes), color.propTypes), fontSize.propTypes), fontFamily.propTypes), textAlign.propTypes), lineHeight.propTypes), fontWeight.propTypes), letterSpacing.propTypes), borders.propTypes), boxShadow.propTypes), alignSelf.propTypes), flex2.propTypes), order.propTypes);

// src/components/divider.view.js
var Divider = styled10(Box4)`
  ${({ topBorder }) => topBorder && css9`
      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(
          to right,
          ${colour("white")},
          ${colour("navyLightest")} 20%,
          ${colour("navyLightest")} 80%,
          ${colour("white")}
        );
      }
    `};

  ${({ bottomBorder }) => bottomBorder && css9`
      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(
          to right,
          ${colour("white")},
          ${colour("navyLightest")} 20%,
          ${colour("navyLightest")} 80%,
          ${colour("white")}
        );
      }
    `};
`;

// src/components/alert.view.js
import React14 from "react";
import PropTypes10 from "prop-types";
import styled11 from "styled-components";
var Title = styled11.div`
  font-weight: 600;
  color: ${({ theme: theme2 }) => getColourObject(theme2).purple};
`;
var AlertWrapper = styled11.div`
  background-color: ${({ theme: theme2 }) => getColourObject(theme2).white};
  min-width: 40rem;
  max-width: 60rem;
  padding: 2rem;
  line-height: 1.4;
  box-shadow: 0.3rem 0.3rem 0 ${({ theme: theme2 }) => getColourObject(theme2).orangeRed};

  ${Title} {
    margin-bottom: 1.5rem;
    color: ${({ theme: theme2 }) => getColourObject(theme2).orangeRed};
  }
`;
var Alert = (_a) => {
  var props = __objRest(_a, []);
  const { title, children, onClose } = props;
  return /* @__PURE__ */ React14.createElement(Backdrop, { onClose }, /* @__PURE__ */ React14.createElement(AlertWrapper, null, title && /* @__PURE__ */ React14.createElement(Title, null, title), /* @__PURE__ */ React14.createElement("div", null, children)));
};
Alert.propTypes = {
  title: PropTypes10.string,
  children: PropTypes10.node,
  onClose: PropTypes10.func
};
Alert.defaultProps = {
  title: null,
  children: null,
  onClose: () => {
  }
};
var alert_view_default = Alert;

// src/components/form-stepper/form-stepper.view.js
import { throttle } from "lodash/fp";
import PropTypes11 from "prop-types";
import React15, { useEffect, useState } from "react";
import { Route, Switch, useRouteMatch } from "@leagueplatform/routing";
import styled12 from "styled-components";
var Container2 = styled12(Box4)`
  height: 100%;
  width: 100%;
`;
function FormStepper({
  routes,
  values,
  touched,
  errors,
  dirty,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  setFieldValue,
  handleReset,
  setFieldTouched,
  setFieldError
}) {
  const { path } = useRouteMatch();
  const [upcomingRoute, setUpcomingRoute] = useState(routes[0].path);
  const [backButtonPressed, setBackButtonPressed] = useState(false);
  useEffect(() => {
    const navigationListener = () => {
      throttle(
        250,
        () => {
          setBackButtonPressed(true);
          setUpcomingRoute(null);
        },
        { leading: true }
      );
    };
    window.addEventListener("popstate", navigationListener);
    return () => {
      window.removeEventListener("popstate", navigationListener);
    };
  });
  const changeRoute = (event, next) => {
    event.preventDefault();
    if (!backButtonPressed) {
      setUpcomingRoute(next);
    } else {
      setBackButtonPressed(false);
    }
  };
  function renderRoutes() {
    const routePaths = routes.map((route) => route.path);
    return routes.map((currentRoute, index) => {
      const limit = routes.length - 1;
      const back = index - 1 >= 0 ? index - 1 : 0;
      const next = index + 1 <= limit ? index + 1 : index;
      const Component3 = currentRoute.component;
      return /* @__PURE__ */ React15.createElement(
        Route,
        {
          exact: true,
          path: `${path}${currentRoute.path}`,
          key: currentRoute.path,
          render: (props) => /* @__PURE__ */ React15.createElement(
            Component3,
            __spreadProps(__spreadValues(__spreadValues({}, props), currentRoute.props), {
              routes,
              upcomingRoute,
              isBrowserBackButtonPressed: backButtonPressed,
              back: (event) => changeRoute(event, `${path}${routePaths[back]}`),
              advance: (event) => changeRoute(event, `${path}${routePaths[next]}`),
              values,
              touched,
              errors,
              dirty,
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
              setFieldTouched,
              setFieldError,
              handleSubmit,
              handleReset
            })
          )
        }
      );
    });
  }
  return /* @__PURE__ */ React15.createElement(Container2, null, /* @__PURE__ */ React15.createElement(Switch, null, renderRoutes(routes)));
}
FormStepper.propTypes = {
  routes: PropTypes11.arrayOf(
    PropTypes11.shape({
      path: PropTypes11.shape,
      component: PropTypes11.node
    })
  ),
  values: PropTypes11.shape({}).isRequired,
  touched: PropTypes11.shape({}).isRequired,
  errors: PropTypes11.shape({}).isRequired,
  dirty: PropTypes11.bool.isRequired,
  isSubmitting: PropTypes11.bool.isRequired,
  handleChange: PropTypes11.func.isRequired,
  handleBlur: PropTypes11.func.isRequired,
  handleSubmit: PropTypes11.func.isRequired,
  setFieldValue: PropTypes11.func.isRequired,
  handleReset: PropTypes11.func.isRequired,
  setFieldTouched: PropTypes11.func.isRequired,
  setFieldError: PropTypes11.func.isRequired
};
FormStepper.defaultProps = {
  routes: []
};
var form_stepper_view_default = FormStepper;

// src/components/click-eater/click-eater.view.js
import React16 from "react";
import PropTypes12 from "prop-types";
var ClickEater = (props) => {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  return /* @__PURE__ */ React16.createElement(Box4, __spreadProps(__spreadValues({}, rest), { onClick: (evt) => evt.stopPropagation() }), children);
};
ClickEater.propTypes = {
  children: PropTypes12.node.isRequired
};
var click_eater_view_default = ClickEater;

// src/molecules/image-viewer/image-viewer.view.js
import React19 from "react";
import PropTypes15 from "prop-types";
import { FontAwesomeIcon as FontAwesomeIcon2 } from "@fortawesome/react-fontawesome";
import { throttle as throttle2 } from "lodash/fp";

// src/molecules/image-viewer/image-viewer-buttons.view.js
import styled13 from "styled-components";
var ImageViewerButton = styled13.button`
  background-color: rgba(0, 0, 0, 0.5);
  border: 0;
  padding: 0;
  cursor: pointer;
  outline: 0;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;
ImageViewerButton.displayName = "ImageViewerButton";
var CloseButton = styled13(ImageViewerButton)`
  position: fixed;
  top: 0px;
  right: 0px;
  overflow: hidden;
  width: 4rem;
  height: 4rem;
  border-radius: 0 0 0 4rem;
  z-index: 1010;

  & > svg {
    position: relative;
    top: -4px;
    left: 8px;
  }
`;
CloseButton.displayName = "CloseButton";
var ActionButton = styled13(ImageViewerButton)`
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  line-height: 1;
`;
ActionButton.displayName = "ActionButton";

// src/molecules/image-viewer/image-viewer-toolbar.view.js
import React17 from "react";
import PropTypes13 from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled14 from "styled-components";
var Toolbar = styled14.div`
  width: 2rem;
  z-index: 1005;
  overflow: hidden;
  text-align: center;
  position: fixed;
  top: 5rem;
  right: 0.5rem;
`;
var ImageViewerToolbar = ({
  zoomIn,
  zoomOut,
  reset,
  rotateRight,
  rotateLeft,
  next,
  prev
}) => /* @__PURE__ */ React17.createElement(Toolbar, null, /* @__PURE__ */ React17.createElement(ActionButton, { onClick: zoomIn }, /* @__PURE__ */ React17.createElement(FontAwesomeIcon, { icon: "plus", color: "white" })), /* @__PURE__ */ React17.createElement(ActionButton, { onClick: zoomOut }, /* @__PURE__ */ React17.createElement(FontAwesomeIcon, { icon: "minus", color: "white" })), /* @__PURE__ */ React17.createElement(ActionButton, { onClick: prev }, /* @__PURE__ */ React17.createElement(FontAwesomeIcon, { icon: "arrow-left", color: "white" })), /* @__PURE__ */ React17.createElement(ActionButton, { onClick: reset }, /* @__PURE__ */ React17.createElement(FontAwesomeIcon, { icon: "history", color: "white" })), /* @__PURE__ */ React17.createElement(ActionButton, { onClick: next }, /* @__PURE__ */ React17.createElement(FontAwesomeIcon, { icon: "arrow-right", color: "white" })), /* @__PURE__ */ React17.createElement(ActionButton, { onClick: rotateLeft }, /* @__PURE__ */ React17.createElement(FontAwesomeIcon, { icon: "undo-alt", color: "white" })), /* @__PURE__ */ React17.createElement(ActionButton, { onClick: rotateRight }, /* @__PURE__ */ React17.createElement(FontAwesomeIcon, { icon: "redo-alt", color: "white" })));
ImageViewerToolbar.propTypes = {
  zoomIn: PropTypes13.func.isRequired,
  zoomOut: PropTypes13.func.isRequired,
  reset: PropTypes13.func.isRequired,
  rotateRight: PropTypes13.func.isRequired,
  rotateLeft: PropTypes13.func.isRequired,
  prev: PropTypes13.func.isRequired,
  next: PropTypes13.func.isRequired
};

// src/molecules/image-viewer/image-viewer-carousel.view.js
import React18 from "react";
import PropTypes14 from "prop-types";
import styled15 from "styled-components";
var Carousel = styled15.div`
  z-index: 1005;
  position: fixed;
  top: 0;
  ${(props) => props.isDragged ? `left: 0;` : `right: 0;`} margin: 0;
  width: ${(props) => props.width}px;
`;
var Image4 = styled15.img`
  position: absolute;
  width: 100%;
  transition-property: transform;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  box-shadow: -3px 4px 14px 3px
    ${({ theme: theme2 }) => getColourObject(theme2).greyLighter};
`;
function imageTransform(rotation, scale) {
  const deltaPercent = (1 - scale) * 100;
  const offsetX = deltaPercent * 0.5;
  const offsetY = deltaPercent * -0.5;
  return `translate(${offsetX}%, ${offsetY}%) scale(${scale}) rotate(${rotation}deg)`;
}
var ImageViewerCarousel = (_a) => {
  var _b = _a, {
    activeIndex,
    images,
    imageWidth,
    carouselRef,
    scale,
    rotation,
    handleMouseOut,
    handleMouseEnter,
    isDragged
  } = _b, props = __objRest(_b, [
    "activeIndex",
    "images",
    "imageWidth",
    "carouselRef",
    "scale",
    "rotation",
    "handleMouseOut",
    "handleMouseEnter",
    "isDragged"
  ]);
  return /* @__PURE__ */ React18.createElement(
    Carousel,
    __spreadProps(__spreadValues({}, props), {
      width: imageWidth,
      ref: carouselRef,
      isDragged
    }),
    images.map((src, idx) => ({
      id: `${src}-${idx}`,
      src
    })).map((img) => {
      return /* @__PURE__ */ React18.createElement(
        Image4,
        {
          key: `carousel-image-${img.id}`,
          style: {
            transform: imageTransform(rotation, scale),
            display: img.src === images[activeIndex] ? "block" : "none"
          },
          onMouseOut: handleMouseOut,
          onMouseEnter: handleMouseEnter,
          src: img.src,
          draggable: false
        }
      );
    })
  );
};
var ImageViewerCarouselPropTypes = {
  visible: PropTypes14.bool,
  activeIndex: PropTypes14.number,
  images: PropTypes14.arrayOf(PropTypes14.string).isRequired,
  imageWidth: PropTypes14.number.isRequired
};
ImageViewerCarousel.propTypes = __spreadValues({
  scale: PropTypes14.number.isRequired,
  rotation: PropTypes14.number.isRequired,
  carouselRef: PropTypes14.func.isRequired,
  handleMouseOut: PropTypes14.func.isRequired,
  handleMouseEnter: PropTypes14.func.isRequired
}, ImageViewerCarouselPropTypes);

// src/molecules/image-viewer/image-viewer.view.js
var ImageViewer = class extends React19.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      scale: 1,
      rotation: 0,
      isDragged: false,
      initDistanceTop: 0,
      initDistanceLeft: 0,
      positionLeft: null,
      positionTop: 0
    });
    __publicField(this, "onZoom", (direction) => {
      this.setState((state) => ({
        scale: Math.max(0.125, state.scale + direction * 0.025)
      }));
    });
    __publicField(this, "onReset", () => {
      this.setState({ scale: 1, rotation: 0, isDragged: false });
    });
    __publicField(this, "getStyle", (left) => left === null ? { top: "0px", right: "0px" } : {
      top: `${this.state.positionTop}px`,
      left: `${this.state.positionLeft}px`
    });
    __publicField(this, "handleStartDrag", (e) => {
      this.dragging = true;
      const bound = this.carouselRef.getBoundingClientRect();
      this.setState(() => ({
        initDistanceTop: e.clientY - bound.top,
        initDistanceLeft: e.clientX - bound.left
      }));
    });
    __publicField(this, "handleDrag", throttle2(50, (e) => {
      if (this.dragging) {
        this.setState(() => ({
          positionTop: e.clientY - this.state.initDistanceTop,
          positionLeft: e.clientX - this.state.initDistanceLeft,
          isDragged: true
        }));
      }
    }));
    __publicField(this, "handleResize", () => {
      if (this.carouselRef && window.innerWidth <= this.carouselRef.getBoundingClientRect().right) {
        this.setState(() => ({
          positionLeft: window.innerWidth - this.carouselRef.offsetWidth
        }));
      }
    });
    __publicField(this, "handleDrop", () => {
      this.dragging = false;
    });
    __publicField(this, "handleMouseEnter", () => {
      this.carouselRef.addEventListener("wheel", this.handleMouseScroll);
      document.body.style.overflow = "hidden";
    });
    __publicField(this, "handleMouseOut", () => {
      this.carouselRef.removeEventListener("wheel", this.handleMouseScroll);
      document.body.style.overflow = "auto";
    });
    __publicField(this, "handleMouseScroll", throttle2(50, (e) => {
      let direction = 0;
      if (e.wheelDelta) {
        direction = e.wheelDelta > 0 ? 1 : -1;
      } else if (e.detail) {
        direction = e.detail > 0 ? 1 : -1;
      }
      if (direction !== 0) {
        this.onZoom(direction);
      }
    }));
    __publicField(this, "handleChange", (direction) => {
      const { activeIndex, images } = this.props;
      const index = (activeIndex + images.length + direction) % images.length;
      if (index !== activeIndex) {
        this.props.onChange(index);
        this.onReset();
      }
    });
  }
  componentDidMount() {
    this.carouselRef.addEventListener("mousedown", this.handleStartDrag);
    document.addEventListener("mouseup", this.handleDrop);
    document.addEventListener("mousemove", this.handleDrag);
    window.addEventListener("resize", this.handleResize);
  }
  onRotate(direction = 1) {
    this.setState((state) => ({
      rotation: state.rotation + 90 * direction
    }));
  }
  render() {
    const _a = this.props, { onClose, onChange, activeIndex } = _a, carouselProps = __objRest(_a, ["onClose", "onChange", "activeIndex"]);
    const { scale, rotation, isDragged, positionLeft } = this.state;
    return /* @__PURE__ */ React19.createElement("div", null, /* @__PURE__ */ React19.createElement(CloseButton, { onClick: onClose }, /* @__PURE__ */ React19.createElement(FontAwesomeIcon2, { icon: "times", color: "white" })), /* @__PURE__ */ React19.createElement(
      ImageViewerCarousel,
      __spreadProps(__spreadValues({
        carouselRef: (el) => {
          this.carouselRef = el;
        },
        handleMouseOut: this.handleMouseOut,
        handleMouseEnter: this.handleMouseEnter,
        scale,
        rotation,
        activeIndex
      }, carouselProps), {
        style: this.getStyle(positionLeft),
        isDragged
      })
    ), /* @__PURE__ */ React19.createElement(
      ImageViewerToolbar,
      {
        zoomIn: () => this.onZoom(2),
        zoomOut: () => this.onZoom(-2),
        reset: this.onReset,
        rotateRight: () => this.onRotate(1),
        rotateLeft: () => this.onRotate(-1),
        next: () => this.handleChange(1),
        prev: () => this.handleChange(-1)
      }
    ));
  }
};
ImageViewer.propTypes = __spreadValues({
  onClose: PropTypes15.func.isRequired,
  onChange: PropTypes15.func.isRequired
}, ImageViewerCarouselPropTypes);

// src/components/input/input.view.js
import styled16, { css as css10 } from "styled-components";
import ValidIcon from "./assets/valid-icon.svg";
import ErrorIcon from "./assets/error-icon.svg";
var Input = styled16.input`
  ${leagueFont()};
  font-size: ${fontSizeInPx(2)};
  height: 45px;
  padding: 0 ${spaceInPx(2)};
  border: 1px solid ${colour("neutral.grayLight")};
  border-radius: ${radiusInPx(2)};
  background-position: right 1rem top 50%;
  background-size: 20px;
  background-repeat: no-repeat;
  outline: none;
  transition: all 200ms ease-out;
  ${({ fit }) => fit && `width: 100%;`};
  ${({ isValid: isValid2 }) => isValid2 && `background-image: url(${ValidIcon})`};
  ${({ hasError }) => hasError && css10`
      background-image: url(${ErrorIcon});
      border-color: ${colour("red")};
    `};
  &[disabled] {
    color: ${colour("grey")};
    background-color: ${colour("greyLightest")};
  }
  &:focus {
    border-color: ${colour("purple")};
  }
  &::placeholder {
    color: ${colour("neutral.gray")};
  }
`;
Input.displayName = "Input";

// src/components/image-input/multiple-image-input.view.js
import React20 from "react";
import styled17 from "styled-components";
import PropTypes16 from "prop-types";
import { noop as noop2, identity } from "lodash";
import {
  fileReader,
  isImageContentType,
  IDENTIFICATION
} from "@leagueplatform/web-common";
import PDF_ICON from "./assets/pdf-icon.svg";
import FILE_ICON from "./assets/file-icon.svg";
import PLUS_ICON from "./assets/plus-icon.svg";
import { FormattedMessage, useIntl as useIntl2 } from "react-intl";
var InputWrapper = styled17(Flex2)`
  justify-content: center;
  width: 100%;
`;
var inputDefaultStyle = {
  width: "0.1vw",
  height: "01.vw",
  border: "none",
  opacity: 0,
  position: "fixed",
  left: "-200%"
};
var PDFPlaceholder = styled17(Box4)`
  height: 162px;
  background: url(${PDF_ICON}) no-repeat center/35px ${vars.colour.offWhite};
`;
var ImageRemovalLink = styled17(Flex2)`
  background: #fff;
  color: ${vars.colour.red};
  padding: 10px;
  position: absolute;
  bottom: 0;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 100%;
  cursor: pointer;
  font-weight: 500;
`;
var PreviewContainer = styled17(Box4)`
  position: relative;
  border: 1px solid ${vars.colour.greyLight};
  margin-bottom: 10px;
  cursor: pointer;
  background: url(${FILE_ICON}) no-repeat center/35px ${vars.colour.offWhite};
`;
var Images = styled17(Flex2)`
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  padding: 2px;
`;
var CrossSymbol = styled17(Flex2)`
  font-size: 30px;
  margin-right: 5px;
  padding-bottom: 5px;
`;
var FileInput = styled17(Flex2)`
  flex-direction: column;
  width: 100%;
  min-height: 162px;
  padding: 26px;
  margin-bottom: 10px;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  border: 1px dashed ${vars.colour.purple};
  &:focus {
    outline: none;
  }
  ${({ hasError }) => hasError && `border-color: ${vars.colour.red};
    background-color: ${vars.colour.redLightest}`};
`;
var UploadTitle = styled17(Box4)`
  color: ${vars.colour.purple};
  font-size: 14px;
  padding: 10px;
`;
var WarningBanner = styled17(Box4)`
  background: ${vars.colour.flushOrangeLight};
  color: ${vars.colour.black};
  padding: 6px 12px;
  font-size: 12px;
  line-height: 24px;
  border-radius: 3px;
  margin-bottom: 16px;
`;
var UploadIcon = () => {
  const { formatMessage } = useIntl2();
  return /* @__PURE__ */ React20.createElement(
    "img",
    {
      height: "30",
      src: PLUS_ICON,
      alt: formatMessage({
        id: "UPLOAD_DOCUMENT"
      })
    }
  );
};
var MultipleImageInput = class extends React20.Component {
  constructor(props) {
    super(props);
    this.fileInputs = [];
    this.focusInput = this.focusInput.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
    this.updateBoxArray = this.updateBoxArray.bind(this);
    this.addBox = this.addBox.bind(this);
    this.removeBox = this.removeBox.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.setImageUrl = this.setImageUrl.bind(this);
    this.state = {
      error: false,
      boxes: [],
      maxBoxCount: this.props.documentType === IDENTIFICATION ? 2 : 10
    };
    const numInputs = this.props.contentUrls.length;
    for (let i = 0; i < numInputs; i += 1) {
      this.fileInputs.push(React20.createRef());
      this.state.boxes.push({
        imageUrl: this.props.isEditing ? this.props.contentUrls[i] : null,
        isImage: !!this.props.isEditing,
        id: i,
        inputFocused: false,
        hasFile: !!this.props.isEditing,
        file: null,
        contentId: this.props.isEditing ? this.props.contentIds[i] : null
      });
    }
  }
  componentDidMount() {
    this.addBox();
    this.updateBoxArray();
  }
  // this is necessary or else the componenet will keep updating in any
  // form that it is in, resulting in massive input delay
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.boxes !== this.state.boxes || nextProps.documentType !== this.props.documentType || nextState.maxBoxCount !== this.state.maxBoxCount) {
      return true;
    }
    return false;
  }
  // disabling linter so can use setState in componentDidUpdate
  // it's a safe usage bc setState is in a condition everytime
  /* eslint-disable react/no-did-update-set-state, react/no-access-state-in-setstate */
  componentDidUpdate() {
    if (this.props.documentType === IDENTIFICATION && this.state.boxes.length > 2) {
      const updateBox = this.state.boxes.slice(0, 2);
      this.setState({
        boxes: updateBox,
        maxBoxCount: 2
      });
    } else if (
      // switched from ID and had a completely filled out set of boxes
      this.props.documentType !== IDENTIFICATION && this.state.boxes.length > 0 && this.state.boxes[this.state.boxes.length - 1].hasFile
    ) {
      this.setState({ maxBoxCount: 10 }, this.addBox());
    }
  }
  onFileChange(i) {
    const file = this.fileInputs[i].current.files[0];
    const { previewOnChange, onFilePreviewError, setFieldError } = this.props;
    setFieldError("file", null);
    if (file) {
      if (previewOnChange) {
        fileReader.toDataUrl(file).then((dataUrl) => {
          const updateBox = this.state.boxes.map((b) => {
            if (b.id === i) {
              return __spreadProps(__spreadValues({}, b), {
                imageUrl: dataUrl,
                isImage: isImageContentType(file.type),
                hasFile: true,
                file
              });
            }
            return b;
          });
          this.setState(
            {
              boxes: updateBox
            },
            () => {
              this.updateBoxArray();
              this.addBox();
            }
          );
        }).catch((error) => {
          onFilePreviewError({ error });
          this.setState({
            error: true
          });
        });
      }
    }
  }
  onInputFocus(i) {
    const updateBox = this.state.boxes.map((b) => {
      if (b.id === i) {
        return __spreadProps(__spreadValues({}, b), {
          inputFocused: true
        });
      }
      return b;
    });
    this.setState({
      boxes: updateBox
    });
  }
  onInputBlur(i) {
    const updateBox = this.state.boxes.map((b) => {
      if (b.id === i) {
        return __spreadProps(__spreadValues({}, b), {
          inputFocused: false
        });
      }
      return b;
    });
    this.setState({
      boxes: updateBox
    });
  }
  setImageUrl(imageUrl, i) {
    const updateBox = this.state.boxes.map((b) => {
      if (b.id === i) {
        return __spreadProps(__spreadValues({}, b), {
          imageUrl
        });
      }
      return b;
    });
    this.setState({
      boxes: updateBox
    });
  }
  setError(error) {
    this.setState({
      error
    });
  }
  // This function should be called everytime the state of the
  // boxes change since it sets the field value of the form
  // Otherwise, when user clicks submit, may not be submitting
  // the images in the boxes
  updateBoxArray() {
    const { onFilePreviewSuccess, documentType } = this.props;
    const { boxes } = this.state;
    const multInputData = boxes.filter((box) => box.imageUrl).map((box) => {
      return { file: box.file, contentId: box.contentId };
    });
    if (documentType === IDENTIFICATION && boxes.length > 3) {
      onFilePreviewSuccess(multInputData.slice(0, 2));
    } else {
      onFilePreviewSuccess(multInputData);
    }
  }
  addBox() {
    const { boxes, maxBoxCount } = this.state;
    if (boxes.length < maxBoxCount) {
      this.fileInputs.push(React20.createRef());
      this.setState({
        boxes: [
          ...this.state.boxes,
          {
            imageUrl: null,
            isImage: false,
            id: this.state.boxes.length,
            inputFocused: false,
            hasFile: false,
            file: null,
            contentId: null
          }
        ]
      });
    }
  }
  removeBox(index) {
    const updateBox = this.state.boxes.filter((box) => box.id !== index);
    updateBox.map((box) => {
      const b = box;
      if (box.id > index) {
        b.id -= 1;
      }
      return b;
    });
    this.fileInputs = this.fileInputs.filter(
      (input, inputIndex) => inputIndex !== index
    );
    this.setState(
      {
        boxes: updateBox
      },
      () => {
        if (updateBox[updateBox.length - 1].hasFile) {
          this.addBox();
        }
        this.updateBoxArray();
      }
    );
  }
  focusInput(i) {
    this.fileInputs[i].current.click();
  }
  render() {
    const { boxes } = this.state;
    const {
      inputStyle,
      width: width2,
      height,
      handleBlur,
      touched,
      errors,
      viewFile,
      documentType
    } = this.props;
    return /* @__PURE__ */ React20.createElement(Box4, null, documentType === IDENTIFICATION && /* @__PURE__ */ React20.createElement(WarningBanner, null, /* @__PURE__ */ React20.createElement(FormattedMessage, { id: "IDENTIFICATION_TYPE_TWO_FILES" })), /* @__PURE__ */ React20.createElement(Images, null, boxes.map((box) => {
      return /* @__PURE__ */ React20.createElement(
        Flex2,
        {
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: width2,
          key: box.id
        },
        /* @__PURE__ */ React20.createElement(
          InputWrapper,
          {
            className: box.inputFocused ? "input-focused " : ""
          },
          /* @__PURE__ */ React20.createElement(
            "input",
            {
              type: "file",
              accept: "image/*, .pdf",
              tabIndex: "0",
              name: "file-input",
              ref: this.fileInputs[box.id],
              style: inputStyle,
              onChange: () => {
                this.onFileChange(box.id);
              }
            }
          ),
          box.imageUrl && /* @__PURE__ */ React20.createElement(
            PreviewContainer,
            {
              onClick: () => {
                viewFile == null ? void 0 : viewFile(box.imageUrl);
              }
            },
            box.isImage ? /* @__PURE__ */ React20.createElement(
              Image,
              {
                onClick: () => {
                  this.focusInput(box.id);
                },
                url: box.imageUrl,
                backgroundSize: "cover",
                backgroundPosition: "top",
                width: width2,
                height
              }
            ) : /* @__PURE__ */ React20.createElement(PDFPlaceholder, { width: width2 }),
            /* @__PURE__ */ React20.createElement(
              ImageRemovalLink,
              {
                onClick: (e) => {
                  e.stopPropagation();
                  this.removeBox(box.id);
                }
              },
              /* @__PURE__ */ React20.createElement(CrossSymbol, null, "\xD7"),
              /* @__PURE__ */ React20.createElement(FormattedMessage, { id: "REMOVE" })
            )
          ),
          !box.imageUrl && /* @__PURE__ */ React20.createElement(
            Box4,
            {
              width: "100%",
              onClick: () => {
                this.focusInput(box.id);
              }
            },
            /* @__PURE__ */ React20.createElement(
              FileInput,
              {
                onBlur: handleBlur,
                hasError: touched.file && errors.file,
                tabIndex: box.id
              },
              /* @__PURE__ */ React20.createElement(UploadIcon, null),
              /* @__PURE__ */ React20.createElement(UploadTitle, null, box.id === 0 ? /* @__PURE__ */ React20.createElement(FormattedMessage, { id: "DRAG_OR_UPLOAD_PHOTO" }) : /* @__PURE__ */ React20.createElement(FormattedMessage, { id: "ADD_IMAGE" }))
            )
          )
        )
      );
    })));
  }
};
MultipleImageInput.propTypes = {
  onFilePreviewSuccess: PropTypes16.func,
  onFilePreviewError: PropTypes16.func,
  inputStyle: PropTypes16.shape({
    height: PropTypes16.string,
    widgth: PropTypes16.string
  }),
  height: PropTypes16.string,
  width: PropTypes16.string,
  previewOnChange: PropTypes16.bool,
  contentIds: PropTypes16.arrayOf(PropTypes16.string),
  contentUrls: PropTypes16.arrayOf(PropTypes16.string),
  handleBlur: PropTypes16.func.isRequired,
  touched: PropTypes16.shape({
    documentType: PropTypes16.bool,
    name: PropTypes16.bool,
    documentTypeOtherDescription: PropTypes16.bool,
    file: PropTypes16.bool
  }),
  errors: PropTypes16.shape({
    documentType: PropTypes16.bool,
    name: PropTypes16.bool,
    documentTypeOtherDescription: PropTypes16.bool,
    file: PropTypes16.bool
  }),
  viewFile: PropTypes16.func,
  isEditing: PropTypes16.bool.isRequired,
  setFieldError: PropTypes16.func,
  documentType: PropTypes16.string.isRequired
};
MultipleImageInput.defaultProps = {
  inputStyle: inputDefaultStyle,
  onFilePreviewSuccess: noop2,
  onFilePreviewError: noop2,
  previewOnChange: false,
  contentIds: [],
  contentUrls: [],
  width: "100%",
  height: "100%",
  touched: {},
  errors: {},
  viewFile: identity,
  setFieldError: noop2
};

// src/components/label/label.view.js
import React21 from "react";
import PropTypes17 from "prop-types";
import styled18 from "styled-components";
var StyledLabel = styled18.label`
  margin-top: 2rem;
  font-size: ${fontSizeInPx(2)};
  font-weight: 500;
  color: ${colour("purpleText")};
  input {
    display: ${(props) => props.inline ? "inline-block" : "block"};
    margin-left: ${(props) => props.inline ? "0.5rem" : "0"};
  }
`;
var Label = (_a) => {
  var _b = _a, { children, inline, htmlFor } = _b, props = __objRest(_b, ["children", "inline", "htmlFor"]);
  return /* @__PURE__ */ React21.createElement(StyledLabel, __spreadProps(__spreadValues({}, props), { inline, htmlFor }), children);
};
Label.propTypes = {
  children: PropTypes17.node.isRequired,
  inline: PropTypes17.bool,
  htmlFor: PropTypes17.string.isRequired
};
Label.defaultProps = {
  inline: false
};

// src/components/textarea.view.js
import styled19 from "styled-components";
import { space as space2 } from "styled-system-old";
var Textarea = styled19.textarea`
  ${leagueFont()};
  min-height: 4.5rem;
  padding: ${spaceInPx(1)};
  ${({ fit }) => fit && `width: 100%`};
  border: 1px solid
    ${(props) => props.error ? colour("red") : colour("greyLight")};
  border-radius: ${radiusInPx(2)};
  ${space2}
`;
Textarea.displayName = "Textarea";

// src/components/select/select.view.js
import React22 from "react";
import PropTypes18 from "prop-types";
import styled20, { css as css11 } from "styled-components";
import { Select as ReactResponsiveSelect } from "react-responsive-select";
import { isUndefined, isNull } from "lodash";
import "react-responsive-select/dist/react-responsive-select.css";
import { has } from "lodash";
import { FontAwesomeIcon as FontAwesomeIcon3 } from "@fortawesome/react-fontawesome";
import { useTheme } from "@leagueplatform/genesis-commons";
var isEmptyString = (value) => typeof value === "string" && value.replace(/\s/g, "").length === 0;
var isEmptyOrUndefined = (value) => isEmptyString(value) || isNull(value) || isUndefined(value);
var SelectContainer = styled20(Box4).attrs({ my: 2, w: 1 })`
  .rrs {
    position: relative;

    .rrs__button {
      height: ${({ height }) => height || "45px"};
    }

    .rrs__button,
    .rrs__button + .rrs__options {
      box-shadow: none;
    }

    .rrs__label {
      border: 1px solid
        ${({ borderColor: borderColor2 }) => borderColor2 || colour("neutral.grayLight")};
      border-radius: ${radiusInPx(2)};
      line-height: ${({ lineHeight: lineHeight2 }) => lineHeight2 || "43px"};
      ${({ hasError }) => hasError && css11`
          border-color: ${({ errorBorderColor }) => errorBorderColor || colour("red")};
          background-color: ${({ errorBackgroundColor }) => errorBackgroundColor || colour("redLightest")};
        `};
      padding: 0 36px 0 16px;
      .svg-inline--fa {
        position: absolute;
        right: 16px;
        top: calc(50% - 7px);
        color: ${colour("neutral.gray")};
        transition: all 200ms ease-out;
      }
    }

    .rrs__button--disabled {
      background-color: ${({ disabledBackgroundColor }) => disabledBackgroundColor || colour("greyLightest")};
      .rrs__label {
        border: 1px solid
          ${({ disabledBorderColor }) => disabledBorderColor || colour("greyLighter")};
      }
    }

    &.rrs--options-visible .rrs__label,
    .rrs__button:focus:not(.rrs__button--disabled) .rrs__label,
    .rrs__button + .rrs__options {
      border-color: ${({ focusBorderColor }) => focusBorderColor || colour("purple")};
    }

    .rrs__button + .rrs__options {
      border-top: none;
      top: 43px;
    }

    &.rrs--options-visible .svg-inline--fa {
      transform: rotate(180deg);
    }

    .rrs__option {
      padding: 18px 16px;
      color: ${({ color: color2 }) => color2 || colour("purpleDarkest")};
      ${({ optionLineHeight }) => css11`
          line-height: ${optionLineHeight};
        `};
      &--selected,
      &--selected.rss__option--next-selection {
        background-color: ${({ selectedOptionBackgroundColor }) => selectedOptionBackgroundColor || colour("purpleLightest")};
      }
      &:focus {
        outline: 1px solid
          ${({ optionFocusBorderColor }) => optionFocusBorderColor || colour("greyLightest")};
      }

      &:hover:not(.rrs__option--selected),
      &--next-selection:not(.rrs__option--selected) {
        background-color: ${({ disabledBackgroundColor }) => disabledBackgroundColor || colour("greyLightest")};
      }
    }

    .rrs__label__text {
      flex-grow: 1;
      ${(props) => !has(props, "selectedValue") || !isEmptyOrUndefined(props.selectedValue) ? css11`
              color: ${props.color || colour("navyDark")};
            ` : css11`
              color: ${props.placeholderColor || colour("neutral.gray")};
              font-weight: 300;
            `};
    }

    ${({ width: width2 }) => width2 && css11`
        width: ${width2};

        > .rrs .rrs__button {
          z-index: 3;
        }

        > .rrs .rrs__label {
          padding-right: 35px;
        }

        > .rrs .rrs__label__text {
          overflow: hidden;
          text-overflow: ellipsis;
        }

        > .rrs.rrs--options-visible {
          .rrs__label {
            border-bottom: 1px solid transparent;
          }

          .rrs__button + .rrs__options {
            border-top-color: ${({ focusBorderColor }) => focusBorderColor || colour("purple")};
          }
        }

        > .rrs .rrs__button + .rrs__options {
          border-top-width: 1px;
          border-top-style: solid;
        }

        > .rrs .rrs__options {
          width: initial;
          top: initial;
          min-width: 200px;
        }

        > .rrs .rrs__option {
          white-space: nowrap;
          width: 100%;
          position: relative;
        }
      `};
  }
`;
var Select = (_a) => {
  var _b = _a, { asGenesis } = _b, props = __objRest(_b, ["asGenesis"]);
  const { colors, space: space3 } = useTheme();
  const genesisStyleProps = asGenesis ? {
    height: "48px",
    lineHeight: "46px",
    optionLineHeight: `${space3.one}px`,
    color: colors.text.primary,
    placeholderColor: colors.text.input.placeholder,
    disabledColor: colors.text.input.disabled,
    borderColor: colors.border.input.default,
    focusBorderColor: colors.text.input.defaultOnFocus,
    errorBorderColor: colors.text.input.danger,
    optionFocusBorderColor: colors.border.input.disabled,
    disabledBorderColor: colors.border.input.disabled,
    errorBackgroundColor: colors.lightPalette.white,
    disabledBackgroundColor: colors.background.input.disabled,
    selectedOptionBackgroundColor: colors.background.primaryHighlight
  } : null;
  return /* @__PURE__ */ React22.createElement(SelectContainer, __spreadValues(__spreadValues({}, genesisStyleProps), props), /* @__PURE__ */ React22.createElement(
    ReactResponsiveSelect,
    __spreadProps(__spreadValues({}, props), {
      caretIcon: /* @__PURE__ */ React22.createElement(FontAwesomeIcon3, { icon: "chevron-down" })
    })
  ));
};
Select.propTypes = {
  asGenesis: PropTypes18.bool
};
Select.defaultProps = {
  asGenesis: false
};

// src/components/radio/radio.view.js
import React23, { Component as Component2 } from "react";
import PropTypes19 from "prop-types";
import styled21 from "styled-components";
import { keys, pick } from "lodash";
var RadioContainer = styled21(Flex2)`
  cursor: ${({ disabled }) => disabled ? `auto` : "pointer"};

  && {
    label {
      cursor: ${({ disabled }) => disabled ? `auto` : "pointer"};
      margin: 0 0 0 1.6rem;
    }
  }
`;
var RADIO_BUTTON = "radio-button";
var DISABLED = "disabled";
var FOCUSED = "focused";
var ERROR = "error";
var getClassNames = (props) => keys(props).reduce(
  (classNames, key) => {
    switch (key) {
      case ERROR:
      case DISABLED:
        return props[key] === true ? [...classNames, key] : classNames;
      case FOCUSED:
        return props[key] === true ? [...classNames, `${RADIO_BUTTON}--${FOCUSED}`] : classNames;
      default:
        return classNames;
    }
  },
  [RADIO_BUTTON]
).join(" ");
var Radio = class extends Component2 {
  constructor(props) {
    super(props);
    this.input = React23.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
    this.state = {
      checked: props.checked,
      focused: false
    };
  }
  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      checked: newProps.checked
    });
  }
  onInputFocus() {
    this.setState({
      focused: true
    });
  }
  onInputBlur() {
    this.setState({
      focused: false
    });
  }
  handleClick() {
    this.input.current.click();
  }
  render() {
    const _a = this.props, {
      id,
      name,
      onChange,
      children,
      disabled,
      value,
      flexDirection: flexDirection2,
      className,
      justify: justify,
      error: error
    } = _a, otherProps = __objRest(_a, [
      "id",
      "name",
      "onChange",
      "children",
      "disabled",
      "value",
      "flexDirection",
      "className",
      // below props are destructured to omit passing to `otherProps`
      "justify",
      // eslint-disable-line
      "error"
    ]);
    const { checked } = this.state;
    return /* @__PURE__ */ React23.createElement(
      RadioContainer,
      {
        onClick: this.handleClick,
        flexDirection: flexDirection2,
        alignItems: "center",
        className: `${className} ${getClassNames(
          pick(__spreadValues(__spreadValues({}, this.props), this.state), [DISABLED, FOCUSED, ERROR])
        )}`,
        disabled
      },
      /* @__PURE__ */ React23.createElement(
        "input",
        __spreadProps(__spreadValues({}, otherProps), {
          type: "radio",
          id,
          name,
          value: value || name,
          checked,
          onChange,
          onFocus: this.onInputFocus,
          onBlur: this.onInputBlur,
          ref: this.input,
          disabled
        })
      ),
      children
    );
  }
};
Radio.propTypes = {
  id: PropTypes19.string.isRequired,
  name: PropTypes19.string.isRequired,
  onChange: PropTypes19.func.isRequired,
  checked: PropTypes19.bool,
  children: PropTypes19.node,
  disabled: PropTypes19.bool,
  error: PropTypes19.bool,
  value: PropTypes19.oneOfType([
    PropTypes19.string,
    PropTypes19.number,
    PropTypes19.bool
  ]),
  flexDirection: PropTypes19.string,
  justify: PropTypes19.string,
  className: PropTypes19.string
};
Radio.defaultProps = {
  children: null,
  checked: false,
  disabled: false,
  value: null,
  flexDirection: "row",
  justify: "flex-start",
  className: "",
  error: false
};

// src/components/radio/radio-group.view.js
import React24 from "react";
import PropTypes20 from "prop-types";
var RadioGroup = ({
  radioGroupLabel,
  flexDirection: flexDirection2,
  align,
  justify,
  children
}) => /* @__PURE__ */ React24.createElement(
  Flex2,
  {
    flexDirection: flexDirection2,
    alignItems: align,
    justifyContent: justify,
    "aria-labelledby": radioGroupLabel,
    role: "radiogroup"
  },
  children
);
RadioGroup.propTypes = {
  radioGroupLabel: PropTypes20.string.isRequired,
  children: PropTypes20.node.isRequired,
  flexDirection: PropTypes20.string,
  align: PropTypes20.string,
  justify: PropTypes20.string
};
RadioGroup.defaultProps = {
  flexDirection: "column",
  align: "auto",
  justify: "auto"
};

// src/components/message.view.js
import styled22 from "styled-components";
var Message = styled22(Box4).attrs({
  fontSize: 2,
  p: 1,
  borderWidth: "0.1rem",
  borderStyle: "solid"
})`
  border-color: ${({ theme: theme2 }) => hex2Rgba(getColourObject(theme2).ocean, 0.5)};
  color: ${({ theme: theme2 }) => getColourObject(theme2).black};
  background-color: ${({ theme: theme2 }) => hex2Rgba(getColourObject(theme2).ocean, 0.15)};
`;
Message.displayName = "Message";
var message_view_default = Message;

// src/components/error-message.js
import styled23 from "styled-components";
var ErrorMessage = styled23(Box4).attrs({
  fontSize: 2,
  p: 1,
  borderWidth: "0.1rem",
  borderColor: hex2Rgba(vars.colour.orangeRed, 0.5),
  borderStyle: "solid"
})`
  color: ${vars.colour.black};
  background-color: ${hex2Rgba(vars.colour.orangeRed, 0.15)};
`;
ErrorMessage.displayName = "ErrorMessage";
var error_message_default = ErrorMessage;

// src/components/table.view.js
import styled24 from "styled-components";
var Table = styled24.table`
  table-layout: fixed;
  width: 100%;

  thead {
    background-color: ${({ theme: theme2 }) => getColourObject(theme2).greyLightest};
    color: ${({ theme: theme2 }) => getColourObject(theme2).grey};
    padding: 1rem 0;
    text-transform: uppercase;
    font-size: 1.3rem;
    font-weight: 500;
  }

  tr {
    border-bottom: 1px solid
      ${({ theme: theme2 }) => getColourObject(theme2).greyLighter};
  }

  td {
    padding: 0.8rem 0 0.8rem 1rem;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  th {
    padding: 2.4em 0 2.4em 1rem;
    text-align: left;
  }

  th:nth-child(1) {
    border-radius: 0.3rem 0 0 0;
  }

  th:nth-last-child(1) {
    border-radius: 0 0.3rem 0 0;
  }
`;

// src/components/tooltip/tooltip.view.js
import React25, { useState as useState2, useEffect as useEffect2, useRef, useCallback } from "react";
import PropTypes21 from "prop-types";
import { noop as noop3 } from "lodash";
import { useOnEscape } from "@leagueplatform/web-common";
import { Box as Box5, genesisStyled as genesisStyled5, css as css12 } from "@leagueplatform/genesis-commons";
var TooltipContainer = genesisStyled5("div")(
  ({ inline, zIndex }) => css12({
    position: "relative",
    display: inline ? "inline-block" : "block",
    zIndex: zIndex && zIndex
  })
);
var TooltipButton = genesisStyled5(Box5)(
  ({ zIndex }) => css12({
    background: "none",
    border: "none",
    position: "relative",
    "&:focus": {
      boxShadow: "focusRing",
      outline: "none"
    }
  })
);
var Tooltip = ({
  id,
  children,
  inline,
  onHover,
  zIndex,
  isHovered = false,
  tooltipText,
  describedBy
}) => {
  const [isActive, setIsActive] = useState2(isHovered);
  const unHoverTimeoutRef = useRef();
  const buttonRef = useRef();
  useEffect2(() => {
    clearTimeout(unHoverTimeoutRef.current);
  }, []);
  const hideTooltip = useCallback(() => {
    setIsActive(false);
    buttonRef == null ? void 0 : buttonRef.current.focus();
  }, [buttonRef]);
  const mouseEnterHandler = useCallback(() => {
    clearTimeout(unHoverTimeoutRef.current);
    setIsActive(true);
    onHover();
  }, [onHover]);
  const mouseLeaveHandler = useCallback(() => {
    unHoverTimeoutRef.current = setTimeout(() => {
      setIsActive(false);
    }, 250);
  }, []);
  const toggleTooltip = useCallback(() => {
    setIsActive((currentState) => {
      if (!currentState) {
        clearTimeout(unHoverTimeoutRef.current);
      }
      return !currentState;
    });
  }, []);
  useOnEscape(hideTooltip);
  useEffect2(() => {
    setIsActive(isHovered);
  }, [isHovered]);
  const [firstChild, ...restOfChildren] = React25.Children.toArray(children);
  return /* @__PURE__ */ React25.createElement(
    TooltipContainer,
    {
      onMouseEnter: mouseEnterHandler,
      onMouseLeave: mouseLeaveHandler,
      inline,
      zIndex: isActive ? 2 : zIndex
    },
    /* @__PURE__ */ React25.createElement(
      TooltipButton,
      __spreadValues({
        as: "button",
        type: "button",
        "aria-expanded": isActive,
        "aria-controls": id,
        "aria-label": tooltipText,
        onClick: toggleTooltip,
        ref: buttonRef
      }, describedBy && { "aria-describedby": describedBy }),
      firstChild
    ),
    restOfChildren.map((child) => {
      return child && React25.cloneElement(child, {
        isHovered: isActive,
        id
      });
    })
  );
};
Tooltip.propTypes = {
  id: PropTypes21.string,
  children: PropTypes21.node.isRequired,
  isHovered: PropTypes21.bool,
  inline: PropTypes21.bool,
  onHover: PropTypes21.func,
  zIndex: PropTypes21.string,
  tooltipText: PropTypes21.string,
  describedBy: PropTypes21.string
};
Tooltip.defaultProps = {
  isHovered: false,
  inline: false,
  onHover: noop3,
  zIndex: null
};

// src/molecules/tooltip/tooltip-modal/tooltip-modal.container.js
import React33, { useState as useState3 } from "react";
import { KEY, useOnEscape as useOnEscape3 } from "@leagueplatform/web-common";

// src/molecules/tooltip/tooltip-modal/tooltip-modal.view.js
import React32 from "react";
import PropTypes28 from "prop-types";
import FocusTrap2 from "focus-trap-react";
import { useIntl as useIntl3 } from "react-intl";
import {
  Box as Box6,
  Flex as Flex3,
  PrimaryButton,
  SubtleButton,
  Link as Link2,
  genesisStyled as genesisStyled6,
  css as css13
} from "@leagueplatform/genesis-commons";

// src/components/modal/modal-container.view.js
import React26 from "react";
import PropTypes22 from "prop-types";
import styled25 from "styled-components";

// src/components/modal/use-modal-a11y-props.hook.js
var useModalA11yProps = (label) => {
  const modalAriaProps = {
    role: "dialog",
    "aria-modal": "true"
  };
  if (label) {
    modalAriaProps["aria-label"] = label;
  }
  return modalAriaProps;
};

// src/components/modal/modal-container.view.js
var Container3 = styled25(Box4)`
  width: ${({ width: width2 }) => width2 || "80%"};
  max-width: ${({ maxWidth }) => maxWidth || "720px"};
  max-height: ${({ maxHeight }) => maxHeight || "90%"};
  overflow-y: auto;
  border: 1px solid ${({ theme: theme2 }) => getColourObject(theme2).darkGrey};
`;
var ModalContainer = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  const modalAriaProps = useModalA11yProps();
  return /* @__PURE__ */ React26.createElement(Container3, __spreadValues(__spreadValues({}, modalAriaProps), props), children);
};
ModalContainer.propTypes = {
  children: PropTypes22.node.isRequired
};

// src/components/modal/modal-body.view.js
import React27 from "react";
import PropTypes23 from "prop-types";
import styled26 from "styled-components";
var BodyContainer = styled26(Box4)`
  background-color: ${({ theme: theme2 }) => getColourObject(theme2).white};
  color: ${({ theme: theme2 }) => getColourObject(theme2).purpleText};
`;
var ModalBody = ({ className, children, p }) => {
  return /* @__PURE__ */ React27.createElement(BodyContainer, { className, p }, children);
};
ModalBody.propTypes = {
  children: PropTypes23.node.isRequired,
  className: PropTypes23.string,
  p: PropTypes23.number
};
ModalBody.defaultProps = {
  className: "",
  p: 3
};

// src/components/modal/modal-header.view.js
import React28 from "react";
import PropTypes24 from "prop-types";
import styled27 from "styled-components";
import { noop as noop4 } from "lodash";
var Header = styled27(Flex2)`
  background-color: ${({ theme: theme2, backgroundColour }) => backgroundColour || getColourObject(theme2).offWhite};
`;
var HeaderContents = styled27(Box4)`
  flex-grow: 1;
`;
var CloseButton2 = styled27(Box4)`
  font-size: 40px;
  transition: opacity 250ms ease-out;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
`;
var ModalHeader = (_a) => {
  var _b = _a, {
    children,
    closeButton,
    onClose,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "closeButton",
    "onClose",
    "className"
  ]);
  return /* @__PURE__ */ React28.createElement(
    Header,
    __spreadValues({
      p: 2,
      pl: 3,
      pr: 3,
      flexDirection: "row",
      className
    }, props),
    /* @__PURE__ */ React28.createElement(HeaderContents, null, children),
    closeButton && /* @__PURE__ */ React28.createElement(CloseButton2, { onClick: onClose }, "\xD7")
  );
};
ModalHeader.propTypes = {
  children: PropTypes24.node.isRequired,
  closeButton: PropTypes24.bool,
  onClose: PropTypes24.func.isRequired,
  className: PropTypes24.string
};
ModalHeader.defaultProps = {
  closeButton: false,
  onClose: noop4,
  className: null
};

// src/components/modal/modal-header-title.view.js
import React29 from "react";
import PropTypes25 from "prop-types";
import styled28 from "styled-components";
var ModalTitle = styled28.h2`
  font-weight: 500;
  font-size: 1.25rem;
  color: ${({ theme: theme2 }) => getColourObject(theme2).purpleText};
`;
var ModalHeaderTitle = ({ children }) => /* @__PURE__ */ React29.createElement(ModalTitle, { level: 2 }, children);
ModalHeaderTitle.propTypes = {
  children: PropTypes25.node.isRequired
};

// src/components/modal/modal-footer.view.js
import React30 from "react";
import PropTypes26 from "prop-types";
import styled29 from "styled-components";
var Footer = styled29(Flex2)`
  background-color: ${({ theme: theme2 }) => getColourObject(theme2).offWhite};
`;
var ModalFooter = ({ children, className }) => /* @__PURE__ */ React30.createElement(Footer, { p: 2, justifyContent: "flex-end", className }, children);
ModalFooter.propTypes = {
  children: PropTypes26.node.isRequired,
  className: PropTypes26.string
};
ModalFooter.defaultProps = {
  className: null
};

// src/components/modal/modal-wrapper.view.js
import React31 from "react";
import PropTypes27 from "prop-types";
import FocusTrap from "focus-trap-react";
import { useOnEscape as useOnEscape2, ModalPortal } from "@leagueplatform/web-common";
var ModalWrapper = (_a) => {
  var _b = _a, { onClose, options, children } = _b, props = __objRest(_b, ["onClose", "options", "children"]);
  useOnEscape2(onClose);
  return /* @__PURE__ */ React31.createElement(ModalPortal, null, /* @__PURE__ */ React31.createElement(FocusTrap, { focusTrapOptions: options }, /* @__PURE__ */ React31.createElement(Backdrop, __spreadValues({ onClose, closeOnChildrenClick: false }, props), children)));
};
ModalWrapper.propTypes = {
  onClose: PropTypes27.func.isRequired,
  children: PropTypes27.node.isRequired,
  // See https://github.com/focus-trap/focus-trap#createfocustrapelement-createoptions
  // for available options
  options: PropTypes27.shape({})
};
ModalWrapper.defaultProps = {
  options: {}
};

// src/components/modal/index.js
var Modal = {
  Container: ModalContainer,
  Header: ModalHeader,
  HeaderTitle: ModalHeaderTitle,
  Body: ModalBody,
  Footer: ModalFooter,
  Wrapper: ModalWrapper
};

// src/molecules/tooltip/tooltip-modal/tooltip-modal.view.js
var MODAL_DESCRIPTION = "uikit-modal-description";
var ContentBox = genesisStyled6(Box6)`
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;
var TooltipModalLabel = (props) => /* @__PURE__ */ React32.createElement(Flex3, __spreadValues({ justifyContent: "center" }, props));
var TooltipContent = (props) => /* @__PURE__ */ React32.createElement(
  Box6,
  __spreadValues({
    backgroundColor: "surface.background.primary",
    borderRadius: "small",
    borderStyle: "solid",
    borderColor: "onSurface.border.subdued",
    padding: "oneAndHalf",
    margin: "auto",
    "aria-labelledby": MODAL_DESCRIPTION
  }, props)
);
var ModalContentProps = {
  closeModal: PropTypes28.func.isRequired,
  content: PropTypes28.node.isRequired
};
var FullscreenModalContent = ({ closeModal, content }) => {
  const { formatMessage } = useIntl3();
  const focusRef = (node) => {
    var _a;
    return (_a = node == null ? void 0 : node.focus) == null ? void 0 : _a.call(node);
  };
  return /* @__PURE__ */ React32.createElement(
    Flex3,
    {
      flexDirection: "column",
      backgroundColor: "surface.background.primary",
      position: "absolute",
      zIndex: "modal",
      height: "100vh",
      left: 0,
      right: 0,
      top: 0,
      paddingTop: 66
    },
    /* @__PURE__ */ React32.createElement(TooltipContent, { flexGrow: 1, overflow: "auto" }, /* @__PURE__ */ React32.createElement(ContentBox, null, /* @__PURE__ */ React32.createElement(
      Box6,
      {
        fontSize: "body1",
        color: "onSurface.text.primary",
        id: MODAL_DESCRIPTION
      },
      content
    ))),
    /* @__PURE__ */ React32.createElement(
      Box6,
      {
        padding: "one",
        width: 1,
        backgroundColor: "surface.background.primary",
        borderTopWidth: "thin",
        borderTopStyle: "solid",
        borderTopColor: "onSurface.border.subdued"
      },
      /* @__PURE__ */ React32.createElement(
        PrimaryButton,
        {
          marginTop: "none",
          width: 1,
          onClick: closeModal,
          ref: focusRef
        },
        formatMessage({ id: "GOT_IT" })
      )
    )
  );
};
FullscreenModalContent.propTypes = ModalContentProps;
var ModalContent = ({ closeModal, content }) => {
  const { formatMessage } = useIntl3();
  const focusRef = (node) => {
    var _a;
    return (_a = node == null ? void 0 : node.focus) == null ? void 0 : _a.call(node);
  };
  return /* @__PURE__ */ React32.createElement(React32.Fragment, null, /* @__PURE__ */ React32.createElement(TooltipContent, { maxWidth: "90%", width: 350 }, /* @__PURE__ */ React32.createElement(
    Box6,
    {
      fontSize: "body1",
      color: "onSurface.text.primary",
      id: MODAL_DESCRIPTION
    },
    content
  ), /* @__PURE__ */ React32.createElement(
    PrimaryButton,
    {
      marginTop: "one",
      width: 1,
      onClick: closeModal,
      ref: focusRef
    },
    formatMessage({ id: "GOT_IT" })
  )));
};
ModalContent.propTypes = ModalContentProps;
var TooltipModalContent = (_a) => {
  var _b = _a, { isFullScreen, closeModal } = _b, props = __objRest(_b, ["isFullScreen", "closeModal"]);
  return /* @__PURE__ */ React32.createElement(Modal.Wrapper, __spreadValues({ onClose: closeModal }, props), /* @__PURE__ */ React32.createElement(FocusTrap2, null, isFullScreen ? /* @__PURE__ */ React32.createElement(FullscreenModalContent, __spreadValues({ closeModal }, props)) : /* @__PURE__ */ React32.createElement(ModalContent, __spreadValues({ closeModal }, props))));
};
TooltipModalContent.propTypes = {
  closeModal: PropTypes28.func.isRequired,
  isFullScreen: PropTypes28.bool,
  content: PropTypes28.node.isRequired
};
TooltipModalContent.defaultProps = {
  isFullScreen: false
};
var LinkButton = genesisStyled6(Link2)(
  css13({
    backgroundColor: "transparent",
    border: "none"
  })
);
var TooltipModalPresenter = (_a) => {
  var _b = _a, {
    isModalOpen,
    openModal,
    closeModal,
    label,
    buttonTabIndex,
    onLabelKeyDown
  } = _b, props = __objRest(_b, [
    "isModalOpen",
    "openModal",
    "closeModal",
    "label",
    "buttonTabIndex",
    "onLabelKeyDown"
  ]);
  return (
    // This component must be enveloped in actual DOM (not a fragment)
    // to prevent the label from shifting when the modal is open.
    /* @__PURE__ */ React32.createElement("span", null, label && /* @__PURE__ */ React32.createElement(TooltipModalLabel, __spreadValues({}, props), /* @__PURE__ */ React32.createElement(
      LinkButton,
      {
        as: "button",
        onClick: openModal,
        tabIndex: buttonTabIndex,
        onKeyDown: onLabelKeyDown
      },
      label
    )), isModalOpen ? /* @__PURE__ */ React32.createElement(TooltipModalContent, __spreadProps(__spreadValues({}, props), { closeModal })) : null)
  );
};
var tooltipModalProps = {
  isModalOpen: PropTypes28.bool,
  openModal: PropTypes28.func.isRequired,
  closeModal: PropTypes28.func.isRequired,
  onLabelKeyDown: PropTypes28.func.isRequired,
  label: PropTypes28.node.isRequired,
  textAlign: PropTypes28.string,
  isFullScreen: PropTypes28.bool,
  inline: PropTypes28.bool,
  buttonTabIndex: PropTypes28.number
};
TooltipModalPresenter.propTypes = __spreadValues({}, tooltipModalProps);
var tooltipModalDefaultProps = {
  label: void 0,
  isModalOpen: false,
  textAlign: null,
  isFullScreen: false,
  inline: false,
  buttonTabIndex: 0
};
TooltipModalPresenter.defaultProps = tooltipModalDefaultProps;
var DottedButton = genesisStyled6(LinkButton)(
  css13({
    textDecoration: "none",
    borderBottomStyle: "dotted",
    borderBottomWidth: "thick",
    borderBottomColor: "onSurface.border.subdued",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    "> span": {
      whiteSpace: "nowrap"
    }
  })
);
var DottedTooltipModalPresenter = (_a) => {
  var _b = _a, {
    isModalOpen,
    openModal,
    closeModal,
    label,
    buttonTabIndex,
    onLabelKeyDown,
    inline
  } = _b, props = __objRest(_b, [
    "isModalOpen",
    "openModal",
    "closeModal",
    "label",
    "buttonTabIndex",
    "onLabelKeyDown",
    "inline"
  ]);
  return (
    // This component must be enveloped in actual DOM (not a fragment)
    // to prevent the label from shifting when the modal is open.
    /* @__PURE__ */ React32.createElement("span", null, /* @__PURE__ */ React32.createElement(TooltipModalLabel, __spreadProps(__spreadValues({}, props), { inline }), /* @__PURE__ */ React32.createElement(
      DottedButton,
      {
        as: "button",
        tabIndex: buttonTabIndex,
        onClick: openModal,
        marginTop: "one",
        marginBottom: inline ? "none" : "twoAndHalf",
        onKeyDown: onLabelKeyDown,
        fontSize: {
          _: "body2",
          tablet: "body1"
        },
        type: "button"
      },
      label
    )), isModalOpen ? /* @__PURE__ */ React32.createElement(TooltipModalContent, __spreadProps(__spreadValues({}, props), { closeModal })) : null)
  );
};
DottedTooltipModalPresenter.propTypes = __spreadValues({}, tooltipModalProps);
TooltipModalPresenter.defaultProps = tooltipModalDefaultProps;
var IconTooltipButton = genesisStyled6(SubtleButton)(
  css13({
    padding: "none"
  })
);
var IconTooltipModalPresenter = (_a) => {
  var _b = _a, {
    isModalOpen,
    openModal,
    closeModal,
    label,
    iconColour,
    buttonTabIndex,
    onLabelKeyDown
  } = _b, props = __objRest(_b, [
    "isModalOpen",
    "openModal",
    "closeModal",
    "label",
    "iconColour",
    "buttonTabIndex",
    "onLabelKeyDown"
  ]);
  return (
    // This component must be enveloped in actual DOM (not a fragment)
    // to prevent the label from shifting when the modal is open.
    /* @__PURE__ */ React32.createElement("span", null, /* @__PURE__ */ React32.createElement(TooltipModalLabel, __spreadValues({}, props), /* @__PURE__ */ React32.createElement(
      IconTooltipButton,
      {
        borderRadius: "circle",
        size: "one",
        fontWeight: "medium",
        onClick: openModal,
        tabIndex: buttonTabIndex,
        iconColour,
        onKeyDown: onLabelKeyDown,
        "aria-label": label
      },
      "?"
    )), isModalOpen ? /* @__PURE__ */ React32.createElement(TooltipModalContent, __spreadProps(__spreadValues({}, props), { closeModal })) : null)
  );
};
IconTooltipModalPresenter.propTypes = __spreadProps(__spreadValues({}, tooltipModalProps), {
  iconColour: PropTypes28.string
});
IconTooltipModalPresenter.defaultProps = __spreadProps(__spreadValues({}, tooltipModalDefaultProps), {
  iconColour: null
});

// src/molecules/tooltip/tooltip-modal/tooltip-modal.container.js
var useTooltipModal = () => {
  const [isModalOpen, setIsModalOpen] = useState3(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  useOnEscape3(() => closeModal);
  const onLabelKeyDown = (e) => {
    e.key === KEY.ENTER && openModal();
  };
  return {
    isModalOpen,
    openModal,
    closeModal,
    onLabelKeyDown,
    buttonTabIndex: isModalOpen ? -1 : 0
  };
};
var TooltipModal = (props) => {
  const tooltipProps = useTooltipModal();
  return /* @__PURE__ */ React33.createElement(TooltipModalPresenter, __spreadValues(__spreadValues({}, props), tooltipProps));
};
var DottedTooltipModal = (props) => {
  const tooltipProps = useTooltipModal();
  return /* @__PURE__ */ React33.createElement(DottedTooltipModalPresenter, __spreadValues(__spreadValues({}, props), tooltipProps));
};
var IconTooltipModal = (props) => {
  const tooltipProps = useTooltipModal();
  return /* @__PURE__ */ React33.createElement(IconTooltipModalPresenter, __spreadValues(__spreadValues({}, props), tooltipProps));
};

// src/molecules/link-button.view.js
import styled30 from "styled-components";
var LinkButton2 = styled30.button`
  ${leagueFont({ medium: true })};
  background-color: transparent;
  border: none;
  color: ${({ color: color2, theme: theme2 }) => color2 || getColourObject(theme2).purple};
  cursor: pointer;
  font-size: 1.6rem;
  outline: none;
  padding: 0;
  text-align: left;
`;

// src/molecules/tooltip/tooltip-header.view.js
import { Box as GenesisBox } from "@leagueplatform/genesis-commons";

// src/components/tooltip/tooltip-content.view.js
import React34 from "react";
import PropTypes29 from "prop-types";
import styled31 from "styled-components";
import { genesisStyled as genesisStyled7 } from "@leagueplatform/genesis-commons";
import { withTheme, css as css14 } from "styled-components";
var getPointerPositionProperty = ({ left, right, position }) => {
  if (left)
    return ` left: ${position}px;`;
  if (right)
    return `right: ${position}px`;
  return null;
};
var TooltipContentBox = styled31(Flex2)`
  position: absolute;
  z-index: 99;
  ${({ verticalPosition }) => verticalPosition};
  ${({ horizontalPosition }) => horizontalPosition};
  ${({ center }) => center && "left: 50%; transform: translateX(-50%)"};
  ${({ right }) => right && "right: 0"};
  ${({ left }) => left && "left: 0"};
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius}`} color: ${({ colour: colour2 }) => colour2};
  background-color: ${({ backgroundColour }) => backgroundColour};
  border: 1px solid ${({ borderColour }) => borderColour};
  filter: drop-shadow(
    0 2px 8px ${({ theme: theme2 }) => getColourObject(theme2).lightMediumGrey}
  );
  pointer-events: auto;
  &[aria-hidden='true'] {
    pointer-events: none;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 100%;
    ${({ center }) => center && "left: 50%; transform: translateX(-50%);"};
    width: 0;
    height: 0;
  }

  &:before {
    ${({ center, left, right, pointerPosition }) => !center && getPointerPositionProperty({ left, right, position: pointerPosition })};
    border-top: 8px solid ${({ borderColour }) => borderColour};
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    ${({ top }) => top && `
        top: auto;
        bottom: 100%;
        transform: rotate(180deg);
      `};
  }

  &:after {
    ${({ right, left, pointerPosition }) => (right || left) && getPointerPositionProperty({
  left,
  right,
  position: pointerPosition + 1
})};
    border-top: 7px solid ${({ backgroundColour }) => backgroundColour};
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    ${({ top }) => top && `
        top: auto;
        bottom: 100%;
        transform: rotate(180deg);
      `};
  }
`;
var TooltipContentWrapper = genesisStyled7("div")`
  width: 100%;
  height: 100%;
  pointer-events: none;
  position: absolute;
  top: 0;
  transition-property: transform, opacity;
  transition-duration: 300ms;
  transform: translateY(32px);
  opacity: 0;
  ${({ isVisible }) => isVisible ? css14`
          transform: translateY(0);
          opacity: 1;
        ` : ""}
`;
var TooltipContent2 = withTheme(
  (_a) => {
    var _b = _a, {
      isHovered,
      children,
      colour: colour2,
      backgroundColour,
      borderColour,
      borderRadius,
      pointerPosition,
      verticalPosition,
      horizontalPosition,
      center,
      left,
      right,
      top,
      theme: theme2
    } = _b, props = __objRest(_b, [
      "isHovered",
      "children",
      "colour",
      "backgroundColour",
      "borderColour",
      "borderRadius",
      "pointerPosition",
      "verticalPosition",
      "horizontalPosition",
      "center",
      "left",
      "right",
      "top",
      "theme"
    ]);
    const colourTheme = getColourObject(theme2);
    return /* @__PURE__ */ React34.createElement(TooltipContentWrapper, { isVisible: isHovered }, /* @__PURE__ */ React34.createElement(
      TooltipContentBox,
      __spreadValues({
        "aria-hidden": !isHovered,
        colour: colour2 || colourTheme.offBlack,
        backgroundColour: backgroundColour || colourTheme.white,
        borderColour: borderColour || colourTheme.greyLighter,
        pointerPosition,
        horizontalPosition,
        verticalPosition,
        borderRadius,
        center,
        left,
        right,
        top
      }, props),
      children
    ));
  }
);
TooltipContent2.propTypes = {
  children: PropTypes29.node.isRequired,
  isHovered: PropTypes29.bool,
  colour: PropTypes29.string,
  backgroundColour: PropTypes29.string,
  borderColour: PropTypes29.string,
  borderRadius: PropTypes29.oneOfType([PropTypes29.number, PropTypes29.string]),
  pointerPosition: PropTypes29.oneOfType([PropTypes29.number, PropTypes29.string]),
  verticalPosition: PropTypes29.string,
  horizontalPosition: PropTypes29.string,
  center: PropTypes29.bool,
  left: PropTypes29.bool,
  right: PropTypes29.bool,
  top: PropTypes29.bool
};
TooltipContent2.defaultProps = {
  isHovered: false,
  borderRadius: "0",
  pointerPosition: "left: 50%",
  horizontalPosition: null,
  verticalPosition: "bottom: 100%",
  center: false,
  left: false,
  right: false,
  top: false
};

// src/molecules/tooltip/tooltip-header.view.js
import React35 from "react";
import styled32 from "styled-components";
import PropTypes30 from "prop-types";
var TooltipText = styled32(Box4).attrs({
  p: 2
})`
  font-size: 1.4rem;
  line-height: 1.5;
  min-width: ${({ minWidth }) => minWidth};
  white-space: pre-wrap;
  ${({ fontWeight: fontWeight2 }) => fontWeight2 && `font-weight: ${fontWeight2}`};
`;
var TooltipHeader = ({
  tooltipLink,
  tooltipText,
  inline,
  top,
  verticalPosition,
  fontWeight: fontWeight2,
  minWidth,
  pointerPosition,
  center,
  right,
  id
}) => /* @__PURE__ */ React35.createElement(Tooltip, { id, inline }, /* @__PURE__ */ React35.createElement(
  GenesisBox,
  {
    as: "span",
    fontSize: "body2",
    marginBottom: inline ? "none" : 20,
    marginTop: inline ? "none" : 14,
    color: "interactive.action.primary"
  },
  tooltipLink
), /* @__PURE__ */ React35.createElement(
  TooltipContent2,
  {
    right,
    center,
    pointerPosition,
    borderRadius: "5px",
    top,
    verticalPosition
  },
  /* @__PURE__ */ React35.createElement(TooltipText, { fontWeight: fontWeight2, minWidth }, tooltipText)
));
TooltipHeader.propTypes = {
  id: PropTypes30.string,
  tooltipLink: PropTypes30.node.isRequired,
  tooltipText: PropTypes30.node.isRequired,
  inline: PropTypes30.bool,
  right: PropTypes30.bool,
  center: PropTypes30.bool,
  top: PropTypes30.bool,
  verticalPosition: PropTypes30.string,
  fontWeight: PropTypes30.string,
  minWidth: PropTypes30.string,
  pointerPosition: PropTypes30.number
};
TooltipHeader.defaultProps = {
  inline: false,
  right: true,
  center: false,
  top: false,
  verticalPosition: null,
  fontWeight: null,
  minWidth: "35rem",
  pointerPosition: 30
};

// src/components/currency-input-v2/currency-input-v2.view.js
import React37, { useState as useState4, useEffect as useEffect3, useMemo } from "react";
import PropTypes32 from "prop-types";
import { Flex as Flex4, Overline, Box as Box7 } from "@leagueplatform/genesis-commons";
import { KEY as KEY2 } from "@leagueplatform/web-common";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { noop as noop5 } from "lodash";

// src/components/currency-input/currency-input.view.js
import React36 from "react";
import styled33 from "styled-components";
import PropTypes31 from "prop-types";
import { isNil } from "lodash";
var sanitizeValue = (value, decimalSeparator, isNegativeAllowed) => {
  if (isNil(value))
    return value;
  let sanitizedValue = `${value}`;
  let centsValue;
  let dollarsValue;
  if (sanitizedValue.indexOf(decimalSeparator) !== -1) {
    centsValue = sanitizedValue.substr(sanitizedValue.indexOf(decimalSeparator)).replace(/\D/g, "");
    dollarsValue = sanitizedValue.substring(0, sanitizedValue.indexOf(decimalSeparator)).replace(/\D/g, "");
  } else {
    dollarsValue = sanitizedValue.replace(/\D/g, "");
  }
  sanitizedValue = centsValue ? `${dollarsValue}.${centsValue}` : dollarsValue;
  return sanitizedValue.length ? parseFloat(
    isNegativeAllowed && value < 0 ? -sanitizedValue : sanitizedValue
  ) : null;
};

// src/components/currency-input-v2/currency-input-v2.view.js
import { TextInput } from "@leagueplatform/genesis-core";
var getLocalizedDecimalSeparator = (locale) => 1.1.toLocaleString(locale).replace(/1/g, "");
var useFormatCurrency = () => {
  const { formatMoney, locale } = useIntl4();
  const decimalSeparator = getLocalizedDecimalSeparator(locale);
  const sanitizeValue2 = (value) => sanitizeValue(value, decimalSeparator);
  const formatCurrency = (currency, value) => {
    const formattedValue = typeof value === "string" ? sanitizeValue2(value) : value;
    return formattedValue || formattedValue === 0 ? formatMoney(
      { F: formattedValue, C: currency },
      { minimumFractionDigits: 2 }
    ) : "";
  };
  return {
    formatCurrency,
    sanitizeValue: sanitizeValue2
  };
};
var PERIOD_TYPE = "period-type";
var CurrencyInputV2 = (_a) => {
  var _b = _a, {
    name,
    id = name,
    currency,
    onChange,
    onFocus,
    onBlur,
    onKeyUp,
    onSanitize,
    onSubmit,
    error,
    disabled,
    value,
    periodType,
    isRequired
  } = _b, props = __objRest(_b, [
    "name",
    "id",
    "currency",
    "onChange",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onSanitize",
    "onSubmit",
    "error",
    "disabled",
    "value",
    "periodType",
    "isRequired"
  ]);
  const { formatMessage } = useIntl4();
  const { formatCurrency, sanitizeValue: sanitizeValue2 } = useFormatCurrency();
  const [sanitizedValue, setSanitizedValue] = useState4(value);
  const [formattedValue, setFormattedValue] = useState4(
    value ? formatCurrency(currency, value) : ""
  );
  const placeholder = useMemo(
    () => formatCurrency(currency, 0),
    [currency, formatCurrency]
  );
  useEffect3(() => {
    onSanitize(sanitizedValue != null ? sanitizedValue : 0);
  }, [sanitizedValue, onSanitize]);
  return /* @__PURE__ */ React37.createElement(
    Box7,
    __spreadProps(__spreadValues({
      position: "relative"
    }, props), {
      minWidth: periodType ? {
        _: "230px",
        laptop: "none",
        desktop: "230px"
      } : null
    }),
    /* @__PURE__ */ React37.createElement(
      TextInput,
      {
        name,
        id,
        disabled,
        error,
        onChange: (e) => {
          e.persist();
          const newValue = e.target.value;
          const sanitized = sanitizeValue2(newValue);
          if (sanitized !== sanitizedValue) {
            setSanitizedValue(sanitized);
          }
          setFormattedValue(newValue);
          onChange(e);
        },
        onKeyUp: (e) => {
          e.persist();
          if (e.key === KEY2.ENTER) {
            onSubmit();
          } else {
            onKeyUp(e);
          }
        },
        onBlur: (e) => {
          e.persist();
          const newValue = e.target.value;
          const sanitized = sanitizeValue2(newValue);
          setFormattedValue(formatCurrency(currency, sanitized));
          onBlur(e);
        },
        onFocus: (e) => {
          e.persist();
          onFocus(e);
        },
        value: formattedValue,
        placeholder: formattedValue ? void 0 : placeholder,
        "aria-labelledby": periodType ? `${id}-${PERIOD_TYPE}` : void 0,
        required: isRequired || void 0,
        inputStatus: error ? "error" : ""
      }
    ),
    periodType && /* @__PURE__ */ React37.createElement(
      Flex4,
      {
        backgroundColor: "surface.background.secondary",
        alignItems: "center",
        paddingX: "threeQuarters",
        position: "absolute",
        right: 1,
        top: 1,
        bottom: 1,
        margin: 1,
        borderRadius: "small",
        borderTopLeftRadius: "unset",
        borderBottomLeftRadius: "unset"
      },
      /* @__PURE__ */ React37.createElement(
        Overline,
        {
          color: "onSurface.text.subdued",
          as: "p",
          id: `${id}-${PERIOD_TYPE}`
        },
        formatMessage({ id: periodType })
      )
    )
  );
};
CurrencyInputV2.defaultProps = {
  value: "",
  onChange: noop5,
  onKeyUp: noop5,
  onSubmit: noop5,
  onBlur: noop5,
  onFocus: noop5,
  onSanitize: noop5,
  error: null,
  id: void 0,
  // this will be set to name if undefined
  periodType: void 0,
  disabled: false,
  isRequired: false
};
CurrencyInputV2.propTypes = {
  name: PropTypes32.string.isRequired,
  id: PropTypes32.string,
  value: PropTypes32.number,
  onChange: PropTypes32.func,
  onBlur: PropTypes32.func,
  onFocus: PropTypes32.func,
  onKeyUp: PropTypes32.func,
  onSanitize: PropTypes32.func,
  onSubmit: PropTypes32.func,
  currency: PropTypes32.string.isRequired,
  error: PropTypes32.string,
  disabled: PropTypes32.bool,
  periodType: PropTypes32.string,
  isRequired: PropTypes32.bool
};

// src/components/tooltip/tooltip-content.v2.view.js
import React38, { useEffect as useEffect4, useRef as useRef2 } from "react";
import PropTypes33 from "prop-types";
import styled34, { css as css15 } from "styled-components";
import { genesisStyled as genesisStyled8, Flex as Flex5 } from "@leagueplatform/genesis-commons";
import { withTheme as withTheme2 } from "styled-components";
var getPointerPositionProperty2 = (position, right) => {
  return right ? css15`
        right: ${position}px;
      ` : css15`
        left: ${position}px;
      `;
};
var getPosition = ({ positionShift, center, right }) => {
  const { x, y } = positionShift;
  let rightPosition = "auto";
  let left = 0;
  let transform = `translate(${x}px, ${y}px)`;
  if (center) {
    left = "50%";
    transform = `translate(-50%, ${y}px)`;
  } else if (right) {
    left = "auto";
    rightPosition = "0";
    transform = `translate(${-x}px, ${y}px)`;
  }
  return css15`
    right: ${rightPosition};
    left: ${left};
    transform: ${transform};
  `;
};
var TooltipContentBox2 = genesisStyled8(Flex5)`
  /* Appearance */
  min-width: 250px;
  max-width: 350px;
  outline: none;
  ${({ width: width2 }) => width2 && css15`
      width: ${width2};
      max-width: ${width2};
    `};
  ${({ padding }) => css15`
      padding: ${padding || "12px"};
    `};
  position: absolute;
  z-index: 99;
  box-shadow: 0 2px 8px ${({ theme: theme2 }) => theme2.lightMediumGrey};
  border: 1px solid ${({ borderColour }) => borderColour};
  pointer-events: auto;
  &[aria-hidden='true'] {
    pointer-events: none;
  }
  ${({ borderRadius }) => css15`
      border-radius: ${borderRadius}px;
    `}
  ${({ colour: colour2 }) => css15`
      color: ${colour2};
    `}
  ${({ backgroundColour }) => css15`
      background: ${backgroundColour || "#fff"};
    `}
  /* Positioning */
  left: 0;
  bottom: 0;
  top: auto;
  ${({ top }) => top && "bottom: auto; top: 0;"};
  ${({ right }) => right && "left: initial; right: 0;"};
  ${({ center }) => center && "left: 50%;"};
  ${({ positionShift, center, right }) => getPosition({ positionShift, center, right })}

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    ${({ center }) => center && "left: 50%; transform: translateX(-50%);"};
    width: 0;
    height: 0;
  }

  &::before {
    ${({ center, right, pointerPosition }) => !center && getPointerPositionProperty2(pointerPosition, right)};

    ${({ borderColour, arrowSize, top }) => css15`
      border-right: ${arrowSize}px solid transparent;
      border-left: ${arrowSize}px solid transparent;
      border-top: ${arrowSize + 1}px solid ${borderColour};
      ${top && css15`
        top: auto;
        bottom: 100%;
        border-bottom: ${arrowSize + 1}px solid ${borderColour};
        border-top: none;
      `};
    `}
  }

  &::after {
    ${({ right, center, pointerPosition }) => !center && getPointerPositionProperty2(pointerPosition + 1, right)};

    ${({ backgroundColour, arrowSize, top }) => css15`
      border-right: ${arrowSize - 1}px solid transparent;
      border-left: ${arrowSize - 1}px solid transparent;
      border-top: ${arrowSize}px solid ${backgroundColour};
      ${top && css15`
        top: auto;
        bottom: 100%;
        border-bottom: ${arrowSize}px solid ${backgroundColour};
        border-top: none;
      `};
    `}
  }
`;
var TooltipContentWrapper2 = genesisStyled8("span")`
  transition-property: transform, opacity;
  transition-duration: 300ms;
  width: 100%;
  height: 100%;
  position: absolute;
  top: -7px;
  display: block;
  transform: translateY(${({ isTop }) => isTop ? "8px" : "-8px"});
  opacity: 0;
  ${({ isVisible }) => isVisible ? css15`
          transform: translateY(0);
          opacity: 1;
        ` : ""}
`;
var TooltipContent3 = withTheme2(
  ({
    isHovered,
    children,
    colour: colour2,
    backgroundColour,
    borderColour,
    borderRadius,
    pointerPosition,
    positionShift,
    arrowSize,
    center,
    left,
    right,
    top,
    padding,
    width: width2,
    describeId,
    theme: theme2,
    trackAnalytics
  }) => {
    const colourTheme = getColourObject(theme2);
    const containerRef = useRef2();
    if (isHovered && trackAnalytics) {
      trackAnalytics();
    }
    useEffect4(() => {
      if (isHovered) {
        containerRef == null ? void 0 : containerRef.current.focus();
      }
    }, [isHovered, containerRef]);
    return /* @__PURE__ */ React38.createElement(TooltipContentWrapper2, { isVisible: isHovered, top }, /* @__PURE__ */ React38.createElement(
      TooltipContentBox2,
      __spreadValues({
        "aria-hidden": !isHovered,
        ref: containerRef,
        tabIndex: "-1",
        colour: colour2 || colourTheme.navyDark,
        backgroundColour: backgroundColour || colourTheme.white,
        borderColour: borderColour || colourTheme.infoGrey,
        pointerPosition,
        borderRadius,
        arrowSize,
        positionShift,
        center,
        left,
        right,
        top,
        padding,
        width: width2
      }, describeId && { id: describeId }),
      children
    ));
  }
);
TooltipContent3.propTypes = {
  children: PropTypes33.node.isRequired,
  isHovered: PropTypes33.bool,
  colour: PropTypes33.string,
  backgroundColour: PropTypes33.string,
  borderColour: PropTypes33.string,
  borderRadius: PropTypes33.number,
  pointerPosition: PropTypes33.number,
  positionShift: PropTypes33.shape({
    x: PropTypes33.number,
    y: PropTypes33.number
  }),
  center: PropTypes33.bool,
  left: PropTypes33.bool,
  right: PropTypes33.bool,
  top: PropTypes33.bool,
  arrowSize: PropTypes33.number,
  padding: PropTypes33.string,
  width: PropTypes33.string,
  describeId: PropTypes33.string,
  trackAnalytics: PropTypes33.func
};
TooltipContent3.defaultProps = {
  isHovered: false,
  borderRadius: 3,
  pointerPosition: 10,
  padding: "12px",
  center: false,
  left: false,
  right: false,
  top: false,
  arrowSize: 7,
  positionShift: {
    x: -10,
    y: -32
  },
  width: ""
};

// src/components/question-icon.view.js
import React39 from "react";
import { FontAwesomeIcon as FontAwesomeIcon4 } from "@fortawesome/react-fontawesome";
import PropTypes34 from "prop-types";
import styled35 from "styled-components";
var QuestionIcon = styled35((_a) => {
  var _b = _a, { isHovered } = _b, props = __objRest(_b, ["isHovered"]);
  return /* @__PURE__ */ React39.createElement(FontAwesomeIcon4, __spreadValues({}, props));
}).attrs({
  icon: "question-circle",
  color: colour("purple")
})``;
QuestionIcon.propTypes = {
  isHovered: PropTypes34.bool
};
QuestionIcon.defaultProps = {
  isHovered: false
};

// src/molecules/confirmation-modal/confirmation-modal.view.js
import React40 from "react";
import PropTypes35 from "prop-types";
import styled36 from "styled-components";
var ModalWrapper2 = styled36(Modal.Container)`
  overflow: visible;
`;
var ConfirmationModal = ({ children, headerText, footerContent }) => /* @__PURE__ */ React40.createElement(ModalWrapper2, null, /* @__PURE__ */ React40.createElement(Modal.Header, null, /* @__PURE__ */ React40.createElement(Modal.HeaderTitle, null, headerText)), /* @__PURE__ */ React40.createElement(Modal.Body, null, children), /* @__PURE__ */ React40.createElement(Modal.Footer, null, footerContent));
ConfirmationModal.propTypes = {
  children: PropTypes35.node.isRequired,
  headerText: PropTypes35.node.isRequired,
  footerContent: PropTypes35.node.isRequired
};

// src/components/callout/callout.view.js
import React41 from "react";
import styled37, { css as css16 } from "styled-components";
import PropTypes36 from "prop-types";
var baseRules = ({ theme: theme2 }) => css16`
  color: ${getColourObject(theme2).purple};
  background-color: ${hex2Rgba(getColourObject(theme2).purple, 0.1)};
  border: 2px solid ${getColourObject(theme2).purple};
  border-radius: 0.5rem;
  line-height: 1.4375;
  a {
    color: ${getColourObject(theme2).purple};
    font-weight: 500;
    text-decoration: none;
    border-bottom: 2px dotted ${getColourObject(theme2).purple};
  }
`;
var adminRules = css16`
  border-radius: 0.25rem;
  padding: 1rem 1.5rem;
  line-height: 1.75;
  margin-top: 1rem;
`;
var CalloutContainer = styled37(Box4)`
  ${baseRules} ${({ admin }) => admin && adminRules};
`;
var Callout = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React41.createElement(CalloutContainer, __spreadProps(__spreadValues({}, props), { p: 3 }), children);
};
Callout.propTypes = {
  children: PropTypes36.node.isRequired
};

// src/components/pill.view.js
import {
  Flex as Flex6,
  Box as Box8,
  Caption,
  genesisStyled as genesisStyled9
} from "@leagueplatform/genesis-commons";
import React42 from "react";
import PropTypes37 from "prop-types";
var PillLabel = genesisStyled9(Caption)`
  letter-spacing: 0.1rem;
  text-transform: uppercase;
`;
var Pill = (_a) => {
  var _b = _a, { color: color2, children, simple } = _b, rest = __objRest(_b, ["color", "children", "simple"]);
  const colourScheme = {
    orange: {
      background: "warning.background.subdued",
      circle: "lightPalette.orange.regular"
    },
    purple: {
      background: "highlight.background.subdued",
      circle: "decorative.brand.primary.default"
    },
    blue: {
      background: "highlight.background.subdued",
      circle: "lightPalette.blue.regular"
    },
    red: {
      background: "critical.background.subdued",
      circle: "lightPalette.red.regular"
    },
    green: {
      background: "success.background.subdued",
      circle: "lightPalette.green.regular"
    },
    grey: {
      background: "interactive.background.disabled",
      circle: "onSurface.text.subdued"
    }
  };
  const getColours = () => colourScheme[color2];
  return /* @__PURE__ */ React42.createElement(
    Flex6,
    __spreadValues({
      alignItems: "center",
      backgroundColor: getColours().background,
      borderRadius: "pill",
      display: "inline-flex",
      padding: 5,
      paddingRight: "half"
    }, rest),
    !simple && /* @__PURE__ */ React42.createElement(
      Box8,
      {
        height: 10,
        width: 10,
        minWidth: 10,
        backgroundColor: getColours().circle,
        borderRadius: "circle"
      }
    ),
    /* @__PURE__ */ React42.createElement(PillLabel, { fontWeight: "bold", marginLeft: 5, lineHeight: "12px" }, children)
  );
};
Pill.propTypes = {
  color: PropTypes37.string,
  simple: PropTypes37.bool,
  className: PropTypes37.string,
  children: PropTypes37.node.isRequired
};
Pill.defaultProps = {
  color: "grey",
  className: null,
  simple: false
};

// src/components/status-circle/status-circle.view.js
import PropTypes38 from "prop-types";
import React43 from "react";
import styled38 from "styled-components";
var Badge = styled38.span`
  position: absolute;
  top: 0;
  left: -14px;
  background: ${({ theme: theme2 }) => getColourObject(theme2).white};
  border: 1px solid ${({ outer }) => outer};
  width: 27px;
  height: 27px;
  border-radius: 999px;
  box-sizing: border-box;

  &:after {
    content: '';
    position: absolute;
    background: ${({ inner }) => inner};
    width: 9px;
    height: 9px;
    border-radius: 999px;
    top: 8px;
    left: 8px;
    box-sizing: border-box;
  }
`;
var StatusCircle = ({ status }) => {
  const { inner, outer } = getStatusColor(status);
  return /* @__PURE__ */ React43.createElement(Badge, { inner, outer });
};
StatusCircle.propTypes = {
  status: PropTypes38.string.isRequired
};
var status_circle_view_default = StatusCircle;

// src/components/close-button/close-button.view.js
import { FontAwesomeIcon as FontAwesomeIcon5 } from "@fortawesome/react-fontawesome";
import React44 from "react";
import styled39 from "styled-components";
import { useIntl as useIntl5 } from "react-intl";
var CloseIconButton = styled39.button`
  border-radius: 50%;
  width: 29px;
  height: 29px;
  padding: 6px 8px;
  cursor: pointer;
  border: 1px solid ${({ theme: theme2 }) => getColourObject(theme2).greyLighter};
`;
var CloseIcon = styled39((props) => /* @__PURE__ */ React44.createElement(FontAwesomeIcon5, __spreadValues({}, props)))`
  font-size: 15px;
`;
var CloseButton3 = () => {
  const { formatMessage } = useIntl5();
  return /* @__PURE__ */ React44.createElement(
    CloseIconButton,
    {
      "aria-label": formatMessage({ id: "ARIA_CIRCLED_CHECKMARK" })
    },
    /* @__PURE__ */ React44.createElement(CloseIcon, { icon: "times" }),
    /* @__PURE__ */ React44.createElement(QuestionIcon, null)
  );
};

// src/components/image-card/image-card.view.js
import React45 from "react";
import styled40 from "styled-components";
import PropTypes39 from "prop-types";
var Card = styled40(Flex2)`
  background-color: ${colour("white")};
  border-radius: 4px;
  min-width: 420px;
  max-width: 782px;

  .image-border {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`;
var LeftColumn = styled40(Box4)`
  min-width: 18%;
`;
var RightColumn = styled40(Box4)`
  padding: 40px 80px;
  width: 100%;
`;
var ImageCard = ({ image, children, className }) => {
  return /* @__PURE__ */ React45.createElement(Card, { className }, image && /* @__PURE__ */ React45.createElement(LeftColumn, null, /* @__PURE__ */ React45.createElement(Image, { url: image, cover: true, fit: true, className: "image-border" })), /* @__PURE__ */ React45.createElement(RightColumn, null, children));
};
ImageCard.propTypes = {
  image: PropTypes39.string,
  children: PropTypes39.node.isRequired,
  className: PropTypes39.string
};
ImageCard.defaultProps = {
  image: null,
  className: ""
};

// src/components/responsive-wrappers/index.js
import React46 from "react";
import PropTypes40 from "prop-types";
import MediaQuery from "react-responsive";
var Responsive = (_a) => {
  var _b = _a, { breakpoint, children } = _b, props = __objRest(_b, ["breakpoint", "children"]);
  return /* @__PURE__ */ React46.createElement(MediaQuery, __spreadProps(__spreadValues({}, props), { query: breakpoint }), children);
};
Responsive.propTypes = {
  breakpoint: PropTypes40.string.isRequired,
  children: PropTypes40.node.isRequired
};
var Phone = (props) => /* @__PURE__ */ React46.createElement(Responsive, __spreadProps(__spreadValues({}, props), { breakpoint: breakpoints.belowTablet }), props.children);
Phone.propTypes = {
  children: PropTypes40.node.isRequired
};
var Tablet = (props) => /* @__PURE__ */ React46.createElement(Responsive, __spreadProps(__spreadValues({}, props), { breakpoint: breakpoints.tablet }), props.children);
Tablet.propTypes = {
  children: PropTypes40.node.isRequired
};
var TabletAndAbove = (props) => /* @__PURE__ */ React46.createElement(Responsive, __spreadProps(__spreadValues({}, props), { breakpoint: breakpoints.tabletAndAbove }), props.children);
TabletAndAbove.propTypes = {
  children: PropTypes40.node.isRequired
};
var LapAndAbove = (props) => /* @__PURE__ */ React46.createElement(Responsive, __spreadProps(__spreadValues({}, props), { breakpoint: breakpoints.lapAndAbove }), props.children);
LapAndAbove.propTypes = {
  children: PropTypes40.node.isRequired
};
var Desktop = (props) => /* @__PURE__ */ React46.createElement(Responsive, __spreadProps(__spreadValues({}, props), { breakpoint: breakpoints.desktop }), props.children);
Desktop.propTypes = {
  children: PropTypes40.node.isRequired
};

// src/components/toggle/toggle.view.js
import React47 from "react";
import styled41 from "styled-components";
import PropTypes41 from "prop-types";
import checkmarkIcon from "./assets/checkmark.svg";
var Label2 = styled41.label`
  display: inline-block;
  ${({ disabled }) => disabled ? `cursor: not-allowed;` : `cursor: pointer;`};
`;
var LabelText = styled41.span`
  ${({ showLabel }) => showLabel ? `opacity: 1; width: default; height: default;` : `opacity: 0; max-width: 0; height: 0;`} ${horizontalBox()};
  ${flexAlign("center")};
`;
var Switch2 = styled41.span`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
`;
var Slider = styled41.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 8px 6px ${colour("greyLight")};
  transition: 0.2s;
  border-radius: 19px;

  &:before {
    content: '';
    position: absolute;
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: ${colour("white")};
    transition: 0.2s;
    border-radius: 50%;
  }
`;
var InvisibleCheckbox = styled41.input`
  opacity: 0;
  width: 0;
  height: 0;

  &[disabled] + ${Slider} {
    opacity: 0.5;
  }

  &:focus + ${Slider} {
    box-shadow: 0 0 0 2px ${colour("purpleLighter")};
  }

  &:checked + ${Slider} {
    background: url(${checkmarkIcon}) no-repeat 8px 6px/12px 12px
      ${colour("purpleDark")};
  }

  &:checked + ${Slider}:before {
    transform: translateX(24px);
  }
`;
var Toggle = ({
  checked,
  onChange,
  disabled,
  name,
  children,
  showLabel
}) => {
  const id = name || Date.now();
  return /* @__PURE__ */ React47.createElement(Label2, { htmlFor: id, disabled }, /* @__PURE__ */ React47.createElement(LabelText, { showLabel }, children), /* @__PURE__ */ React47.createElement(Switch2, null, /* @__PURE__ */ React47.createElement(
    InvisibleCheckbox,
    {
      type: "checkbox",
      onChange,
      checked,
      disabled,
      id
    }
  ), /* @__PURE__ */ React47.createElement(Slider, null)));
};
Toggle.propTypes = {
  checked: PropTypes41.bool,
  disabled: PropTypes41.bool,
  showLabel: PropTypes41.bool,
  onChange: PropTypes41.func.isRequired,
  name: PropTypes41.string,
  children: PropTypes41.node.isRequired
};
Toggle.defaultProps = {
  checked: false,
  disabled: false,
  showLabel: false,
  name: null
};

// src/components/badge/badge.view.js
import React48 from "react";
import PropTypes42 from "prop-types";
import {
  Flex as Flex7,
  Overline as Overline2,
  css as css17,
  genesisStyled as genesisStyled10
} from "@leagueplatform/genesis-commons";
var StyledIcon = genesisStyled10(icon_view_default)(
  (props) => css17({
    fill: props.iconColor,
    marginRight: "quarter"
  })
);
var Badge2 = (_a) => {
  var _b = _a, { icon, iconColor, text } = _b, props = __objRest(_b, ["icon", "iconColor", "text"]);
  return /* @__PURE__ */ React48.createElement(
    Flex7,
    __spreadValues({
      display: "inline-flex",
      backgroundColor: "highlight.background.subdued",
      height: "oneAndHalf",
      borderRadius: "medium",
      paddingX: "quarter",
      alignItems: "center"
    }, props),
    icon && /* @__PURE__ */ React48.createElement(
      StyledIcon,
      {
        icon,
        size: 10,
        iconColor,
        "aria-hidden": "true"
      }
    ),
    /* @__PURE__ */ React48.createElement(Overline2, { as: "span" }, text)
  );
};
Badge2.propTypes = {
  text: PropTypes42.string.isRequired,
  icon: PropTypes42.arrayOf(
    PropTypes42.oneOfType([PropTypes42.string, PropTypes42.element])
  ),
  iconColor: PropTypes42.string
};
Badge2.defaultProps = {
  icon: null,
  iconColor: "onSurface.text.primary"
};

// src/components/multi-select/multi-select.view.js
import React49 from "react";
import { withTheme as withTheme3 } from "styled-components";
import PropTypes43 from "prop-types";
import ReactSelect, { components as reactSelectComponents } from "react-select";
import ReactSelectCreatable from "react-select/creatable";
import { FontAwesomeIcon as FontAwesomeIcon6 } from "@fortawesome/react-fontawesome";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { useTheme as useTheme2 } from "@leagueplatform/genesis-core";
var makeOption = (value) => ({
  value,
  label: value
});
var makeOptionWithLabel = (value, label) => ({
  value,
  label: label || value
});
var mapValuesToOptions = (valuesArray, mapper = makeOption) => valuesArray.map(mapper);
var mapOneOfValuesToOptions = (oneOf) => oneOf.map(({ properties: { value, label } }) => ({
  value: value.const,
  label: label.const || value.const
}));
var borderColor = (theme2, { hasError, isFocused, menuIsOpen } = {}) => {
  let color2;
  if (hasError) {
    color2 = theme2.colors.red;
  } else if (isFocused || menuIsOpen) {
    color2 = theme2.colors.purple;
  } else {
    color2 = theme2.colors["neutral.grayLight"];
  }
  return {
    borderColor: color2
  };
};
var inputBoxInset = 4;
var textInset = (theme2) => theme2.space[2] - inputBoxInset;
var DropdownIndicator = (props) => {
  const {
    selectProps: { menuIsOpen }
  } = props;
  return /* @__PURE__ */ React49.createElement(reactSelectComponents.DropdownIndicator, __spreadValues({}, props), /* @__PURE__ */ React49.createElement(FontAwesomeIcon6, { icon: menuIsOpen ? "chevron-up" : "chevron-down" }));
};
DropdownIndicator.propTypes = {
  selectProps: PropTypes43.shape({
    menuIsOpen: PropTypes43.bool
  })
};
DropdownIndicator.defaultProps = {
  selectProps: {}
};
var MultiSelect = withTheme3(
  (_a) => {
    var _b = _a, {
      canCreate,
      canCreatePrompt,
      disabled,
      hasError,
      isClearable,
      isMulti,
      theme: theme2,
      placeholder,
      options,
      id,
      name,
      formatCreateLabel
    } = _b, props = __objRest(_b, [
      "canCreate",
      "canCreatePrompt",
      "disabled",
      "hasError",
      "isClearable",
      "isMulti",
      "theme",
      "placeholder",
      "options",
      "id",
      "name",
      "formatCreateLabel"
    ]);
    const { formatMessage } = useIntl6();
    const { colors } = useTheme2();
    const defaultCanCreatePrompt = formatMessage({
      id: "MULTI_SELECT_DEFAULT_CAN_CREATE"
    });
    const defaultPlaceholder = formatMessage({
      id: "MULTI_SELECT_DEFAULT_PLACEHOLDER"
    });
    const defaultFormatCreateLabel = (label) => formatMessage(
      {
        id: "CREATE"
      },
      { label }
    );
    const promptToCreate = {
      label: canCreatePrompt || defaultCanCreatePrompt,
      isDisabled: true
    };
    const augmentedOptions = canCreate ? [...options, promptToCreate] : options;
    const SelectComponent = canCreate ? ReactSelectCreatable : ReactSelect;
    const reactSelectTheme = {
      borderRadius: 2,
      spacing: {
        controlHeight: 45,
        baseUnit: 4,
        menuGutter: -1
      },
      colors: {
        primary: theme2.colors.purple,
        primary25: theme2.colors.purpleLightest,
        primary50: theme2.colors.purpleLighter,
        primary75: theme2.colors.purpleLight,
        danger: theme2.colors.red,
        dangerLight: theme2.colors.redLightest,
        neutral0: theme2.colors.white,
        neutral5: theme2.colors.greyLightest,
        neutral10: theme2.colors.greyLighter,
        neutral20: theme2.colors.grey,
        neutral30: theme2.colors.grey,
        neutral40: theme2.colors.greyDark,
        neutral80: theme2.colors.navyDark
      }
    };
    const styles = {
      control: (provided, state) => __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, provided), {
        boxShadow: "",
        "&:hover": null
      }), borderColor(theme2, __spreadProps(__spreadValues({}, state), { hasError }))), hasError && {
        backgroundColor: theme2.colors.redLightest
      }),
      valueContainer: (provided) => __spreadProps(__spreadValues({}, provided), {
        padding: "2px"
      }),
      placeholder: (provided) => __spreadProps(__spreadValues({}, provided), {
        color: theme2.colors.grey,
        paddingLeft: textInset(theme2)
      }),
      singleValue: (provided) => __spreadProps(__spreadValues({}, provided), {
        fontWeight: "bold",
        overflow: "visible",
        paddingLeft: textInset(theme2)
      }),
      input: (provided) => __spreadProps(__spreadValues({}, provided), {
        paddingLeft: textInset(theme2)
      }),
      multiValue: (provided) => __spreadProps(__spreadValues({}, provided), {
        backgroundColor: theme2.colors.greyLighter,
        borderRadius: theme2.radii[2]
      }),
      multiValueLabel: (provided) => __spreadProps(__spreadValues({}, provided), {
        fontSize: theme2.fontSizes[2],
        lineHeight: `${theme2.space[3]}px`,
        borderRadius: theme2.radii[2],
        padding: 0,
        paddingLeft: textInset(theme2),
        paddingRight: theme2.space[1] / 2
      }),
      multiValueRemove: (provided, { isFocused }) => __spreadProps(__spreadValues({}, provided), {
        borderRadius: theme2.radii[2],
        backgroundColor: "none",
        border: isFocused ? `1px solid ${theme2.colors.purple}` : "none",
        width: theme2.space[3],
        justifyContent: "center",
        ":hover": __spreadProps(__spreadValues({}, provided[":hover"]), {
          backgroundColor: "none"
        })
      }),
      menu: (provided) => __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, provided), {
        borderStyle: "solid",
        borderWidth: "1px"
      }), borderColor(theme2, { menuIsOpen: true, hasError })), {
        fontSize: `${theme2.fontSizes[2]}px`,
        padding: 0,
        boxShadow: "initial"
      }),
      menuList: (provided) => __spreadProps(__spreadValues({}, provided), {
        padding: 0,
        marginTop: -1,
        // this is to cover the top border
        backgroundColor: theme2.colors.white
      }),
      option: (provided, state) => __spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, provided), {
        ":active": null,
        fontSize: `${theme2.fontSizes[2]}px`,
        padding: theme2.space[2]
      }), !state.isDisabled && {
        fontWeight: 500
      }), {
        color: theme2.colors.navyDark
      }), state.isFocused && {
        backgroundColor: colors.interactiveActionPrimary.value,
        color: colors.onSurfaceTextReversed.value
      }), state.isSelected && {
        backgroundColor: theme2.colors.purpleLightest
      }),
      dropdownIndicator: (provided) => __spreadProps(__spreadValues({}, provided), {
        color: theme2.colors["neutral.gray"],
        paddingRight: theme2.space[2],
        ":hover": null
      })
    };
    const components = {
      IndicatorSeparator: () => null,
      DropdownIndicator
    };
    return /* @__PURE__ */ React49.createElement(Box4, __spreadValues({}, props), /* @__PURE__ */ React49.createElement(
      SelectComponent,
      __spreadValues({
        classNamePrefix: "ui-kit-multi-select",
        components,
        isDisabled: disabled,
        isClearable,
        isMulti,
        options: augmentedOptions,
        placeholder: placeholder || defaultPlaceholder,
        styles,
        theme: reactSelectTheme,
        inputId: id,
        name,
        formatCreateLabel: formatCreateLabel || defaultFormatCreateLabel
      }, props)
    ));
  }
);
MultiSelect.propTypes = {
  canCreate: PropTypes43.bool,
  canCreatePrompt: PropTypes43.string,
  disabled: PropTypes43.bool,
  hasError: PropTypes43.bool,
  isClearable: PropTypes43.bool,
  isMulti: PropTypes43.bool,
  options: PropTypes43.arrayOf(
    PropTypes43.shape({
      label: PropTypes43.string,
      value: PropTypes43.string
    })
  ),
  placeholder: PropTypes43.node,
  formatCreateLabel: PropTypes43.func
};
MultiSelect.defaultProps = {
  disabled: void 0,
  canCreate: false,
  canCreatePrompt: void 0,
  hasError: false,
  isClearable: false,
  isMulti: true,
  options: void 0,
  placeholder: void 0,
  formatCreateLabel: void 0
};

// src/components/date-input/date-input.container.js
import React52, { useState as useState5, useRef as useRef3, useEffect as useEffect5 } from "react";
import PropTypes46 from "prop-types";
import parseISO from "date-fns/parseISO";
import toDate from "date-fns/toDate";
import isValid from "date-fns/isValid";
import getDaysInMonth from "date-fns/getDaysInMonth";

// src/components/date-input/date-input.view.js
import React50, { useMemo as useMemo2 } from "react";
import PropTypes44 from "prop-types";
import { FormattedMessage as FormattedMessage2 } from "react-intl";
import { useIntl as useIntl7 } from "react-intl";
import { Flex as Flex8, Box as Box9, VisuallyHidden as VisuallyHidden2 } from "@leagueplatform/genesis-commons";
import { Select as Select2, styled as styled42, TextInput as TextInput2 } from "@leagueplatform/genesis-core";
var DateTextInput = styled42(TextInput2, {
  height: "$three",
  width: "inherit",
  fontSize: "$bodyOne"
});
var DateInputPresenter = ({
  day,
  onChangeDay,
  month,
  onChangeMonth,
  year,
  onChangeYear,
  onBlur,
  disabled,
  hasError,
  id,
  name,
  dayInputRef,
  monthInputRef,
  yearInputRef,
  errorMessageId,
  autoComplete
}) => {
  const { formatMessage, formatDate } = useIntl7();
  const months = useMemo2(
    () => Array(12).fill().map((_, m) => ({
      label: formatDate(new Date(0, m, 10), {
        month: "long"
      }),
      value: String(m)
    })),
    [formatDate]
  );
  const monthLabel = formatMessage({ id: "MONTH" });
  const dayLabel = formatMessage({ id: "DAY" });
  const yearLabel = formatMessage({ id: "YEAR" });
  const getMonthAriaLabel = (monthValue) => {
    var _a;
    return (_a = months == null ? void 0 : months.find((option) => option.value === monthValue)) == null ? void 0 : _a.label;
  };
  return /* @__PURE__ */ React50.createElement(Flex8, { onBlur, id, name }, /* @__PURE__ */ React50.createElement(Box9, { width: "50%" }, /* @__PURE__ */ React50.createElement(
    Select2,
    {
      id: `${name || id}_month`,
      options: months,
      onChange: onChangeMonth,
      onSubmit: () => {
      },
      disabled,
      width: 1,
      "aria-required": "true",
      placeholder: monthLabel,
      value: month,
      error: hasError,
      ref: monthInputRef,
      "aria-labelledby": `${name || id}_month_label`,
      "aria-describedby": hasError ? errorMessageId : void 0,
      inputStatus: hasError ? "error" : "",
      autoComplete,
      css: {
        ".GDS-select-menu": {
          height: "$three",
          fontSize: "$bodyOne"
        }
      }
    }
  ), /* @__PURE__ */ React50.createElement(VisuallyHidden2, { id: `${name || id}_month_label` }, month ? getMonthAriaLabel(month) : monthLabel)), /* @__PURE__ */ React50.createElement(Box9, { marginLeft: "half", width: "20%" }, /* @__PURE__ */ React50.createElement(
    DateTextInput,
    {
      fit: true,
      id: `${name || id}_day`,
      type: "text",
      placeholder: dayLabel,
      value: day,
      onChange: onChangeDay,
      disabled,
      "aria-required": "true",
      "aria-label": dayLabel,
      ref: dayInputRef,
      error: hasError,
      "aria-describedby": hasError ? errorMessageId : void 0,
      inputStatus: hasError ? "error" : "",
      autoComplete
    }
  )), /* @__PURE__ */ React50.createElement(Box9, { marginLeft: "half", width: "30%" }, /* @__PURE__ */ React50.createElement(
    DateTextInput,
    {
      fit: true,
      id: `${name || id}_year`,
      type: "text",
      placeholder: yearLabel,
      value: year,
      onChange: onChangeYear,
      disabled,
      "aria-required": "true",
      "aria-label": yearLabel,
      ref: yearInputRef,
      error: hasError,
      "aria-describedby": hasError ? errorMessageId : void 0,
      inputStatus: hasError ? "error" : "",
      autoComplete
    }
  )));
};
var refPropType = PropTypes44.oneOfType([
  PropTypes44.func,
  PropTypes44.shape({ current: PropTypes44.instanceOf(Element) })
]);
DateInputPresenter.propTypes = {
  day: PropTypes44.string,
  month: PropTypes44.string,
  year: PropTypes44.string,
  onChangeDay: PropTypes44.func,
  onChangeMonth: PropTypes44.func,
  onChangeYear: PropTypes44.func,
  onBlur: PropTypes44.func,
  disabled: PropTypes44.bool,
  hasError: PropTypes44.bool,
  id: PropTypes44.string,
  name: PropTypes44.string,
  dayInputRef: refPropType,
  monthInputRef: refPropType,
  yearInputRef: refPropType,
  errorMessageId: PropTypes44.string,
  autoComplete: PropTypes44.string
};
DateInputPresenter.defaultProps = {
  day: "",
  month: "",
  year: "",
  autoComplete: "off",
  onChangeDay: () => {
  },
  onChangeMonth: () => {
  },
  onChangeYear: () => {
  },
  onBlur: () => {
  },
  disabled: false,
  hasError: false,
  id: null,
  name: null,
  dayInputRef: null,
  monthInputRef: null,
  yearInputRef: null,
  errorMessageId: void 0
};

// src/components/date-input/legacy-date-input.view.js
import React51, { useMemo as useMemo3 } from "react";
import PropTypes45 from "prop-types";
import { FormattedMessage as FormattedMessage3 } from "react-intl";
import { useIntl as useIntl8 } from "react-intl";
var LegacyUIKitDateInputPresenter = ({
  day,
  onChangeDay,
  month,
  onChangeMonth,
  year,
  onChangeYear,
  onBlur,
  disabled,
  hasError,
  id,
  name,
  dayInputRef,
  monthInputRef,
  yearInputRef,
  autoComplete
}) => {
  const { formatMessage, formatDate } = useIntl8();
  const months = useMemo3(
    () => Array(12).fill().map((_, m) => ({
      text: formatDate(new Date(0, m, 10), {
        month: "long"
      }),
      value: String(m)
    })),
    [formatDate]
  );
  const monthLabel = formatMessage({ id: "MONTH" });
  const dayLabel = formatMessage({ id: "DAY" });
  const yearLabel = formatMessage({ id: "YEAR" });
  return /* @__PURE__ */ React51.createElement(Flex2, { onBlur, id, name }, /* @__PURE__ */ React51.createElement(
    Select,
    {
      id: `${name || id}_month`,
      options: months,
      onChange: onChangeMonth,
      onSubmit: () => {
      },
      width: 5 / 10,
      disabled,
      "aria-required": "true",
      "aria-label": monthLabel,
      hasError,
      selectedValue: month,
      noSelectionLabel: monthLabel,
      my: 0,
      ref: monthInputRef,
      autoComplete
    }
  ), /* @__PURE__ */ React51.createElement(Box4, { ml: 1, width: 2 / 10 }, /* @__PURE__ */ React51.createElement(
    Input,
    {
      fit: true,
      id: `${name || id}_day`,
      type: "text",
      placeholder: dayLabel,
      value: day,
      onChange: onChangeDay,
      disabled,
      "aria-required": "true",
      "aria-label": dayLabel,
      ref: dayInputRef,
      hasError,
      autoComplete
    }
  )), /* @__PURE__ */ React51.createElement(Box4, { ml: 1, width: 3 / 10 }, /* @__PURE__ */ React51.createElement(
    Input,
    {
      fit: true,
      id: `${name || id}_year`,
      type: "text",
      placeholder: yearLabel,
      value: year,
      onChange: onChangeYear,
      disabled,
      "aria-required": "true",
      "aria-label": yearLabel,
      ref: yearInputRef,
      hasError,
      autoComplete
    }
  )));
};
var refPropType2 = PropTypes45.oneOfType([
  PropTypes45.func,
  PropTypes45.shape({ current: PropTypes45.instanceOf(Element) })
]);
LegacyUIKitDateInputPresenter.propTypes = {
  day: PropTypes45.string,
  month: PropTypes45.string,
  year: PropTypes45.string,
  onChangeDay: PropTypes45.func,
  onChangeMonth: PropTypes45.func,
  onChangeYear: PropTypes45.func,
  onBlur: PropTypes45.func,
  disabled: PropTypes45.bool,
  hasError: PropTypes45.bool,
  id: PropTypes45.string,
  name: PropTypes45.string,
  dayInputRef: refPropType2,
  monthInputRef: refPropType2,
  yearInputRef: refPropType2,
  autoComplete: PropTypes45.string
};
LegacyUIKitDateInputPresenter.defaultProps = {
  day: "",
  month: "",
  year: "",
  autoComplete: "off",
  onChangeDay: () => {
  },
  onChangeMonth: () => {
  },
  onChangeYear: () => {
  },
  onBlur: () => {
  },
  disabled: false,
  hasError: false,
  id: null,
  name: null,
  dayInputRef: null,
  monthInputRef: null,
  yearInputRef: null
};

// src/components/date-input/date-input.container.js
import { useIntl as useIntl9 } from "react-intl";
var isNil2 = (val) => val === void 0 || val === null;
function isDate(value) {
  if (isNil2(value)) {
    return false;
  }
  if (isValid(parseISO(value))) {
    return true;
  }
  if (typeof value !== "string" && isValid(toDate(value))) {
    return true;
  }
  return false;
}
var isBlank = (str) => !str || /^\s*$/.test(str);
var getDay = (date) => isDate(date) ? String(new Date(date).getUTCDate()) : void 0;
var getMonth = (date) => isDate(date) ? String(new Date(date).getUTCMonth()) : void 0;
var getYear = (date) => isDate(date) ? String(new Date(date).getUTCFullYear()) : void 0;
var constrainDigits = (numDigits) => (val) => isNil2(val) ? val : val.replace(/\D/g, "").substring(0, numDigits);
var handleInput = (handler) => (e) => {
  const { target: { value } = {} } = e;
  handler(e, value);
};
var dateFromParts = (dateParts) => {
  const clean = (d) => isBlank(d) ? void 0 : d;
  const date = new Date(
    Date.UTC(
      clean(dateParts.year),
      clean(dateParts.month),
      clean(dateParts.day)
    )
  );
  return isValid(date) ? date : void 0;
};
var useDateInputHandlers = ({ onBlur: onBlurProp, onChange, value }) => {
  const { formatMessage } = useIntl9();
  const initialDay = getDay(value);
  const initialMonth = getMonth(value);
  const initialYear = getYear(value);
  const [day, setDay] = useState5(constrainDigits(2)(initialDay));
  const [month, setMonth] = useState5(initialMonth);
  const [year, setYear] = useState5(constrainDigits(4)(initialYear));
  const dayInputRef = useRef3(null);
  const monthInputRef = useRef3(null);
  const yearInputRef = useRef3(null);
  const hasAnyFocus = () => document.activeElement === dayInputRef.current || document.activeElement === monthInputRef.current || document.activeElement === yearInputRef.current;
  const validate = ({ day: dayValue, month: monthValue, year: yearValue }) => {
    const dayTooBig = parseInt(dayValue, 10) > 31;
    const dayNotInMonth = dayValue && getDaysInMonth(new Date(yearValue, monthValue)) < dayValue;
    if (dayTooBig || dayNotInMonth)
      return formatMessage({ id: "INVALID_DAY_ERROR_MESSAGE" });
    return void 0;
  };
  const handleChange = (fieldName, updateState, constrain = (v) => v) => (e, val) => {
    const constrainedValue = constrain(val);
    const dateParts = { day, month, year, [fieldName]: constrainedValue };
    const error = validate(dateParts);
    const date = dateFromParts(dateParts);
    updateState(constrainedValue);
    onChange(e, __spreadProps(__spreadValues({}, dateParts), { date, error }));
  };
  const onChangeMonth = handleInput(handleChange("month", setMonth));
  const onChangeDay = handleInput(
    handleChange("day", setDay, constrainDigits(2))
  );
  const onChangeYear = handleInput(
    handleChange("year", setYear, constrainDigits(4))
  );
  const onBlur = (event) => {
    if (hasAnyFocus())
      return;
    event == null ? void 0 : event.persist();
    const dateParts = { day, month, year };
    const error = validate(dateParts);
    const date = dateFromParts(dateParts);
    if (onBlurProp) {
      onBlurProp(event, __spreadProps(__spreadValues({}, dateParts), { date, error }));
    }
  };
  useEffect5(() => {
    if (hasAnyFocus())
      return;
    const newDay = getDay(value);
    const newMonth = getMonth(value);
    const newYear = getYear(value);
    if (!newDay || !newMonth || !newYear)
      return;
    if (newDay !== day || newMonth !== month || newYear !== year) {
      setMonth(getMonth(value));
      setDay(getDay(value));
      setYear(getYear(value));
    }
  }, [value]);
  return {
    day,
    month,
    year,
    onChangeMonth,
    onChangeDay,
    onChangeYear,
    onBlur,
    validate,
    handleChange,
    dayInputRef,
    monthInputRef,
    yearInputRef
  };
};
var DateInputContainer = (props) => {
  const { legacy } = props;
  const handlerProps = useDateInputHandlers(props);
  return legacy ? /* @__PURE__ */ React52.createElement(LegacyUIKitDateInputPresenter, __spreadValues(__spreadValues({}, props), handlerProps)) : /* @__PURE__ */ React52.createElement(DateInputPresenter, __spreadValues(__spreadValues({}, props), handlerProps));
};
DateInputContainer.propTypes = {
  legacy: PropTypes46.bool,
  value: PropTypes46.instanceOf(Date),
  name: PropTypes46.string.isRequired,
  onChange: PropTypes46.func.isRequired
};
DateInputContainer.defaultProps = {
  legacy: false,
  value: void 0
};

// src/components/money/money.view.js
import React53 from "react";
import PropTypes47 from "prop-types";
import { FormattedNumber } from "react-intl";
var Money = ({ value, currency, withCents }) => /* @__PURE__ */ React53.createElement(
  FormattedNumber,
  {
    value,
    currency,
    minimumFractionDigits: withCents ? 2 : 0,
    style: "currency",
    currencyDisplay: "symbol"
  }
);
Money.propTypes = {
  value: PropTypes47.number.isRequired,
  currency: PropTypes47.string.isRequired,
  withCents: PropTypes47.bool
};
Money.defaultProps = {
  withCents: false
};

// src/components/pill-tabs/pill-tabs.view.js
import React54 from "react";
import PropTypes48 from "prop-types";
import snakeCase from "lodash/snakeCase";
import {
  Flex as Flex9,
  css as css18,
  genesisStyled as genesisStyled11,
  PrimaryButton as PrimaryButton2,
  QuietButton
} from "@leagueplatform/genesis-commons";
var TOKEN_PILL_BACKGROUND_HOVER = "decorative.brand.primary.pastel";
var StyledQuietButton = genesisStyled11(QuietButton)(
  css18({
    "&:hover": {
      backgroundColor: TOKEN_PILL_BACKGROUND_HOVER,
      color: "onSurface.text.primary"
    }
  })
);
var Pill2 = ({ pill }) => {
  const { active, label, onClick } = pill;
  const pillStyles = {
    borderRadius: "pill",
    fontSize: "subtitle2",
    marginRight: "quarter",
    paddingX: "threeQuarters",
    paddingY: "quarter"
  };
  const pillProps = {
    children: label,
    onClick
  };
  return active ? /* @__PURE__ */ React54.createElement(PrimaryButton2, __spreadValues(__spreadValues({}, pillStyles), pillProps)) : /* @__PURE__ */ React54.createElement(StyledQuietButton, __spreadValues(__spreadValues({}, pillStyles), pillProps));
};
var PillProps = PropTypes48.shape({
  label: PropTypes48.string,
  onClick: PropTypes48.func,
  active: PropTypes48.bool
});
Pill2.propTypes = {
  pill: PillProps.isRequired
};
var PillTabs = ({ pills }) => {
  return /* @__PURE__ */ React54.createElement(
    Flex9,
    {
      backgroundColor: "surface.background.primary",
      borderColor: "highlight.background.subdued",
      borderRadius: "pill",
      borderWidth: "thin",
      boxShadow: "card",
      paddingLeft: "half",
      paddingRight: "quarter",
      paddingY: "half"
    },
    pills.map((pill) => /* @__PURE__ */ React54.createElement(Pill2, { pill, key: snakeCase(pill.label) }))
  );
};
PillTabs.propTypes = {
  pills: PropTypes48.arrayOf(PillProps)
};
PillTabs.defaultProps = {
  pills: []
};

// src/components/styled-component-ref-wrapper/styled-component-ref-wrapper.view.js
import React55 from "react";
var StyledComponentRefWrapper = (Component3) => {
  return (props) => /* @__PURE__ */ React55.createElement(Component3, __spreadValues({}, props));
};

// src/components/question-icon-light.view.js
import React56 from "react";
import PropTypes49 from "prop-types";
import QUESTION_TOOLTIP_ICON from "./assets/questionmark-in-circle.svg";
import { Box as Box10, Image as Image5 } from "@leagueplatform/genesis-commons";
var LightQuestionIcon = ({ altText }) => /* @__PURE__ */ React56.createElement(Box10, { as: "span", display: "block", width: "one", height: "one" }, /* @__PURE__ */ React56.createElement(Image5, { src: QUESTION_TOOLTIP_ICON, alt: altText, display: "block" }));
LightQuestionIcon.propTypes = {
  altText: PropTypes49.string
};
LightQuestionIcon.defaultProps = {
  altText: "Tooltip"
};

// src/components/single-progress-bar/single-progress-bar.view.js
import React57, { useState as useState6, useEffect as useEffect6 } from "react";
import PropTypes50 from "prop-types";
import uniqueId from "lodash/uniqueId";
import {
  BodyOneSecondary,
  BodyOne,
  Box as Box11,
  HeadingThree,
  Flex as Flex10,
  CoverImage,
  BodyTwoSecondary,
  css as css19,
  genesisStyled as genesisStyled12,
  VisuallyHidden as VisuallyHidden3
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl10 } from "react-intl";
import { withTheme as withTheme4 } from "styled-components";
import resumeStar from "./assets/resume-star.svg";
var Container4 = genesisStyled12((props) => /* @__PURE__ */ React57.createElement(Box11, __spreadValues({}, props)))(
  ({ active }) => css19({
    flexGrow: active ? 4.75 : 1,
    flexBasis: 0,
    transition: active && "flex-grow 1s ease",
    /* The tooltip generates a button with a width of its content which is
    0 for the below progress bar. The progress bar depends on its
    parent being 100% to function properly. */
    button: {
      width: "100%"
    }
  })
);
var ProgressBarContainer = (props) => /* @__PURE__ */ React57.createElement(
  Box11,
  __spreadValues({
    height: "half",
    backgroundColor: "interactive.action.disabled",
    cursor: "pointer",
    borderRadius: "large"
  }, props)
);
var ProgressBar = (props) => /* @__PURE__ */ React57.createElement(
  Box11,
  __spreadValues({
    height: "half",
    borderRadius: "large",
    transition: "width 2s ease"
  }, props)
);
var ProgressBarText = (props) => /* @__PURE__ */ React57.createElement(BodyOneSecondary, __spreadValues({ minHeight: "two", padding: "quarter" }, props));
var SingleProgressBar = withTheme4(
  ({
    name,
    color: color2,
    active,
    isResuming,
    totalSteps,
    completedSteps,
    description,
    toolTipRight,
    completionPoints,
    showContentTooltip,
    theme: theme2,
    isMobile
  }) => {
    const { formatMessage } = useIntl10();
    const progress = completedSteps / totalSteps * 100 || 0;
    const activeResume = active && isResuming;
    const [showResumeTooltip, setShowResumeTooltip] = useState6(activeResume);
    const [timedOut, setTimedOut] = useState6(false);
    useEffect6(() => {
      const timer = setTimeout(() => {
        setTimedOut(true);
      }, 3e3);
      return () => clearTimeout(timer);
    }, [setTimedOut]);
    const topicContent = /* @__PURE__ */ React57.createElement(Box11, null, /* @__PURE__ */ React57.createElement(HeadingThree, { marginBottom: "quarter" }, name), /* @__PURE__ */ React57.createElement(BodyOneSecondary, { marginTop: "one" }, description));
    const questionsAwayMessageId = completionPoints > 0 ? "YOURE_QUESTIONS_AWAY_WITHOUT_QUESTIONS_NUMBER" : "YOURE_QUESTIONS_AWAY_WITHOUT_QUESTIONS_NOR_POINTS";
    const resumeContent = /* @__PURE__ */ React57.createElement(Flex10, { flexDirection: "column", alignItems: "center" }, /* @__PURE__ */ React57.createElement(Flex10, { alignItems: "center", justifyContent: "center", marginBottom: "half" }, /* @__PURE__ */ React57.createElement(
      CoverImage,
      {
        src: resumeStar,
        alt: "resume-star",
        size: "42px",
        backgroundSize: "contain"
      }
    ), /* @__PURE__ */ React57.createElement(BodyOne, { fontWeight: "bold", marginLeft: "one" }, formatMessage({ id: "WEVE_PICKED_UP" }))), /* @__PURE__ */ React57.createElement(BodyTwoSecondary, null, formatMessage(
      { id: questionsAwayMessageId },
      { points: completionPoints }
    )));
    const progressDescribeById = uniqueId("single-progress-bar");
    return /* @__PURE__ */ React57.createElement(
      Container4,
      {
        marginX: "quarter",
        active,
        className: `league-progress-bar-${active ? "active" : "inactive"}`
      },
      !isMobile && /* @__PURE__ */ React57.createElement(ProgressBarText, null, active && name),
      /* @__PURE__ */ React57.createElement(
        Tooltip,
        {
          describedBy: progressDescribeById,
          onHover: () => setShowResumeTooltip(false)
        },
        /* @__PURE__ */ React57.createElement(ProgressBarContainer, { className: `league-progress-bar` }, /* @__PURE__ */ React57.createElement(VisuallyHidden3, null, name), /* @__PURE__ */ React57.createElement(ProgressBar, { backgroundColor: color2, width: `${progress}%` })),
        showContentTooltip && /* @__PURE__ */ React57.createElement(
          TooltipContent3,
          {
            describeId: progressDescribeById,
            positionShift: {
              x: 0,
              y: 30
            },
            top: true,
            right: !active && toolTipRight,
            arrowSize: 12,
            borderRadius: 4,
            borderColour: getColourObject(theme2).neutral.grayLight,
            padding: "20px"
          },
          topicContent
        )
      ),
      showResumeTooltip && // active resume takes care of if they change their selections, since isResuming -> false
      // if selections change
      // timedOut is a local state variable that handles if it times out.
      /* @__PURE__ */ React57.createElement(Tooltip, { isHovered: activeResume && !timedOut }, /* @__PURE__ */ React57.createElement(Box11, { height: 0 }), /* @__PURE__ */ React57.createElement(
        TooltipContent3,
        {
          positionShift: {
            x: 0,
            y: 30
          },
          top: true,
          right: !active && toolTipRight,
          arrowSize: 12,
          borderRadius: 4,
          borderColour: getColourObject(theme2).neutral.grayLight,
          padding: "20px"
        },
        resumeContent
      ))
    );
  }
);
SingleProgressBar.propTypes = {
  name: PropTypes50.string.isRequired,
  color: PropTypes50.string.isRequired,
  active: PropTypes50.bool,
  totalSteps: PropTypes50.number.isRequired,
  completedSteps: PropTypes50.number.isRequired,
  description: PropTypes50.string,
  toolTipRight: PropTypes50.bool,
  isResuming: PropTypes50.bool,
  completionPoints: PropTypes50.number,
  showContentTooltip: PropTypes50.bool,
  isMobile: PropTypes50.bool
};
SingleProgressBar.defaultProps = {
  active: false,
  description: "",
  toolTipRight: false,
  isResuming: false,
  completionPoints: 0,
  showContentTooltip: true,
  isMobile: false
};

// src/components/compound-progress-bar/compound-progress-bar.view.js
import React58 from "react";
import PropTypes51 from "prop-types";
import { Box as Box12, Flex as Flex11 } from "@leagueplatform/genesis-commons";
var ProgressBarContainer2 = (props) => /* @__PURE__ */ React58.createElement(
  Flex11,
  __spreadValues({
    height: "half",
    backgroundColor: "interactive.action.disabled",
    borderRadius: "large",
    overflowX: "hidden",
    width: "100%"
  }, props)
);
var lastSegmentStyles = {
  borderTopRightRadius: "large",
  borderBottomRightRadius: "large"
};
var ProgressBarSegment = (_a) => {
  var _b = _a, { percent, color: color2, isLast } = _b, props = __objRest(_b, ["percent", "color", "isLast"]);
  return /* @__PURE__ */ React58.createElement(
    Box12,
    __spreadValues(__spreadValues({
      width: `${percent}%`,
      transition: "width 2s ease",
      backgroundColor: color2
    }, isLast ? lastSegmentStyles : {}), props)
  );
};
ProgressBarSegment.propTypes = {
  color: PropTypes51.string,
  percent: PropTypes51.number.isRequired,
  isLast: PropTypes51.bool.isRequired
};
ProgressBarSegment.defaultProps = {
  color: "transparent"
};
var CompoundProgressBar = (_a) => {
  var _b = _a, { segments } = _b, props = __objRest(_b, ["segments"]);
  const shouldBeLastSegment = (segmentIndex) => {
    const nextSegments = segments.slice(segmentIndex + 1);
    return segmentIndex === segments.length - 1 || nextSegments.some(({ percent = void 0 }) => !percent);
  };
  return /* @__PURE__ */ React58.createElement(ProgressBarContainer2, __spreadValues({}, props), segments.map((segment, index) => /* @__PURE__ */ React58.createElement(ProgressBarSegment, __spreadProps(__spreadValues({}, segment), { isLast: shouldBeLastSegment(index) }))));
};
CompoundProgressBar.propTypes = {
  segments: PropTypes51.arrayOf(
    PropTypes51.shape({
      key: PropTypes51.string.isRequired,
      percent: PropTypes51.number.isRequired,
      color: PropTypes51.string
    })
  ).isRequired
};

// src/components/theme-provider.tsx
import "./assets/css/genesis_font.css";
import "./assets/css/style.css";
import React59 from "react";
import { ThemeProvider } from "styled-components";
import { useTheme as useTheme3 } from "@leagueplatform/genesis-commons";
import { get as get3 } from "lodash";
var themeKeysMap = {
  blue: "highlight.border.default",
  blueLightest: "highlight.background.subdued",
  functional: {
    blueLight: "highlight.background.subdued",
    green: "success.border.default"
  },
  "highlight.background.subdued": "highlight.background.subdued",
  "functional.green": "success.border.default",
  neutral: {
    grayLight: "onSurface.border.subdued",
    grayLighter: "interactive.background.disabled",
    grayDark: "onSurface.text.subdued"
  },
  "neutral.grayLight": "onSurface.border.subdued",
  "neutral.grayLighter": "interactive.background.disabled",
  "neutral.grayDark": "onSurface.text.subdued",
  offWhite: "surface.background.secondary",
  purple: "primary.background.default",
  purpleDarkest: "decorative.brand.primary.darkest",
  purpleLightest: "interactive.background.hovered",
  white: "surface.background.primary"
};
var UIKitThemeProvider = ({
  children
}) => {
  const { colors: genesisColorTheme } = useTheme3();
  const mapGenesisColorTokensToHexValues = (keysMap) => Object.entries(keysMap).reduce(
    (accumulator, [uiKitKey, genesisKey]) => {
      if (typeof genesisKey === "object") {
        accumulator[uiKitKey] = mapGenesisColorTokensToHexValues(genesisKey);
      } else {
        accumulator[uiKitKey] = get3(genesisColorTheme, genesisKey);
      }
      return accumulator;
    },
    {}
  );
  const newUIKitThemeColors = mapGenesisColorTokensToHexValues(themeKeysMap);
  const newUIKitTheme = __spreadProps(__spreadValues({}, theme), {
    colors: __spreadValues(__spreadValues({}, theme.colors), newUIKitThemeColors),
    colour: __spreadValues(__spreadValues({}, theme.colour), newUIKitThemeColors)
  });
  return /* @__PURE__ */ React59.createElement(ThemeProvider, { theme: newUIKitTheme }, children);
};
export {
  alert_view_default as Alert,
  animated_league_logo_view_default as AnimatedLeagueLogo,
  Backdrop,
  Badge2 as Badge,
  Box4 as Box,
  Callout,
  check_box_view_default as CheckBox,
  click_eater_view_default as ClickEater,
  CloseButton3 as CloseButton,
  Code,
  CompoundProgressBar,
  ConfirmationModal,
  CurrencyInputV2,
  DateInputContainer as DateInput,
  Desktop,
  Divider,
  DottedTooltipModal,
  error_message_default as ErrorMessage,
  Fill,
  Fit,
  Flex2 as Flex,
  FontAwesomeIcon7 as FontAwesomeIcon,
  form_stepper_view_default as FormStepper,
  heading_view_default as Heading,
  icon_constants_default as ICONS,
  icon_view_default as Icon,
  IconTooltipModal,
  Image,
  ImageCard,
  ImageViewer,
  InlineFlex,
  Input,
  Label,
  LapAndAbove,
  LightQuestionIcon,
  link_view_default as Link,
  LinkButton2 as LinkButton,
  message_view_default as Message,
  Modal,
  Money,
  MultiSelect,
  MultipleImageInput,
  Phone,
  Pill,
  PillTabs,
  QuestionIcon,
  Radio,
  RadioGroup,
  Responsive,
  scroll_loader_view_default as ScrollLoader,
  Select,
  SingleProgressBar,
  Spinner,
  state_message_view_default as StateMessage,
  status_circle_view_default as StatusCircle,
  StyledComponentRefWrapper,
  subtitle_view_default as Subtitle,
  Table,
  Tablet,
  TabletAndAbove,
  TestComponent,
  Text,
  Textarea,
  Toggle,
  Tooltip,
  TooltipContent2 as TooltipContent,
  TooltipContent3 as TooltipContentV2,
  TooltipHeader,
  TooltipModal,
  TooltipModalLabel,
  TooltipModalPresenter,
  UIKitThemeProvider,
  VisuallyHidden,
  bgImageContain,
  bgImageCover,
  breakpoints,
  colour,
  fadeIn,
  fadeOut,
  fixedWidthCentered,
  flex,
  flexAlign,
  flexBox,
  flexGrow,
  flexOrder,
  flexPack,
  flexShrink,
  flexWrap,
  fontSizeInPx,
  fontSizeLineHeight,
  fullScreen,
  genesisFocus,
  getColourObject,
  getStatusColor,
  getThemeValue,
  hex2Rgba,
  horizontalBox,
  leagueFont,
  makeOption,
  makeOptionWithLabel,
  mapOneOfValuesToOptions,
  mapValuesToOptions,
  media,
  multilineEllipsis,
  pulse,
  radiusInPx,
  scrollable,
  shake,
  slideDown,
  slideUp,
  smallFixedWidthCentered,
  spaceInPx,
  sumField,
  textEllipsis,
  theme,
  units,
  useModalA11yProps,
  vars,
  verticalBox,
  visuallyHidden
};
//# sourceMappingURL=index.js.map